// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
/* prettier-ignore */
// @ts-nocheck
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  MultipleValue: { input: any; output: any; }
  ScoreGaugeVariant: { input: any; output: any; }
  TextVariation: { input: any; output: any; }
};

export type AboutWhich = {
  __typename?: 'AboutWhich';
  moreArticles: Maybe<AboutWhichCardLinks>;
  promoUrls: Maybe<Array<Maybe<AboutWhichLink>>>;
  subVerticalArticles: Maybe<Array<Maybe<AboutWhichLink>>>;
};

export type AboutWhichCardLinks = {
  __typename?: 'AboutWhichCardLinks';
  cards: Maybe<Array<Maybe<AboutWhichMoreLink>>>;
  heading: Maybe<Scalars['String']['output']>;
};

export type AboutWhichLink = {
  __typename?: 'AboutWhichLink';
  description: Maybe<Scalars['String']['output']>;
  image: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type AboutWhichMoreLink = {
  __typename?: 'AboutWhichMoreLink';
  description: Maybe<Scalars['String']['output']>;
  image: Maybe<Scalars['String']['output']>;
  publishedAt: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type AddSavedItem = SavedItemError | SavedItemSuccess;

export type AdditionalData = {
  __typename?: 'AdditionalData';
  htmlSnippets: Maybe<Array<Maybe<HtmlSnippet>>>;
  images: Maybe<Array<Maybe<ImageWithSources>>>;
};

export type AdditionalGnData = {
  __typename?: 'AdditionalGNData';
  date: Maybe<Scalars['String']['output']>;
};

export type AdviceCard = {
  __typename?: 'AdviceCard';
  href: Maybe<Scalars['String']['output']>;
  linkText: Maybe<Scalars['String']['output']>;
  strapline: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type AdviceCards = {
  __typename?: 'AdviceCards';
  cards: Maybe<Array<Maybe<AdviceCard>>>;
  heading: Maybe<Scalars['String']['output']>;
};

export type AffiliateItem = {
  __typename?: 'AffiliateItem';
  isTrackable: Maybe<Scalars['Boolean']['output']>;
  price: Maybe<Scalars['String']['output']>;
  retailer: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type AnnualRunningCost = {
  __typename?: 'AnnualRunningCost';
  priceLabel: Maybe<Scalars['String']['output']>;
  ranking: Maybe<Scalars['Int']['output']>;
  rankingTotal: Maybe<Scalars['Int']['output']>;
  tooltip: Maybe<Tooltip>;
};

export type Article = {
  __typename?: 'Article';
  article_type: Maybe<ArticleType>;
  glide_id: Maybe<Scalars['String']['output']>;
  headline: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  path: Maybe<Scalars['String']['output']>;
  promo_image_url: Maybe<Scalars['String']['output']>;
  published_at: Maybe<Scalars['String']['output']>;
  short_headline: Maybe<Scalars['String']['output']>;
  short_standfirst: Maybe<Scalars['String']['output']>;
  standfirst: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  updated_at: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type ArticleCard = {
  __typename?: 'ArticleCard';
  heading: Maybe<Scalars['String']['output']>;
  image: Maybe<ImageWithSources>;
  links: Maybe<Array<Maybe<Link>>>;
  viewAll: Maybe<Link>;
};

export type ArticleCards = {
  __typename?: 'ArticleCards';
  cards: Maybe<Array<Maybe<ArticleCard>>>;
  heading: Maybe<Scalars['String']['output']>;
};

export type ArticleConfig = {
  __typename?: 'ArticleConfig';
  adviceType: Maybe<Scalars['String']['output']>;
  affiliateDisclaimer: Maybe<Scalars['Boolean']['output']>;
  articleArea: Maybe<Scalars['String']['output']>;
  articleType: Maybe<Scalars['String']['output']>;
  inlinePageScripts: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  syncWithAppleNews: Maybe<Scalars['Boolean']['output']>;
  whichConnectMessage: Maybe<Scalars['Boolean']['output']>;
};

export type ArticleHeader = {
  __typename?: 'ArticleHeader';
  addMarginOffsetClass: Maybe<Scalars['Boolean']['output']>;
  date: Maybe<DateInfo>;
  headline: Maybe<Scalars['String']['output']>;
  standfirst: Maybe<Scalars['String']['output']>;
};

export type ArticleJumpLinks = {
  __typename?: 'ArticleJumpLinks';
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type ArticleLink = {
  __typename?: 'ArticleLink';
  href: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ArticleListingFilteredPage = {
  __typename?: 'ArticleListingFilteredPage';
  breadcrumb: Maybe<Breadcrumb>;
  meta: Maybe<Meta>;
  newsAuthorArticles: Maybe<NewsAuthorArticles>;
  newsAuthorHeader: Maybe<NewsAuthorHeader>;
  newsTagArticles: Maybe<NewsTagArticles>;
  newsTagHeader: Maybe<ArticleListingHeader>;
  showResubBanner: Maybe<Scalars['Boolean']['output']>;
  taxonomyConversionBanner: Maybe<TaxonomyConversionBanner>;
};

export type ArticleListingHeader = {
  __typename?: 'ArticleListingHeader';
  description: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type ArticleListingPage = {
  __typename?: 'ArticleListingPage';
  articleListingOptionalData: Maybe<SubVerticalOptionalData>;
  breadcrumb: Maybe<Breadcrumb>;
  callout: Maybe<Callout>;
  consumerRightsArticles: Maybe<ConsumerRightsArticles>;
  consumerRightsFooter: Maybe<LocalFooter>;
  header: Maybe<ArticleListingHeader>;
  latestNews: Maybe<LatestNews>;
  meta: Maybe<Meta>;
  newsArticles: Maybe<NewsArticles>;
  recommendations: Maybe<Recommendations>;
  reviewsArticles: Maybe<ReviewsArticles>;
  showResubBanner: Maybe<Scalars['Boolean']['output']>;
  taxonomyConversionBanner: Maybe<TaxonomyConversionBanner>;
  taxonomyHierarchyWithCounts: Maybe<TaxonomyHierarchyWithCounts>;
};

export type ArticleListingWithImage = {
  __typename?: 'ArticleListingWithImage';
  articles: Maybe<Array<Maybe<Articles>>>;
  categoryLabel: Maybe<Scalars['String']['output']>;
  categorySlug: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type ArticleOnwardJourney = {
  __typename?: 'ArticleOnwardJourney';
  component: Maybe<Scalars['String']['output']>;
  props: Maybe<ToolSignpost>;
};

export type ArticleOptionalComponents = {
  __typename?: 'ArticleOptionalComponents';
  localFooter: Maybe<LocalFooter>;
  moneyPromoBlock: Maybe<PromoBlock>;
};

export type ArticlePage = {
  __typename?: 'ArticlePage';
  articleBodyTemplate: Maybe<Scalars['JSON']['output']>;
  articleConfig: Maybe<ArticleConfig>;
  articleExcelDataSheet: Maybe<Scalars['JSON']['output']>;
  articlePdf: Maybe<Scalars['JSON']['output']>;
  authors: Maybe<Array<Maybe<Author>>>;
  breadcrumb: Maybe<Breadcrumb>;
  callout: Maybe<Callout>;
  consumerRightsFooter: Maybe<LocalFooter>;
  estimatedReadingTime: Maybe<Scalars['String']['output']>;
  header: Maybe<ArticleHeader>;
  heroCTA: Maybe<HeroCta>;
  heroImage: Maybe<ImageWithSources>;
  heroVideo: Maybe<HeroVideo>;
  introParagraph: Maybe<Scalars['String']['output']>;
  jumpLinks: Maybe<Array<Maybe<ArticleJumpLinks>>>;
  latestNews: Maybe<LatestNews>;
  meta: Maybe<Meta>;
  moreOnArticles: Maybe<AssociatedArticles>;
  multiPageGuide: Maybe<AssociatedArticles>;
  onwardJourney: Maybe<ArticleOnwardJourney>;
  optionalArticleData: Maybe<OptionalArticleData>;
  podcastUrl: Maybe<Scalars['String']['output']>;
  promoBlock: Maybe<PromoBlock>;
  redirectUrl: Maybe<Scalars['String']['output']>;
  relatedArticles: Maybe<AssociatedArticles>;
  relatedProducts: Maybe<WcdRelatedProducts>;
  sharingData: Maybe<SharingData>;
  showResubBanner: Maybe<Scalars['Boolean']['output']>;
  tags: Maybe<Array<Maybe<Tag>>>;
  taxonomyConversionBanner: Maybe<TaxonomyConversionBanner>;
  videosSeoData: Maybe<Array<Maybe<VideoSeo>>>;
  wpPostId: Maybe<Scalars['String']['output']>;
};

export type ArticlePageOrRedirect = ArticlePage | Redirect;

export type ArticleType = {
  __typename?: 'ArticleType';
  id: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type ArticleTypePage = {
  __typename?: 'ArticleTypePage';
  breadcrumb: Maybe<Breadcrumb>;
  consumerRightsFooter: Maybe<LocalFooter>;
  meta: Maybe<Meta>;
  popularArticles: Maybe<PopularArticles>;
  taxonomyConversionBanner: Maybe<TaxonomyConversionBanner>;
  topArticles: Maybe<TopArticles>;
};

export type Articles = {
  __typename?: 'Articles';
  id: Maybe<Scalars['Int']['output']>;
  label: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  standfirst: Maybe<Scalars['String']['output']>;
};

export type ArticlesList = {
  __typename?: 'ArticlesList';
  articles: Array<Maybe<ArticleLink>>;
  image: Maybe<ImageWithSources>;
  title: Scalars['String']['output'];
};

export type AssociatedArticles = {
  __typename?: 'AssociatedArticles';
  links: Maybe<Array<Maybe<ImageLink>>>;
  title: Scalars['String']['output'];
};

export type AttributesCount = {
  __typename?: 'AttributesCount';
  bestBuyCount: Maybe<Scalars['Int']['output']>;
  dontBuyCount: Maybe<Scalars['Int']['output']>;
  firstLookCount: Maybe<Scalars['Int']['output']>;
  notTestedProductsCount: Maybe<Scalars['Int']['output']>;
  productsCount: Maybe<Scalars['Int']['output']>;
  testedProductsCount: Maybe<Scalars['Int']['output']>;
};

export type Authentication = {
  __typename?: 'Authentication';
  headers: Maybe<Scalars['JSON']['output']>;
  loginStatus: Maybe<Scalars['String']['output']>;
  response: Maybe<Scalars['JSON']['output']>;
  responseProfile: Maybe<Scalars['JSON']['output']>;
  responseSF: Maybe<Scalars['JSON']['output']>;
};

export type AuthenticationError = {
  __typename?: 'AuthenticationError';
  loginStatus: Maybe<Scalars['String']['output']>;
};

export type Author = {
  __typename?: 'Author';
  about: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  image: Maybe<ImageWithSources>;
  jobTitle: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
};

export type BannerSignUp = {
  __typename?: 'BannerSignUp';
  backgroundColour: Maybe<Scalars['String']['output']>;
  buttonType: Maybe<Scalars['String']['output']>;
  facebookUrl: Maybe<Scalars['String']['output']>;
  image: Maybe<ImageWithSources>;
  linkText: Maybe<Scalars['String']['output']>;
  linkUrl: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  twitterUrl: Maybe<Scalars['String']['output']>;
};

export type BaseArticleListingData = {
  __typename?: 'BaseArticleListingData';
  authors: Maybe<Array<Maybe<Author>>>;
  headline: Maybe<Scalars['String']['output']>;
  image: Maybe<ImageWithSources>;
  summary: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type BaseNewsArticleListingData = {
  __typename?: 'BaseNewsArticleListingData';
  headline: Maybe<Scalars['String']['output']>;
  image: Maybe<ImageWithSources>;
  primaryTaxonomy: Maybe<PrimaryTaxonomy>;
  summary: Maybe<Scalars['String']['output']>;
  updatedDate: Maybe<DateInfo>;
  url: Maybe<Scalars['String']['output']>;
};

export type BasicJumpLink = {
  __typename?: 'BasicJumpLink';
  id: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
};

export type Brand = {
  __typename?: 'Brand';
  heading: Maybe<Scalars['String']['output']>;
  items: Maybe<Array<Maybe<BrandItem>>>;
  relatedArticle: Maybe<RelatedArticle>;
};

export type BrandItem = {
  __typename?: 'BrandItem';
  link: Maybe<Scalars['String']['output']>;
  linkText: Maybe<Scalars['String']['output']>;
};

export type Breadcrumb = {
  __typename?: 'Breadcrumb';
  baseUrl: Maybe<Scalars['String']['output']>;
  currentPage: Maybe<Link>;
  heading: Maybe<Link>;
  links: Maybe<Array<Maybe<Link>>>;
};

export type CrCategories = {
  __typename?: 'CRCategories';
  jumpLinks: Maybe<JumpLinks>;
  sections: Maybe<Array<Maybe<CrCategory>>>;
};

export type CrCategorisedArticle = {
  __typename?: 'CRCategorisedArticle';
  href: Maybe<Scalars['String']['output']>;
  strapline: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type CrCategorisedArticles = {
  __typename?: 'CRCategorisedArticles';
  articles: Maybe<Array<Maybe<CrCategorisedArticle>>>;
  title: Maybe<Scalars['String']['output']>;
};

export type CrCategory = {
  __typename?: 'CRCategory';
  articleLinks: Maybe<Array<Maybe<Link>>>;
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  link: Maybe<Link>;
  title: Maybe<Scalars['String']['output']>;
};

export type Callout = {
  __typename?: 'Callout';
  byline: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  imageFormat: Maybe<ImageFormat>;
  items: Maybe<Array<Maybe<CalloutItem>>>;
  title: Maybe<Scalars['String']['output']>;
};

export type CalloutItem = {
  __typename?: 'CalloutItem';
  href: Maybe<Scalars['String']['output']>;
  image: Maybe<ImageWithSources>;
  strapline: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type CampaignsHomepageContent = {
  __typename?: 'CampaignsHomepageContent';
  contentItems: Maybe<Array<Maybe<CampaignsHomepageContentItem>>>;
};

export type CampaignsHomepageContentItem = {
  __typename?: 'CampaignsHomepageContentItem';
  data: Maybe<Scalars['JSON']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type CampaignsPetitionContent = {
  __typename?: 'CampaignsPetitionContent';
  contentItems: Maybe<Array<Maybe<CampaignsPetitionContentItem>>>;
  header: Maybe<Header>;
  petitionDetails: Maybe<PetitionDetails>;
};

export type CampaignsPetitionContentItem = {
  __typename?: 'CampaignsPetitionContentItem';
  data: Maybe<Scalars['JSON']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type CardItem = {
  __typename?: 'CardItem';
  href: Maybe<Scalars['String']['output']>;
  linkType: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
};

export type Categories = {
  __typename?: 'Categories';
  name: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
};

export type Category = {
  __typename?: 'Category';
  slug: Maybe<Scalars['String']['output']>;
};

export type CategoryData = {
  __typename?: 'CategoryData';
  renderAccordion: Maybe<Scalars['Boolean']['output']>;
};

export type CategoryType = {
  __typename?: 'CategoryType';
  image: Maybe<ImageWithSources>;
  link: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type CategoryTypes = {
  __typename?: 'CategoryTypes';
  cards: Maybe<Array<Maybe<CategoryType>>>;
  relatedArticleLink: Maybe<RelatedArticle>;
  title: Maybe<Scalars['String']['output']>;
};

export type CompareRow = {
  __typename?: 'CompareRow';
  helpText: Maybe<Scalars['String']['output']>;
  rowCode: Maybe<Scalars['String']['output']>;
  rowLabel: Maybe<Scalars['String']['output']>;
  rowValues: Maybe<Array<Maybe<Scalars['MultipleValue']['output']>>>;
};

export type ComparisonTable = {
  __typename?: 'ComparisonTable';
  productDetails: Maybe<Array<Maybe<ProductDetail>>>;
  tableData: Maybe<Array<Maybe<ComparisonTableData>>>;
  taxonomySlug: Maybe<Scalars['String']['output']>;
};

export type ComparisonTableData = {
  __typename?: 'ComparisonTableData';
  dataType: Maybe<Scalars['String']['output']>;
  groupHelpText: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
  rows: Maybe<Array<Maybe<CompareRow>>>;
};

export type ComponentsData = {
  __typename?: 'ComponentsData';
  bannerSignUpComponentData: Maybe<BannerSignUp>;
  newsletterSignUpWithImage: Maybe<NewsletterSignUpCollectionItem>;
  podcastComponentData: Maybe<PodcastComponentData>;
};

export type ConsumerRegulations = {
  __typename?: 'ConsumerRegulations';
  all: Maybe<Link>;
  items: Maybe<Array<Maybe<ConsumerRegulationsArticles>>>;
  title: Maybe<Scalars['String']['output']>;
};

export type ConsumerRegulationsArticles = {
  __typename?: 'ConsumerRegulationsArticles';
  authors: Maybe<Array<Maybe<Author>>>;
  href: Maybe<Scalars['String']['output']>;
  standfirst: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type ConsumerRightsArticles = {
  __typename?: 'ConsumerRightsArticles';
  featuredArticles: Maybe<Array<Maybe<BaseArticleListingData>>>;
  letterArticles: Maybe<CrCategorisedArticles>;
  nonFeaturedArticles: Maybe<Array<Maybe<BaseArticleListingData>>>;
  regulationArticles: Maybe<CrCategorisedArticles>;
};

export type ContactLink = {
  __typename?: 'ContactLink';
  href: Maybe<Scalars['String']['output']>;
  icon: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
};

export type ConvoArticlesWidget = {
  __typename?: 'ConvoArticlesWidget';
  conversationPageSlug: Maybe<Scalars['String']['output']>;
  footerText: Maybe<Scalars['String']['output']>;
  wordpressTagId: Maybe<Scalars['String']['output']>;
};

export type Creative = {
  __typename?: 'Creative';
  isQueryParam: Maybe<Scalars['Boolean']['output']>;
  val: Scalars['String']['output'];
};

export type CtaItems = {
  __typename?: 'CtaItems';
  href: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
};

export type CurrentStoryCollection = {
  __typename?: 'CurrentStoryCollection';
  articles: Maybe<Array<Maybe<LatestNewsArticle>>>;
  header: Maybe<Scalars['String']['output']>;
  image: Maybe<ImageWithSources>;
  navigationLink: Maybe<Link>;
  title: Maybe<Scalars['String']['output']>;
};

export type DateInfo = {
  __typename?: 'DateInfo';
  iso: Maybe<Scalars['String']['output']>;
  rendered: Maybe<Scalars['String']['output']>;
};

export type Dimensions = {
  __typename?: 'Dimensions';
  height: Maybe<Scalars['String']['output']>;
  width: Maybe<Scalars['String']['output']>;
};

export type EnergyPage = {
  __typename?: 'EnergyPage';
  authors: Maybe<Array<Maybe<PicksAuthor>>>;
  contentItems: Maybe<Array<Maybe<PicksContent>>>;
  header: Maybe<Header>;
  isLoggedIn: Maybe<Scalars['Boolean']['output']>;
  meta: Maybe<PageMeta>;
  relatedArticleLinks: Maybe<Array<Maybe<Link>>>;
};

export type ExpertReview = {
  __typename?: 'ExpertReview';
  heading: Maybe<Scalars['String']['output']>;
  sectionHeadings: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sections: Maybe<Array<Maybe<ExpertReviewSections>>>;
};

export type ExpertReviewSections = {
  __typename?: 'ExpertReviewSections';
  content: Maybe<Array<Maybe<ReviewSectionContent>>>;
  title: Maybe<Scalars['String']['output']>;
};

export type ExtendedArticles = {
  __typename?: 'ExtendedArticles';
  href: Scalars['String']['output'];
  strapline: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type FeaturedArticles = {
  __typename?: 'FeaturedArticles';
  date: Maybe<Scalars['String']['output']>;
  glideId: Maybe<Scalars['String']['output']>;
  href: Maybe<Scalars['String']['output']>;
  image: Maybe<Scalars['String']['output']>;
  multipageArticles: Maybe<Array<Maybe<MultipageArticle>>>;
  strapline: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type FeaturedContent = {
  __typename?: 'FeaturedContent';
  dateInfo: Maybe<DateInfo>;
  href: Maybe<Scalars['String']['output']>;
  imageWithSources: Maybe<ImageWithSources>;
  title: Maybe<Scalars['String']['output']>;
};

export type FeaturedLinks = {
  __typename?: 'FeaturedLinks';
  backgroundColour: Maybe<Scalars['String']['output']>;
  featuredArticles: Maybe<Array<Maybe<FeaturedContent>>>;
  identifier: Maybe<Scalars['String']['output']>;
  mainFeaturedArticle: Maybe<MainFeaturedArticle>;
  onwardLinkText: Maybe<Scalars['String']['output']>;
  onwardLinkUrl: Maybe<Scalars['String']['output']>;
  strapline: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type Features = {
  __typename?: 'Features';
  count: Maybe<Scalars['Int']['output']>;
  list: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type: Maybe<Scalars['String']['output']>;
};

export type Filter = {
  __typename?: 'Filter';
  attributeGroup: Maybe<Scalars['String']['output']>;
  caption: Maybe<Scalars['String']['output']>;
  componentType: Maybe<Scalars['String']['output']>;
  disabled: Maybe<Scalars['Boolean']['output']>;
  exclusion: Maybe<Scalars['Boolean']['output']>;
  externalId: Maybe<Scalars['String']['output']>;
  filterItems: Maybe<Array<Maybe<FilterItem>>>;
  filterLabel: Maybe<Scalars['String']['output']>;
  filterLabelTooltip: Maybe<FilterTooltip>;
  order: Maybe<Scalars['Int']['output']>;
  predicateType: Maybe<Scalars['String']['output']>;
};

export type FilterItem = {
  code: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
};

export type FilterItemOptions = {
  label: Maybe<Scalars['String']['output']>;
  optionCount: Maybe<Scalars['Int']['output']>;
};

export type FilterItemOptionsWithValueBoolean = FilterItemOptions & {
  __typename?: 'FilterItemOptionsWithValueBoolean';
  label: Maybe<Scalars['String']['output']>;
  optionCount: Maybe<Scalars['Int']['output']>;
  optionValueBool: Maybe<Scalars['Boolean']['output']>;
};

export type FilterItemOptionsWithValueString = FilterItemOptions & {
  __typename?: 'FilterItemOptionsWithValueString';
  label: Maybe<Scalars['String']['output']>;
  optionCount: Maybe<Scalars['Int']['output']>;
  optionValueStr: Maybe<Scalars['String']['output']>;
};

export type FilterItemWithOptions = FilterItem & {
  __typename?: 'FilterItemWithOptions';
  code: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
  options: Maybe<Array<Maybe<FilterItemOptions>>>;
  order: Maybe<Scalars['Int']['output']>;
  tooltip: Maybe<FilterTooltip>;
};

export type FilterItemWithToFrom = FilterItem & {
  __typename?: 'FilterItemWithToFrom';
  code: Maybe<Scalars['String']['output']>;
  count: Maybe<Scalars['Int']['output']>;
  from: Maybe<Scalars['Float']['output']>;
  label: Maybe<Scalars['String']['output']>;
  order: Maybe<Scalars['Int']['output']>;
  to: Maybe<Scalars['Float']['output']>;
  tooltip: Maybe<FilterTooltip>;
};

export type FilterItemWithValueBoolean = FilterItem & {
  __typename?: 'FilterItemWithValueBoolean';
  code: Maybe<Scalars['String']['output']>;
  count: Maybe<Scalars['Int']['output']>;
  label: Maybe<Scalars['String']['output']>;
  order: Maybe<Scalars['Int']['output']>;
  tooltip: Maybe<FilterTooltip>;
  valueBool: Maybe<Scalars['Boolean']['output']>;
};

export type FilterItemWithValueString = FilterItem & {
  __typename?: 'FilterItemWithValueString';
  code: Maybe<Scalars['String']['output']>;
  count: Maybe<Scalars['Int']['output']>;
  label: Maybe<Scalars['String']['output']>;
  order: Maybe<Scalars['Int']['output']>;
  tooltip: Maybe<FilterTooltip>;
  valueStr: Maybe<Scalars['String']['output']>;
};

export type FilterTooltip = {
  __typename?: 'FilterTooltip';
  description: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
};

export type ForgotPasswordError = {
  __typename?: 'ForgotPasswordError';
  isRedirectToKinde: Maybe<Scalars['Boolean']['output']>;
  status: Maybe<Scalars['String']['output']>;
};

export type ForgotPasswordSuccess = {
  __typename?: 'ForgotPasswordSuccess';
  isRedirectToKinde: Maybe<Scalars['Boolean']['output']>;
  status: Maybe<Scalars['String']['output']>;
};

export type FormRequest = {
  contactNumber: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  isMember: InputMaybe<Scalars['Boolean']['input']>;
  membershipNumber: InputMaybe<Scalars['String']['input']>;
  message: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type FreeAccountExclusive = {
  __typename?: 'FreeAccountExclusive';
  description: Maybe<Scalars['String']['output']>;
  image: Maybe<ImageWithSources>;
  title: Maybe<Scalars['String']['output']>;
};

export type GardeningFormRequest = {
  email: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  webformType: Scalars['String']['input'];
};

export type GlobalNavigation = {
  __typename?: 'GlobalNavigation';
  additionalData: Maybe<AdditionalGnData>;
  footer: Maybe<Array<Maybe<GlobalNavigationMenu>>>;
  navigation: Maybe<Array<Maybe<GlobalNavigationMenu>>>;
};

export type GlobalNavigationMenu = {
  __typename?: 'GlobalNavigationMenu';
  children: Maybe<Array<Maybe<GlobalNavigationMenu>>>;
  description: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type Header = {
  __typename?: 'Header';
  backgroundColour: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  image: Maybe<ImageWithSources>;
  intro: Maybe<Scalars['String']['output']>;
  links: Maybe<Array<Maybe<Link>>>;
  title: Maybe<Scalars['String']['output']>;
};

export type HelpAndAdvice = {
  __typename?: 'HelpAndAdvice';
  allArticles: Maybe<Array<Maybe<HelpAndAdviceArticle>>>;
  featuredArticle: Maybe<HelpAndAdviceFeaturedArticle>;
  subtitle: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  topArticles: Maybe<Array<Maybe<HelpAndAdviceArticle>>>;
};

export type HelpAndAdviceArticle = {
  __typename?: 'HelpAndAdviceArticle';
  date: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  image: Maybe<HelpAndAdviceImage>;
  path: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type HelpAndAdviceFeaturedArticle = {
  __typename?: 'HelpAndAdviceFeaturedArticle';
  date: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  image: Maybe<HelpAndAdviceImage>;
  path: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type HelpAndAdviceImage = {
  __typename?: 'HelpAndAdviceImage';
  alt: Maybe<Scalars['String']['output']>;
  sources: Maybe<Array<ImageSources>>;
  src: Maybe<Scalars['String']['output']>;
};

export type HeroCta = {
  __typename?: 'HeroCTA';
  button_text: Maybe<Scalars['String']['output']>;
  button_url: Maybe<Scalars['String']['output']>;
  caption_text: Maybe<Scalars['String']['output']>;
  component: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  image_alt_text: Maybe<Scalars['String']['output']>;
  link_anchor: Maybe<Scalars['String']['output']>;
  links_list_aria_label: Maybe<Scalars['String']['output']>;
  links_list_label: Maybe<Scalars['String']['output']>;
  secondary_tool_url: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  widget_image_aspect_ratio: Maybe<Scalars['String']['output']>;
};

export type HeroVideo = {
  __typename?: 'HeroVideo';
  brightcoveAccountId: Maybe<Scalars['String']['output']>;
  seo: Maybe<VideoSeo>;
  videoClient: Maybe<Scalars['String']['output']>;
  videoId: Maybe<Scalars['String']['output']>;
};

export type HomePage = {
  __typename?: 'HomePage';
  featuredLinks: Maybe<Array<Maybe<FeaturedLinks>>>;
  freeAccountExclusive: Maybe<FreeAccountExclusive>;
  imageUrl: Maybe<Scalars['String']['output']>;
  magazineLinks: Maybe<MagazineLinks>;
  meta: Maybe<Meta>;
  mostReadLinks: Maybe<MostReadLinks>;
  recommendations: Maybe<Recommendations>;
  showResubBanner: Maybe<Scalars['Boolean']['output']>;
  toolCTAs: Maybe<Array<Maybe<ToolSignpost>>>;
};

export type HowWeTest = {
  __typename?: 'HowWeTest';
  image: Maybe<ImageWithSources>;
  title: Maybe<Scalars['String']['output']>;
  updatedDate: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type HtmlSnippet = {
  __typename?: 'HtmlSnippet';
  body: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  resources: Maybe<Array<Maybe<HtmlSnippetResource>>>;
};

export type HtmlSnippetResource = {
  __typename?: 'HtmlSnippetResource';
  async: Maybe<Scalars['Boolean']['output']>;
  body: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  inline: Maybe<Scalars['Boolean']['output']>;
  resource_type: Maybe<ResourceTypes>;
  src: Maybe<Scalars['String']['output']>;
};

export type HubPageContent = {
  __typename?: 'HubPageContent';
  contentItems: Maybe<Array<Maybe<HubPageContentItem>>>;
  header: Maybe<Header>;
  latestNewsTag: Maybe<Tag>;
  mainFeaturedArticle: Maybe<NewsCard>;
};

export type HubPageContentItem = {
  __typename?: 'HubPageContentItem';
  data: Maybe<Scalars['JSON']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type ImageFormat =
  | 'rectangle'
  | 'square';

export type ImageLink = {
  __typename?: 'ImageLink';
  href: Maybe<Scalars['String']['output']>;
  img: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
};

export type ImageSources = {
  __typename?: 'ImageSources';
  media: Maybe<Scalars['String']['output']>;
  sizes: Maybe<Scalars['String']['output']>;
  srcset: Scalars['String']['output'];
  type: Maybe<Scalars['String']['output']>;
};

export type ImageWithSources = {
  __typename?: 'ImageWithSources';
  alt: Maybe<Scalars['String']['output']>;
  caption: Maybe<Scalars['String']['output']>;
  dimensions: Maybe<Dimensions>;
  id: Maybe<Scalars['String']['output']>;
  renditions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sources: Maybe<Array<ImageSources>>;
  src: Maybe<Scalars['String']['output']>;
};

export type Individual = {
  isEmailOptIn: Scalars['Boolean']['input'];
  isPostOptIn: Scalars['Boolean']['input'];
};

export type JumpLink = {
  __typename?: 'JumpLink';
  id: Maybe<Scalars['Int']['output']>;
  label: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
};

export type JumpLinks = {
  __typename?: 'JumpLinks';
  links: Maybe<Array<Maybe<JumpLink>>>;
};

export type KeyTestResults = {
  __typename?: 'KeyTestResults';
  isPadlocked: Maybe<Scalars['Boolean']['output']>;
  label: Maybe<Scalars['String']['output']>;
  tooltip: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type LatestNews = {
  __typename?: 'LatestNews';
  articles: Maybe<Array<Maybe<LatestNewsArticle>>>;
  name: Maybe<Scalars['String']['output']>;
};

export type LatestNewsArticle = {
  __typename?: 'LatestNewsArticle';
  authors: Maybe<Array<Maybe<Author>>>;
  dateInfo: Maybe<DateInfo>;
  href: Scalars['String']['output'];
  imageWithSources: Maybe<ImageWithSources>;
  tags: Array<Maybe<LatestNewsTag>>;
  title: Scalars['String']['output'];
};

export type LatestNewsFeed = {
  __typename?: 'LatestNewsFeed';
  articles: Maybe<Array<Maybe<LatestNewsArticle>>>;
  label: Maybe<Scalars['String']['output']>;
  total: Maybe<Scalars['Int']['output']>;
};

export type LatestNewsTag = {
  __typename?: 'LatestNewsTag';
  id: Scalars['Int']['output'];
  slug: Maybe<Scalars['String']['output']>;
};

export type Link = {
  __typename?: 'Link';
  href: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
};

export type LinkBlock = {
  __typename?: 'LinkBlock';
  children: Maybe<Scalars['String']['output']>;
  href: Maybe<Scalars['String']['output']>;
};

export type LinksButton = {
  __typename?: 'LinksButton';
  ariaLabel: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
};

export type LinksListExpandableData = {
  __typename?: 'LinksListExpandableData';
  button: Maybe<LinksButton>;
  items: Maybe<Array<Maybe<CtaItems>>>;
};

export type LiveReportHeader = {
  __typename?: 'LiveReportHeader';
  catchline: Maybe<Scalars['String']['output']>;
  coverageEndTime: Maybe<Scalars['String']['output']>;
  dateModifiedIso: Maybe<Scalars['String']['output']>;
  datePublishedIso: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  headline: Maybe<Scalars['String']['output']>;
  isLive: Maybe<Scalars['Boolean']['output']>;
  promoImageSrcList: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  summary: Maybe<Scalars['String']['output']>;
};

export type LiveReportPage = {
  __typename?: 'LiveReportPage';
  liveReportHeader: Maybe<LiveReportHeader>;
  liveReportPosts: Maybe<Array<Maybe<LiveReportPostData>>>;
  meta: Maybe<Meta>;
  sharingData: Maybe<SharingData>;
};

export type LiveReportPostData = {
  __typename?: 'LiveReportPostData';
  authors: Maybe<Scalars['String']['output']>;
  catchline: Maybe<Scalars['String']['output']>;
  headline: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  postBodyString: Maybe<Scalars['String']['output']>;
  postBodyTemplate: Maybe<Scalars['JSON']['output']>;
  publishedAtIso: Maybe<Scalars['String']['output']>;
  updatedAtIso: Maybe<Scalars['String']['output']>;
};

export type LocalFooter = {
  __typename?: 'LocalFooter';
  description: Maybe<Scalars['String']['output']>;
  items: Array<Maybe<LocalFooterItem>>;
  social: Array<Maybe<LocalFooterSocial>>;
  title: Scalars['String']['output'];
};

export type LocalFooterItem = {
  __typename?: 'LocalFooterItem';
  links: Array<Maybe<Link>>;
  title: Scalars['String']['output'];
};

export type LocalFooterSocial = {
  __typename?: 'LocalFooterSocial';
  href: Scalars['String']['output'];
  text: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type MagazineLink = {
  __typename?: 'MagazineLink';
  href: Maybe<Scalars['String']['output']>;
  image: Maybe<ImageWithSources>;
  strapline: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type MagazineLinks = {
  __typename?: 'MagazineLinks';
  links: Maybe<Array<Maybe<MagazineLink>>>;
  strapline: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type MainFeaturedArticle = {
  __typename?: 'MainFeaturedArticle';
  dateInfo: Maybe<DateInfo>;
  href: Maybe<Scalars['String']['output']>;
  image: Maybe<ImageWithSources>;
  isLive: Maybe<Scalars['Boolean']['output']>;
  standfirst: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type Manufacturer = {
  __typename?: 'Manufacturer';
  name: Maybe<Scalars['String']['output']>;
};

export type MappedSortedProducts = {
  __typename?: 'MappedSortedProducts';
  productsSortedByHighestScore: Maybe<Array<Maybe<ReviewsProduct>>>;
  productsSortedByMostRecentlyReviewed: Maybe<Array<Maybe<ReviewsProduct>>>;
};

export type MarketingHubCard = {
  __typename?: 'MarketingHubCard';
  smallPrint: Maybe<Scalars['String']['output']>;
  subTitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type MarketingHubCollection = {
  __typename?: 'MarketingHubCollection';
  cards: Array<Maybe<MarketingHubCard>>;
  jumplink: Maybe<BasicJumpLink>;
  title: Scalars['String']['output'];
};

export type MarketingHubContent = MarketingHubContentItem | MarketingHubWidget;

export type MarketingHubContentItem = {
  __typename?: 'MarketingHubContentItem';
  cards: Maybe<Array<Maybe<MarketingHubCard>>>;
  jumplink: Maybe<BasicJumpLink>;
  title: Maybe<Scalars['String']['output']>;
};

export type MarketingHubHeader = {
  __typename?: 'MarketingHubHeader';
  backgroundColour: Maybe<Scalars['String']['output']>;
  catchline: Scalars['String']['output'];
  description: Scalars['String']['output'];
  image: Maybe<MarketingHubHeaderImage>;
};

export type MarketingHubHeaderImage = {
  __typename?: 'MarketingHubHeaderImage';
  alt: Maybe<Scalars['String']['output']>;
  sources: Maybe<Array<Maybe<MarketingHubImageSource>>>;
  src: Maybe<Scalars['String']['output']>;
};

export type MarketingHubImageSource = {
  __typename?: 'MarketingHubImageSource';
  sizes: Maybe<Scalars['String']['output']>;
  srcset: Maybe<Scalars['String']['output']>;
};

export type MarketingHubPage = {
  __typename?: 'MarketingHubPage';
  contentItems: Maybe<Array<Maybe<MarketingHubContent>>>;
  footer: Maybe<Scalars['String']['output']>;
  header: Maybe<MarketingHubHeader>;
  meta: Maybe<PageMeta>;
};

export type MarketingHubWidget = {
  __typename?: 'MarketingHubWidget';
  component: Maybe<Scalars['String']['output']>;
  props: Maybe<Scalars['JSON']['output']>;
};

export type MemberBenefitContent = {
  __typename?: 'MemberBenefitContent';
  heading: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  subheader: Scalars['String']['output'];
};

export type MemberBenefitLink = MemberBenefitPageLink | MemberBenefitWidgetLink;

export type MemberBenefitOffer = {
  __typename?: 'MemberBenefitOffer';
  heading: Maybe<Scalars['String']['output']>;
  href: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
};

export type MemberBenefitPageLink = {
  __typename?: 'MemberBenefitPageLink';
  href: Maybe<Scalars['String']['output']>;
  image: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
};

export type MemberBenefitRenewalOffer = {
  __typename?: 'MemberBenefitRenewalOffer';
  body: Scalars['String']['output'];
  footerText: Scalars['String']['output'];
  heading: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type MemberBenefitWidgetLink = {
  __typename?: 'MemberBenefitWidgetLink';
  content: Array<MemberBenefitContent>;
  image: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
};

export type MemberBenefitsInfo = {
  __typename?: 'MemberBenefitsInfo';
  calloutText: Maybe<Scalars['String']['output']>;
  caption: Maybe<Scalars['String']['output']>;
  creative: Creative;
  isLoggedIn: Scalars['Boolean']['output'];
  links: Maybe<Array<MemberBenefitLink>>;
  offer: Maybe<MemberBenefitOffer>;
  offerPrice: Maybe<Scalars['String']['output']>;
  overline: Maybe<Scalars['String']['output']>;
  previousOfferPrice: Maybe<Scalars['String']['output']>;
  /** renewalOffer will be set when Percy identifies the user as likely to churn. */
  renewalOffer: Maybe<MemberBenefitRenewalOffer>;
};

export type Meta = {
  __typename?: 'Meta';
  canonical: Maybe<Scalars['String']['output']>;
  contentId: Maybe<Scalars['String']['output']>;
  dataLayer: Maybe<Scalars['JSON']['output']>;
  desc: Maybe<Scalars['String']['output']>;
  facebookDesc: Maybe<Scalars['String']['output']>;
  facebookImage: Maybe<Scalars['String']['output']>;
  facebookTitle: Maybe<Scalars['String']['output']>;
  fbAppId: Maybe<Scalars['String']['output']>;
  frequencyOfUpdate: Maybe<Scalars['String']['output']>;
  glideCurationDate: Maybe<Scalars['String']['output']>;
  headCodeBlock: Maybe<Scalars['String']['output']>;
  keywords: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pageType: Maybe<Scalars['String']['output']>;
  publishedDate: Maybe<Scalars['String']['output']>;
  publishedDateTime: Maybe<Scalars['Float']['output']>;
  reviewSchema: Maybe<Scalars['String']['output']>;
  significantUpdate: Maybe<Scalars['String']['output']>;
  systemContentPublishedDate: Maybe<Scalars['String']['output']>;
  systemContentUpdatedDate: Maybe<Scalars['String']['output']>;
  taxonomyHierarchy: Maybe<TaxonomyHierarchy>;
  title: Maybe<Scalars['String']['output']>;
  twitterDesc: Maybe<Scalars['String']['output']>;
  twitterImage: Maybe<Scalars['String']['output']>;
  twitterTitle: Maybe<Scalars['String']['output']>;
  updatedDateTime: Maybe<Scalars['Float']['output']>;
};

export type MostReadArticles = {
  __typename?: 'MostReadArticles';
  links: Maybe<Array<Maybe<Link>>>;
  title: Maybe<Scalars['String']['output']>;
};

export type MostReadLinks = {
  __typename?: 'MostReadLinks';
  links: Maybe<Array<Maybe<Link>>>;
  title: Maybe<Scalars['String']['output']>;
};

export type MultipageArticle = {
  __typename?: 'MultipageArticle';
  href: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['Int']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addSavedItem: Maybe<AddSavedItem>;
  createCaseInSF: Maybe<CreateCaseInSf>;
  createGardeningCaseInSF: Maybe<CreateGardeningCaseInSf>;
  createTechSupportCaseInSF: Maybe<CreateTechSupportCaseInSf>;
  forgotPassword: Maybe<UserForgotPassword>;
  login: Maybe<UserAuthentication>;
  register: Maybe<UserRegistration>;
  removeSavedItem: Maybe<RemoveSavedItem>;
  resetPassword: Maybe<UserResetPassword>;
  subscribeToNewsletters: Maybe<SubscribeToNewslettersResult>;
};


export type MutationAddSavedItemArgs = {
  item: SavedItemDetails;
};


export type MutationCreateCaseInSfArgs = {
  formRequest: FormRequest;
};


export type MutationCreateGardeningCaseInSfArgs = {
  formRequest: GardeningFormRequest;
};


export type MutationCreateTechSupportCaseInSfArgs = {
  formRequest: TechSupportFormRequest;
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationRegisterArgs = {
  registerRequest: RegisterRequest;
};


export type MutationRemoveSavedItemArgs = {
  itemId: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSubscribeToNewslettersArgs = {
  newsletterList: Array<Scalars['String']['input']>;
};

export type NeedsBasedAnswer = {
  __typename?: 'NeedsBasedAnswer';
  caption: Maybe<Scalars['String']['output']>;
  icon: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
  needsBasedAnswerOptions: Maybe<Array<Maybe<NeedsBasedAnswerOption>>>;
};

export type NeedsBasedAnswerOption = {
  __typename?: 'NeedsBasedAnswerOption';
  attributeGroup: Maybe<Scalars['String']['output']>;
  bucketLabel: Maybe<Scalars['String']['output']>;
  code: Maybe<Scalars['String']['output']>;
  componentType: Maybe<Scalars['String']['output']>;
  externalId: Maybe<Scalars['String']['output']>;
  from: Maybe<Scalars['Float']['output']>;
  label: Maybe<Scalars['String']['output']>;
  predicateType: Maybe<Scalars['String']['output']>;
  to: Maybe<Scalars['Float']['output']>;
  valueBool: Maybe<Scalars['Boolean']['output']>;
  valueStr: Maybe<Scalars['String']['output']>;
};

export type NeedsBasedFilter = {
  __typename?: 'NeedsBasedFilter';
  answers: Maybe<Array<Maybe<NeedsBasedAnswer>>>;
  disabled: Maybe<Scalars['Boolean']['output']>;
  externalId: Maybe<Scalars['String']['output']>;
  questionText: Maybe<Scalars['String']['output']>;
};

export type NewsArticles = {
  __typename?: 'NewsArticles';
  pagedArticles: Maybe<PagedFlatArticles>;
};

export type NewsAuthorArticles = {
  __typename?: 'NewsAuthorArticles';
  pagedArticles: Maybe<PagedFlatArticles>;
};

export type NewsAuthorHeader = {
  __typename?: 'NewsAuthorHeader';
  author: Maybe<Author>;
};

export type NewsCard = {
  __typename?: 'NewsCard';
  date: Maybe<DateInfo>;
  heading: Maybe<Scalars['String']['output']>;
  image: Maybe<ImageWithSources>;
  summary: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type NewsCardsCollectionItem = {
  __typename?: 'NewsCardsCollectionItem';
  cards: Maybe<Array<Maybe<NewsCard>>>;
  featuredArticle: Maybe<NewsCard>;
  taxonomy: Maybe<NewsCollectionTaxonomy>;
};

export type NewsCardsCollections = {
  __typename?: 'NewsCardsCollections';
  collections: Maybe<Array<Maybe<NewsCardsCollectionItem>>>;
  mainFeaturedArticle: Maybe<NewsCard>;
  mostReadArticles: Maybe<MostReadArticles>;
};

export type NewsCollectionTaxonomy = {
  __typename?: 'NewsCollectionTaxonomy';
  name: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
};

export type NewsTagArticles = {
  __typename?: 'NewsTagArticles';
  pagedArticles: Maybe<PagedFlatArticles>;
};

export type NewsletterSignUpCollectionItem = {
  __typename?: 'NewsletterSignUpCollectionItem';
  image: Maybe<ImageWithSources>;
  source: Maybe<Scalars['String']['output']>;
};

export type NewsletterSignUpWithImage = {
  __typename?: 'NewsletterSignUpWithImage';
  className: Maybe<Scalars['String']['output']>;
  image: Maybe<Scalars['String']['output']>;
  source: Maybe<Scalars['String']['output']>;
};

export type OptionalArticleData = {
  __typename?: 'OptionalArticleData';
  components: Maybe<ArticleOptionalComponents>;
};

export type OptionalComponents = {
  __typename?: 'OptionalComponents';
  bannerSignUpComponentData: Maybe<BannerSignUp>;
  localFooter: Maybe<LocalFooter>;
  relatedGuides: Maybe<RelatedGuides>;
  toolCTA: Maybe<ToolCta>;
};

export type OptionalData = {
  __typename?: 'OptionalData';
  components: Maybe<ComponentsData>;
};

export type PageMeta = {
  __typename?: 'PageMeta';
  canonical: Maybe<Scalars['String']['output']>;
  desc: Maybe<Scalars['String']['output']>;
  fbAppId: Maybe<Scalars['String']['output']>;
  publishedDateTime: Maybe<Scalars['Float']['output']>;
  socialData: Maybe<SocialData>;
  taxonomySlug: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  updatedDateTime: Maybe<Scalars['Float']['output']>;
};

export type PageTemplate = {
  __typename?: 'PageTemplate';
  additionalData: Maybe<AdditionalData>;
  json_tree: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  label: Maybe<Scalars['String']['output']>;
};

export type PagedFlatArticles = {
  __typename?: 'PagedFlatArticles';
  articles: Maybe<Array<Maybe<BaseNewsArticleListingData>>>;
  total: Maybe<Scalars['Int']['output']>;
};

export type PensionScheme = {
  __typename?: 'PensionScheme';
  moreArticles: Maybe<AboutWhichCardLinks>;
  promoUrls: Maybe<Array<Maybe<AboutWhichLink>>>;
  subVerticalArticles: Maybe<Array<Maybe<AboutWhichLink>>>;
};

export type PersonalisationInfo = {
  __typename?: 'PersonalisationInfo';
  enableWinbackOffer: Scalars['Boolean']['output'];
  hasApp: Scalars['Boolean']['output'];
  isChurning: Scalars['Boolean']['output'];
  newsletterRecommendation: Maybe<Scalars['String']['output']>;
  newsletterSignups: Maybe<Array<Scalars['String']['output']>>;
};

export type PetitionDetails = {
  __typename?: 'PetitionDetails';
  activeCampaign: Maybe<Scalars['Boolean']['output']>;
  formID: Maybe<Scalars['String']['output']>;
  manualAdjustment: Maybe<Scalars['String']['output']>;
  meta: Maybe<PetitionMeta>;
  pageID: Maybe<Scalars['Int']['output']>;
  targetCount: Maybe<Scalars['String']['output']>;
};

export type PetitionMeta = {
  __typename?: 'PetitionMeta';
  description: Maybe<Scalars['String']['output']>;
  image: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type PicksAnnualRunningCost = {
  __typename?: 'PicksAnnualRunningCost';
  formatted: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
};

export type PicksArticleCard = {
  __typename?: 'PicksArticleCard';
  description: Maybe<Scalars['String']['output']>;
  image: Maybe<ImageWithSources>;
  link: Maybe<Link>;
  title: Maybe<Scalars['String']['output']>;
};

export type PicksAuthor = {
  __typename?: 'PicksAuthor';
  about: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  image: Maybe<ImageWithSources>;
  jobTitle: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
};

export type PicksCardItem = PicksArticleCard | PicksProductCard;

export type PicksContent = PicksContentItem | PicksPromo;

export type PicksContentItem = {
  __typename?: 'PicksContentItem';
  inlineArticles: Maybe<Array<Maybe<Link>>>;
  intro: Maybe<Scalars['String']['output']>;
  items: Maybe<Array<Maybe<PicksCardItem>>>;
  jumpLinks: Maybe<PicksJumpLink>;
  productListingLink: Maybe<PicksProductListingLink>;
  title: Maybe<Scalars['String']['output']>;
};

export type PicksJumpLink = {
  __typename?: 'PicksJumpLink';
  id: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
};

export type PicksProductCard = {
  __typename?: 'PicksProductCard';
  affiliateItems: Maybe<Array<Maybe<AffiliateItem>>>;
  annualRunningCost: Maybe<PicksAnnualRunningCost>;
  articleLink: Maybe<Scalars['String']['output']>;
  articleLinkLabel: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  image: Maybe<ImageWithSources>;
  manufacturer: Maybe<Scalars['String']['output']>;
  model: Maybe<Scalars['String']['output']>;
  reviewUrl: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  typicalPrice: Maybe<Scalars['String']['output']>;
  usesPimData: Maybe<Scalars['Boolean']['output']>;
};

export type PicksProductListingLink = {
  __typename?: 'PicksProductListingLink';
  href: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
};

export type PicksPromo = {
  __typename?: 'PicksPromo';
  component: Maybe<Scalars['String']['output']>;
  props: Maybe<Scalars['JSON']['output']>;
};

export type PodcastCollection = {
  __typename?: 'PodcastCollection';
  header: Maybe<Scalars['String']['output']>;
  iframeContent: Maybe<Scalars['String']['output']>;
  info: Maybe<Scalars['String']['output']>;
  link: Maybe<Link>;
  title: Maybe<Scalars['String']['output']>;
};

export type PodcastComponentData = {
  __typename?: 'PodcastComponentData';
  header: Maybe<Scalars['String']['output']>;
  iframeContent: Maybe<Scalars['String']['output']>;
  info: Maybe<Scalars['String']['output']>;
  link: Maybe<Link>;
  title: Maybe<Scalars['String']['output']>;
};

export type PolicyAndInsightArticle = {
  __typename?: 'PolicyAndInsightArticle';
  articleExcelDataSheet: Maybe<Scalars['JSON']['output']>;
  articlePdf: Maybe<Scalars['JSON']['output']>;
  authors: Maybe<Array<Maybe<Author>>>;
  category: Maybe<Scalars['String']['output']>;
  date: Maybe<Scalars['String']['output']>;
  estimatedReadingTime: Maybe<Scalars['String']['output']>;
  href: Scalars['String']['output'];
  image: Maybe<Scalars['String']['output']>;
  imageAlt: Maybe<Scalars['String']['output']>;
  standFirst: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  topicHeading: Maybe<TopicHeading>;
  trendingTopics: Maybe<Scalars['String']['output']>;
};

export type PolicyAndInsightArticlesFeed = {
  __typename?: 'PolicyAndInsightArticlesFeed';
  articles: Maybe<Array<Maybe<PolicyAndInsightSearch>>>;
  label: Maybe<Scalars['String']['output']>;
  total: Maybe<Scalars['Int']['output']>;
};

export type PolicyAndInsightAuthor = {
  __typename?: 'PolicyAndInsightAuthor';
  about: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  image: Maybe<ImageWithSources>;
  jobTitle: Maybe<Scalars['String']['output']>;
  links: Maybe<Array<Maybe<ContactLink>>>;
  name: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
};

export type PolicyAndInsightAuthorPage = {
  __typename?: 'PolicyAndInsightAuthorPage';
  articles: Maybe<Array<Maybe<PolicyAndInsightArticle>>>;
  author: Maybe<PolicyAndInsightAuthor>;
  label: Maybe<Scalars['String']['output']>;
  sharingData: Maybe<SharingData>;
  total: Maybe<Scalars['Int']['output']>;
};

export type PolicyAndInsightCard = {
  __typename?: 'PolicyAndInsightCard';
  ariaLabel: Maybe<Scalars['String']['output']>;
  buttonText: Maybe<Scalars['String']['output']>;
  estimatedReadingTime: Maybe<Scalars['String']['output']>;
  heading: Maybe<Scalars['String']['output']>;
  image: Maybe<ImageWithSources>;
  linkUrl: Maybe<Scalars['String']['output']>;
  publishedAt: Maybe<Scalars['String']['output']>;
  standfirst: Maybe<Scalars['String']['output']>;
  summary: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  topicHeading: Maybe<TopicHeading>;
  url: Maybe<Scalars['String']['output']>;
};

export type PolicyAndInsightCardsCollectionItem = {
  __typename?: 'PolicyAndInsightCardsCollectionItem';
  cards: Maybe<Array<Maybe<PolicyAndInsightCard>>>;
  taxonomy: Maybe<PolicyAndInsightCollectionTaxonomy>;
};

export type PolicyAndInsightCardsCollections = {
  __typename?: 'PolicyAndInsightCardsCollections';
  collections: Maybe<Array<Maybe<PolicyAndInsightCardsCollectionItem>>>;
  hero: Maybe<PolicyAndInsightHero>;
};

export type PolicyAndInsightCategories = {
  __typename?: 'PolicyAndInsightCategories';
  categories: Maybe<Array<Maybe<Categories>>>;
};

export type PolicyAndInsightCollectionTaxonomy = {
  __typename?: 'PolicyAndInsightCollectionTaxonomy';
  name: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
};

export type PolicyAndInsightHero = {
  __typename?: 'PolicyAndInsightHero';
  cards: Maybe<Array<Maybe<PolicyAndInsightHeroCard>>>;
  taxonomy: Maybe<PolicyAndInsightCollectionTaxonomy>;
};

export type PolicyAndInsightHeroCard = {
  __typename?: 'PolicyAndInsightHeroCard';
  ariaLabel: Maybe<Scalars['String']['output']>;
  buttonText: Maybe<Scalars['String']['output']>;
  image: Maybe<ImageWithSources>;
  linkUrl: Maybe<Scalars['String']['output']>;
  standfirst: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type PolicyAndInsightLandingContent = {
  __typename?: 'PolicyAndInsightLandingContent';
  contentItems: Maybe<Array<Maybe<PolicyAndInsightLandingContentItem>>>;
  meta: Maybe<PolicyAndInsightLandingMeta>;
};

export type PolicyAndInsightLandingContentItem = {
  __typename?: 'PolicyAndInsightLandingContentItem';
  data: Maybe<Scalars['JSON']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type PolicyAndInsightLandingMeta = {
  __typename?: 'PolicyAndInsightLandingMeta';
  description: Maybe<Scalars['String']['output']>;
  image: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type PolicyAndInsightSearch = {
  __typename?: 'PolicyAndInsightSearch';
  authors: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  category: Maybe<Scalars['String']['output']>;
  date: Maybe<Scalars['String']['output']>;
  estimatedReadingTime: Maybe<Scalars['String']['output']>;
  href: Scalars['String']['output'];
  image: Maybe<Scalars['String']['output']>;
  imageAlt: Maybe<Scalars['String']['output']>;
  standFirst: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  topicHeading: Maybe<TopicHeading>;
  trendingTopics: Maybe<Scalars['String']['output']>;
};

export type PopularArticles = {
  __typename?: 'PopularArticles';
  articlesList: Array<Maybe<ArticlesList>>;
  title: Scalars['String']['output'];
};

export type Price = {
  __typename?: 'Price';
  formatted: Maybe<Scalars['String']['output']>;
};

export type PrimaryTaxonomy = {
  __typename?: 'PrimaryTaxonomy';
  name: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type Product = {
  __typename?: 'Product';
  badges: Maybe<Array<Scalars['String']['output']>>;
  businessKey: Maybe<Scalars['String']['output']>;
  category: Maybe<Category>;
  cons: Maybe<Array<Scalars['String']['output']>>;
  hasRetailers: Maybe<Scalars['Boolean']['output']>;
  imageUrl: Maybe<Scalars['String']['output']>;
  manufacturer: Maybe<Manufacturer>;
  model: Maybe<Scalars['String']['output']>;
  price: Maybe<Price>;
  productUrl: Maybe<Scalars['String']['output']>;
  pros: Maybe<Array<Scalars['String']['output']>>;
  slug: Maybe<Scalars['String']['output']>;
  testScore: Maybe<TestScore>;
};

export type ProductComparisonPage = {
  __typename?: 'ProductComparisonPage';
  breadcrumb: Maybe<Breadcrumb>;
  comparisonTable: Maybe<ComparisonTable>;
  meta: Maybe<Meta>;
};

export type ProductCount = {
  __typename?: 'ProductCount';
  description: Maybe<Scalars['String']['output']>;
  end: Maybe<Scalars['Int']['output']>;
  start: Maybe<Scalars['Int']['output']>;
  total: Maybe<Scalars['Int']['output']>;
};

export type ProductCounts = {
  __typename?: 'ProductCounts';
  bestBuysCount: Maybe<Scalars['Int']['output']>;
  dontBuysCount: Maybe<Scalars['Int']['output']>;
  totalItemCount: Maybe<Scalars['Int']['output']>;
};

export type ProductDates = {
  __typename?: 'ProductDates';
  date: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
};

export type ProductDetail = {
  __typename?: 'ProductDetail';
  alertType: Maybe<Scalars['String']['output']>;
  badges: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  businessKey: Maybe<Scalars['String']['output']>;
  cons: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  editorialReview: Maybe<ProductEditorialReview>;
  image: Maybe<ImageWithSources>;
  manufacturer: Maybe<ProductDetailManufacturer>;
  model: Maybe<Scalars['String']['output']>;
  offers: Maybe<Array<Maybe<ProductOffer>>>;
  price: Maybe<Scalars['String']['output']>;
  productScoreGauge: Maybe<ProductDetailScoreGauge>;
  pros: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  retailers: Maybe<Scalars['Boolean']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  testedType: Maybe<Scalars['String']['output']>;
};

export type ProductDetailManufacturer = {
  __typename?: 'ProductDetailManufacturer';
  name: Maybe<Scalars['String']['output']>;
};

export type ProductDetailScoreGauge = {
  __typename?: 'ProductDetailScoreGauge';
  label: Maybe<Scalars['String']['output']>;
  testScoreGauge: Maybe<ProductDetailTestScore>;
  tooltip: Maybe<Tooltip>;
  variant: Maybe<Scalars['ScoreGaugeVariant']['output']>;
};

export type ProductDetailTestScore = {
  __typename?: 'ProductDetailTestScore';
  overallScore: Maybe<Scalars['Int']['output']>;
  textVariation: Maybe<Scalars['TextVariation']['output']>;
};

export type ProductDetails = {
  __typename?: 'ProductDetails';
  alerts: Maybe<Array<Maybe<ProductDetailsAlert>>>;
  badges: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  businessKey: Maybe<Scalars['String']['output']>;
  categoryData: Maybe<CategoryData>;
  cons: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  curationDate: Maybe<Scalars['String']['output']>;
  editorialReview: Maybe<ProductEditorialReview>;
  expertReview: Maybe<ExpertReview>;
  firstLook: Maybe<Scalars['Boolean']['output']>;
  hasRetailers: Maybe<Scalars['Boolean']['output']>;
  images: Maybe<Array<Maybe<ProductImage>>>;
  isValidSecondHandProduct: Maybe<Scalars['Boolean']['output']>;
  keyTestResults: Maybe<Array<Maybe<KeyTestResults>>>;
  launchDate: Maybe<Scalars['String']['output']>;
  manufacturer: Maybe<Scalars['String']['output']>;
  model: Maybe<Scalars['String']['output']>;
  price: Maybe<Scalars['String']['output']>;
  priceValue: Maybe<Scalars['Int']['output']>;
  productScoreGauge: Maybe<ProductScoreGauge>;
  pros: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  scoreScale: Maybe<ScoreScale>;
  secondHandText: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  specifications: Maybe<Array<Maybe<SpecificationsSection>>>;
  suggestedAlternatives: Maybe<Array<Maybe<SuggestedAlternative>>>;
  supply: Maybe<ProductSupply>;
  tags: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  testResults: Maybe<ProductPageTestResults>;
  testedDate: Maybe<Scalars['String']['output']>;
  testedType: Maybe<Scalars['String']['output']>;
  timeline: Maybe<ProductTimeLine>;
  variantProductModel: Maybe<Scalars['String']['output']>;
  variantProducts: Maybe<Array<Maybe<VariantProducts>>>;
  variantValues: Maybe<Array<Maybe<VariantValue>>>;
};

export type ProductDetailsAlert = {
  __typename?: 'ProductDetailsAlert';
  description: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type ProductEditorialReview = {
  __typename?: 'ProductEditorialReview';
  content: Maybe<Scalars['String']['output']>;
  cta: Maybe<Scalars['String']['output']>;
  isPadlocked: Maybe<Scalars['Boolean']['output']>;
  teaser: Maybe<Scalars['String']['output']>;
  verdict: Maybe<Scalars['String']['output']>;
};

export type ProductHubPage = {
  __typename?: 'ProductHubPage';
  breadcrumb: Maybe<Breadcrumb>;
  categoryTypes: Maybe<CategoryTypes>;
  header: Maybe<Header>;
  helpAndAdvice: Maybe<HelpAndAdvice>;
  isLoggedIn: Maybe<Scalars['Boolean']['output']>;
  meta: Maybe<Meta>;
  productHubEnabled: Maybe<Scalars['Boolean']['output']>;
  productReviews: Maybe<ProductReviews>;
  showResubBanner: Maybe<Scalars['Boolean']['output']>;
  transformTypeDecision: Maybe<Scalars['String']['output']>;
};

export type ProductImage = {
  __typename?: 'ProductImage';
  alt: Maybe<Scalars['String']['output']>;
  height: Maybe<Scalars['Int']['output']>;
  sources: Maybe<ProductImageAllSources>;
  src: Maybe<Scalars['String']['output']>;
  thumbnailAlt: Maybe<Scalars['String']['output']>;
  width: Maybe<Scalars['Int']['output']>;
  zoomHeight: Maybe<Scalars['Int']['output']>;
  zoomSources: Maybe<ProductImageZoomSources>;
  zoomSrc: Maybe<Scalars['String']['output']>;
  zoomWidth: Maybe<Scalars['Int']['output']>;
};

export type ProductImageAllSources = {
  __typename?: 'ProductImageAllSources';
  main: Maybe<Array<Maybe<ProductImageSource>>>;
  thumb: Maybe<Array<Maybe<ProductImageSource>>>;
};

export type ProductImageSource = {
  __typename?: 'ProductImageSource';
  sizes: Maybe<Scalars['String']['output']>;
  srcset: Scalars['String']['output'];
  type: Maybe<Scalars['String']['output']>;
};

export type ProductImageZoomSources = {
  __typename?: 'ProductImageZoomSources';
  large: Maybe<Scalars['String']['output']>;
  medium: Maybe<Scalars['String']['output']>;
};

export type ProductListingHeader = {
  __typename?: 'ProductListingHeader';
  description: Maybe<Scalars['String']['output']>;
  heading: Maybe<Scalars['String']['output']>;
  image: Maybe<ImageWithSources>;
  labTested: Maybe<Scalars['Boolean']['output']>;
};

export type ProductListingPage = {
  __typename?: 'ProductListingPage';
  articleListingWithImage: Maybe<ArticleListingWithImage>;
  attributesCount: Maybe<AttributesCount>;
  breadcrumb: Maybe<Breadcrumb>;
  filters: Maybe<Array<Maybe<Filter>>>;
  header: Maybe<ProductListingHeader>;
  meta: Maybe<Meta>;
  needsBasedFilters: Maybe<Array<Maybe<NeedsBasedFilter>>>;
  optionalRedirect: Maybe<ProductListingRedirect>;
  productsWithPagination: Maybe<ProductsWithPagination>;
  scoreStatement: Maybe<ScoreStatement>;
  seoContentBlock: Maybe<Scalars['String']['output']>;
  showResubBanner: Maybe<Scalars['Boolean']['output']>;
  sortByMenu: Maybe<SortByMenu>;
  transformTypeDecision: Maybe<Scalars['String']['output']>;
};

export type ProductListingRedirect = {
  __typename?: 'ProductListingRedirect';
  isExternal: Maybe<Scalars['Boolean']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type ProductOffer = {
  __typename?: 'ProductOffer';
  availableInStock: Maybe<Scalars['Int']['output']>;
  formattedPrice: Maybe<Scalars['String']['output']>;
  isTrackable: Maybe<Scalars['Boolean']['output']>;
  priceValue: Maybe<Scalars['Int']['output']>;
  retailer: Maybe<Retailer>;
  url: Maybe<Scalars['String']['output']>;
};

export type ProductPage = {
  __typename?: 'ProductPage';
  breadcrumb: Maybe<Breadcrumb>;
  meta: Maybe<Meta>;
  productCounts: Maybe<ProductCounts>;
  productDetails: Maybe<ProductDetails>;
  relatedArticles: Maybe<ArticleListingWithImage>;
  reviewsSwitchingLink: Maybe<ReviewsSwitchingLink>;
  showResubBanner: Maybe<Scalars['Boolean']['output']>;
  transformTypeDecision: Maybe<Scalars['String']['output']>;
};

export type ProductPageTestResults = {
  __typename?: 'ProductPageTestResults';
  howWeTest: Maybe<HowWeTest>;
  results: Maybe<Array<Maybe<ProductTestResult>>>;
};

export type ProductReview = {
  __typename?: 'ProductReview';
  badges: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  businessKey: Maybe<Scalars['String']['output']>;
  image: Maybe<ProductReviewImage>;
  manufacturer: Maybe<Scalars['String']['output']>;
  model: Maybe<Scalars['String']['output']>;
  price: Maybe<Scalars['String']['output']>;
  productScoreGauge: Maybe<ProductScoreGauge>;
  retailers: Maybe<Scalars['Boolean']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  tags: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  variantPriceRange: Maybe<VariantPriceRange>;
  variantValues: Maybe<Array<Maybe<VariantValue>>>;
};

export type ProductReviewImage = {
  __typename?: 'ProductReviewImage';
  alt: Maybe<Scalars['String']['output']>;
  sources: Maybe<Array<ImageSources>>;
  src: Maybe<Scalars['String']['output']>;
};

export type ProductReviews = {
  __typename?: 'ProductReviews';
  brands: Maybe<Brand>;
  heading: Maybe<Scalars['String']['output']>;
  productCount: Maybe<ProductCount>;
  productData: Maybe<Array<Maybe<ProductReview>>>;
  productSlug: Maybe<Scalars['String']['output']>;
  subText: Maybe<Scalars['String']['output']>;
};

export type ProductScoreGauge = {
  __typename?: 'ProductScoreGauge';
  label: Maybe<Scalars['String']['output']>;
  testScoreGauge: Maybe<TestScore>;
  tooltip: Maybe<Tooltip>;
  variant: Maybe<Scalars['String']['output']>;
};

export type ProductSupply = {
  __typename?: 'ProductSupply';
  indicationPrice: Maybe<Scalars['Int']['output']>;
  offers: Maybe<Array<Maybe<ProductOffer>>>;
};

export type ProductTestResult = {
  __typename?: 'ProductTestResult';
  description: Maybe<Scalars['String']['output']>;
  heading: Maybe<Scalars['String']['output']>;
  overallScore: Maybe<Scalars['String']['output']>;
  scores: Maybe<Array<Maybe<ProductTestResultScore>>>;
  subHeading: Maybe<Scalars['String']['output']>;
};

export type ProductTestResultScore = {
  __typename?: 'ProductTestResultScore';
  label: Maybe<Scalars['String']['output']>;
  starRating: Maybe<Scalars['String']['output']>;
};

export type ProductTimeLine = {
  __typename?: 'ProductTimeLine';
  dates: Maybe<Array<Maybe<ProductDates>>>;
  helpText: Maybe<Scalars['String']['output']>;
};

export type ProductsWithPagination = {
  __typename?: 'ProductsWithPagination';
  mappedSortedProducts: Maybe<MappedSortedProducts>;
  numberOfPages: Maybe<Scalars['Int']['output']>;
  productCount: Maybe<ProductCount>;
  products: Array<Maybe<ReviewsProduct>>;
  taxonomySlug: Maybe<Scalars['String']['output']>;
  totalRunningCostCount: Maybe<Scalars['Int']['output']>;
};

export type PromoBlock = {
  __typename?: 'PromoBlock';
  ctaLabel: Maybe<Scalars['String']['output']>;
  ctaLink: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  articleListingFilteredPage: Maybe<ArticleListingFilteredPage>;
  articleListingPage: Maybe<ArticleListingPage>;
  articlePage: Maybe<ArticlePageOrRedirect>;
  articleTypePage: Maybe<ArticleTypePage>;
  authorArticles: Maybe<PolicyAndInsightAuthorPage>;
  energyPage: Maybe<EnergyPage>;
  globalNavigation: Maybe<GlobalNavigation>;
  homePage: Maybe<HomePage>;
  isMigratedMember: Maybe<IsMigratedMember>;
  kindeClientId: Maybe<Scalars['String']['output']>;
  kindeDomain: Maybe<Scalars['String']['output']>;
  latestNews: Maybe<LatestNewsFeed>;
  liveReportPage: Maybe<LiveReportPage>;
  marketingHubPage: Maybe<MarketingHubPage>;
  memberBenefitsInfo: Maybe<MemberBenefitsInfo>;
  pageTemplate: Maybe<PageTemplate>;
  paywallUrl: Maybe<Scalars['String']['output']>;
  personalisationInfo: Maybe<PersonalisationInfo>;
  policyAndInsightArticles: Maybe<PolicyAndInsightArticlesFeed>;
  productComparisonPage: Maybe<ProductComparisonPage>;
  productHubPage: Maybe<ProductHubPage>;
  productListingPage: Maybe<ProductListingPage>;
  productPage: Maybe<ProductPage>;
  savedItems: Maybe<Array<Maybe<SavedItem>>>;
  savedPage: Maybe<SavedPage>;
  signupCompletePage: Maybe<SignupCompletePage>;
  subVerticalPage: Maybe<SubVerticalPage>;
  taxonomyHierarchy: Maybe<Array<Maybe<Taxonomy>>>;
  toolsPage: Maybe<ToolPage>;
  userAccessState: Maybe<UserAccessState>;
  verticalPage: Maybe<VerticalPage>;
};


export type QueryArticleListingFilteredPageArgs = {
  context: Scalars['String']['input'];
  filterSlug: Scalars['String']['input'];
  filterValue: Scalars['String']['input'];
  pageNumber: InputMaybe<Scalars['Int']['input']>;
  verticalSlug: Scalars['String']['input'];
};


export type QueryArticleListingPageArgs = {
  categorySlug: Scalars['String']['input'];
  context: Scalars['String']['input'];
  pageNumber: InputMaybe<Scalars['Int']['input']>;
  subVerticalSlug: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};


export type QueryArticlePageArgs = {
  context: Scalars['String']['input'];
  url: Scalars['String']['input'];
};


export type QueryArticleTypePageArgs = {
  articleTypeSlug: Scalars['String']['input'];
  url: Scalars['String']['input'];
};


export type QueryAuthorArticlesArgs = {
  authorSlug: InputMaybe<Scalars['String']['input']>;
};


export type QueryEnergyPageArgs = {
  rootCollectionName: Scalars['String']['input'];
};


export type QueryIsMigratedMemberArgs = {
  email: Scalars['String']['input'];
};


export type QueryLatestNewsArgs = {
  pageNumber: InputMaybe<Scalars['Int']['input']>;
  pageSize: InputMaybe<Scalars['Int']['input']>;
  tagSlug: InputMaybe<Scalars['String']['input']>;
  taxonomySlug: InputMaybe<Scalars['String']['input']>;
};


export type QueryLiveReportPageArgs = {
  liveReportUrl: Scalars['String']['input'];
};


export type QueryPageTemplateArgs = {
  templateName: Scalars['String']['input'];
};


export type QueryProductComparisonPageArgs = {
  categorySlug: Scalars['String']['input'];
  context: Scalars['String']['input'];
  productsIds: Array<Scalars['String']['input']>;
};


export type QueryProductHubPageArgs = {
  productSlug: Scalars['String']['input'];
  subVerticalSlug: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductListingPageArgs = {
  basicFilterData: Scalars['JSON']['input'];
  categorySlug: Scalars['String']['input'];
  channel: InputMaybe<Scalars['String']['input']>;
  context: Scalars['String']['input'];
  needsBasedFilterData: Scalars['JSON']['input'];
  pageNumber: Scalars['String']['input'];
  selectedNeedsBasedFilters: Scalars['JSON']['input'];
  sortBy: Scalars['String']['input'];
};


export type QueryProductPageArgs = {
  categorySlug: Scalars['String']['input'];
  channel: InputMaybe<Scalars['String']['input']>;
  context: Scalars['String']['input'];
  productSlug: Scalars['String']['input'];
};


export type QuerySubVerticalPageArgs = {
  context: Scalars['String']['input'];
  pageNumber: InputMaybe<Scalars['Int']['input']>;
  subVerticalSlug: Scalars['String']['input'];
  verticalSlug: InputMaybe<Scalars['String']['input']>;
};


export type QueryVerticalPageArgs = {
  context: InputMaybe<Scalars['String']['input']>;
  pageNumber: InputMaybe<Scalars['Int']['input']>;
  verticalSlug: Scalars['String']['input'];
};

export type RecentlyViewed = {
  __typename?: 'RecentlyViewed';
  content: Maybe<Array<RecentlyViewedContent>>;
};

export type RecentlyViewedContent = Article | Product;

export type Recommendations = {
  __typename?: 'Recommendations';
  models: Maybe<Array<Maybe<RecommendedModel>>>;
};

export type RecommendedArticle = {
  __typename?: 'RecommendedArticle';
  href: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: Maybe<Scalars['String']['output']>;
  subheading: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type RecommendedContent = RecommendedArticle | RecommendedProduct;

export type RecommendedModel = {
  __typename?: 'RecommendedModel';
  content: Maybe<Array<RecommendedContent>>;
  groups: Maybe<Array<RecommendedModel>>;
  model: Scalars['String']['output'];
  title: Maybe<Scalars['String']['output']>;
};

export type RecommendedProduct = {
  __typename?: 'RecommendedProduct';
  href: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: Maybe<Scalars['String']['output']>;
  manufacturer: Maybe<Scalars['String']['output']>;
  model: Maybe<Scalars['String']['output']>;
  price: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  testScore: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
};

export type Redirect = {
  __typename?: 'Redirect';
  redirectUrl: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
};

export type RegisterRequest = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  individual: Individual;
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type Registration = {
  __typename?: 'Registration';
  headers: Maybe<Scalars['JSON']['output']>;
  masterId: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
};

export type RegistrationError = {
  __typename?: 'RegistrationError';
  status: Maybe<Scalars['String']['output']>;
};

export type RelatedArticle = {
  __typename?: 'RelatedArticle';
  link: Maybe<Scalars['String']['output']>;
  linkText: Maybe<Scalars['String']['output']>;
};

export type RelatedGuides = {
  __typename?: 'RelatedGuides';
  guides: Maybe<Array<Maybe<SuperCategorySectionCard>>>;
  title: Maybe<Scalars['String']['output']>;
};

export type RemoveSavedItem = SavedItemError | SavedItemSuccess;

export type ResetPasswordError = {
  __typename?: 'ResetPasswordError';
  ErrorResponse: Maybe<Scalars['JSON']['output']>;
  Status: Maybe<Scalars['String']['output']>;
};

export type ResetPasswordSuccess = {
  __typename?: 'ResetPasswordSuccess';
  Status: Maybe<Scalars['String']['output']>;
};

export type ResourceTypes =
  | 'SCRIPT'
  | 'STYLE';

export type Retailer = {
  __typename?: 'Retailer';
  hasScore: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  score: Maybe<Scalars['Int']['output']>;
};

export type ReviewSectionContent = {
  __typename?: 'ReviewSectionContent';
  appearance: Maybe<Scalars['String']['output']>;
  brightcoveAccountId: Maybe<Scalars['String']['output']>;
  imageAlt: Maybe<Scalars['String']['output']>;
  imageSrc: Maybe<Scalars['String']['output']>;
  listItems: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  paragraph: Maybe<Scalars['String']['output']>;
  techSpecs: Maybe<Array<Maybe<SpecificationsSection>>>;
  testResults: Maybe<Array<Maybe<ProductTestResult>>>;
  videoId: Maybe<Scalars['String']['output']>;
};

export type ReviewsArticles = {
  __typename?: 'ReviewsArticles';
  featuredArticles: Maybe<Array<Maybe<FeaturedArticles>>>;
  nonFeaturedArticles: Maybe<Array<Maybe<FeaturedArticles>>>;
};

export type ReviewsCategories = {
  __typename?: 'ReviewsCategories';
  jumpLinks: Maybe<JumpLinks>;
  sections: Maybe<Array<Maybe<SuperCategorySection>>>;
};

export type ReviewsProduct = {
  __typename?: 'ReviewsProduct';
  alertType: Maybe<Scalars['String']['output']>;
  annualRunningCost: Maybe<AnnualRunningCost>;
  badges: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  businessKey: Maybe<Scalars['String']['output']>;
  category: Maybe<Scalars['String']['output']>;
  features: Maybe<Array<Maybe<Features>>>;
  hasRetailers: Maybe<Scalars['Boolean']['output']>;
  image: Maybe<ImageWithSources>;
  isProductTest: Maybe<Scalars['Boolean']['output']>;
  manufacturer: Maybe<Scalars['String']['output']>;
  model: Maybe<Scalars['String']['output']>;
  overallScore: Maybe<Scalars['Int']['output']>;
  price: Maybe<Scalars['String']['output']>;
  productScoreGauge: Maybe<ProductScoreGauge>;
  retailers: Maybe<Scalars['Boolean']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  tags: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  variantPriceRange: Maybe<VariantPriceRange>;
  variantProducts: Maybe<Array<Maybe<VariantProducts>>>;
  variantValues: Maybe<Array<Maybe<VariantValue>>>;
};

export type ReviewsSwitchingLink = {
  __typename?: 'ReviewsSwitchingLink';
  href: Maybe<Scalars['String']['output']>;
  isExternal: Maybe<Scalars['Boolean']['output']>;
  label: Maybe<Scalars['String']['output']>;
};

export type SavedItem = {
  __typename?: 'SavedItem';
  category: Maybe<Scalars['String']['output']>;
  categorySlug: Maybe<Scalars['String']['output']>;
  products: Maybe<Array<Maybe<SavedProduct>>>;
};

export type SavedItemDetails = {
  itemCategory: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
  itemType: Scalars['String']['input'];
};

export type SavedItemError = {
  __typename?: 'SavedItemError';
  errorResponse: Maybe<Scalars['String']['output']>;
  success: Maybe<Scalars['Boolean']['output']>;
};

export type SavedItemSuccess = {
  __typename?: 'SavedItemSuccess';
  success: Maybe<Scalars['Boolean']['output']>;
};

export type SavedPage = {
  __typename?: 'SavedPage';
  isLoggedIn: Maybe<Scalars['Boolean']['output']>;
  items: Maybe<Array<Maybe<SavedItem>>>;
  meta: Maybe<SavedPageMeta>;
};

export type SavedPageMeta = {
  __typename?: 'SavedPageMeta';
  canonical: Maybe<Scalars['String']['output']>;
  dataLayer: Maybe<Scalars['JSON']['output']>;
  desc: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type SavedProduct = {
  __typename?: 'SavedProduct';
  alertType: Maybe<Scalars['String']['output']>;
  badges: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  businessKey: Maybe<Scalars['String']['output']>;
  hasBadgeZone: Maybe<Scalars['Boolean']['output']>;
  hasRetailers: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  image: Maybe<ImageWithSources>;
  manufacturer: Maybe<Scalars['String']['output']>;
  model: Maybe<Scalars['String']['output']>;
  price: Maybe<Scalars['String']['output']>;
  productScoreGauge: Maybe<ProductScoreGauge>;
  saveId: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  tags: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ScoreScale = {
  __typename?: 'ScoreScale';
  average: Maybe<ScoreScaleItemAverage>;
  heading: Maybe<Scalars['String']['output']>;
  highest: Maybe<ScoreScaleItem>;
  lowest: Maybe<ScoreScaleItem>;
  product: Maybe<ScoreScaleItemProduct>;
};

export type ScoreScaleItem = {
  __typename?: 'ScoreScaleItem';
  label: Maybe<Scalars['String']['output']>;
  score: Maybe<Scalars['Int']['output']>;
};

export type ScoreScaleItemAverage = {
  __typename?: 'ScoreScaleItemAverage';
  label: Maybe<Scalars['String']['output']>;
  relativeScorePercentage: Maybe<Scalars['Int']['output']>;
  score: Maybe<Scalars['Int']['output']>;
};

export type ScoreScaleItemProduct = {
  __typename?: 'ScoreScaleItemProduct';
  label: Maybe<Scalars['String']['output']>;
  obfuscated: Maybe<Scalars['Boolean']['output']>;
  relativeScorePercentage: Maybe<Scalars['Int']['output']>;
  score: Maybe<Scalars['Int']['output']>;
};

export type ScoreStatement = {
  __typename?: 'ScoreStatement';
  content: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type SeoData = {
  __typename?: 'SeoData';
  metaDescription: Maybe<Scalars['String']['output']>;
  pageTitle: Maybe<Scalars['String']['output']>;
};

export type SharingData = {
  __typename?: 'SharingData';
  facebook: Maybe<Scalars['String']['output']>;
  mail: Maybe<Scalars['String']['output']>;
  metaData: Maybe<SharingMetaData>;
  twitter: Maybe<Scalars['String']['output']>;
  whatsapp: Maybe<Scalars['String']['output']>;
};

export type SharingMetaData = {
  __typename?: 'SharingMetaData';
  facebookText: Maybe<Scalars['String']['output']>;
  fbAppId: Maybe<Scalars['String']['output']>;
  headline: Maybe<Scalars['String']['output']>;
  subject: Maybe<Scalars['String']['output']>;
  twitterText: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type SignupCompletePage = {
  __typename?: 'SignupCompletePage';
  recentlyViewed: Maybe<RecentlyViewed>;
};

export type SitemapMenu = {
  __typename?: 'SitemapMenu';
  items: Maybe<Array<Maybe<SitemapMenuItems>>>;
  name: Maybe<Scalars['String']['output']>;
};

export type SitemapMenuItems = {
  __typename?: 'SitemapMenuItems';
  children: Maybe<Array<Maybe<SitemapMenuItems>>>;
  label: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type SocialData = {
  __typename?: 'SocialData';
  og: Maybe<SocialDataOg>;
  twitter: Maybe<SocialDataTwitter>;
};

export type SocialDataOg = {
  __typename?: 'SocialDataOG';
  description: Maybe<Scalars['String']['output']>;
  image: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type SocialDataTwitter = {
  __typename?: 'SocialDataTwitter';
  description: Maybe<Scalars['String']['output']>;
  image: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type SortByMenu = {
  __typename?: 'SortByMenu';
  defaultOption: Maybe<Scalars['Int']['output']>;
  items: Maybe<Array<Maybe<SortByMenuItem>>>;
};

export type SortByMenuItem = {
  __typename?: 'SortByMenuItem';
  icon: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type SpecificationsRow = {
  __typename?: 'SpecificationsRow';
  helpText: Maybe<Scalars['String']['output']>;
  restricted: Maybe<Scalars['Boolean']['output']>;
  rowLabel: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['MultipleValue']['output']>;
};

export type SpecificationsSection = {
  __typename?: 'SpecificationsSection';
  rows: Maybe<Array<Maybe<SpecificationsRow>>>;
  sectionLabel: Maybe<Scalars['String']['output']>;
};

export type SubVerticalLinks = {
  __typename?: 'SubVerticalLinks';
  links: Maybe<Array<Maybe<LinkBlock>>>;
  name: Maybe<Scalars['String']['output']>;
};

export type SubVerticalOptionalData = {
  __typename?: 'SubVerticalOptionalData';
  components: Maybe<OptionalComponents>;
};

export type SubVerticalPage = {
  __typename?: 'SubVerticalPage';
  breadcrumb: Maybe<Breadcrumb>;
  callout: Maybe<Callout>;
  campaignsPetitionCollection: Maybe<CampaignsPetitionContent>;
  categoryLinks: Maybe<Array<Maybe<LinkBlock>>>;
  consumerRightsFooter: Maybe<LocalFooter>;
  crCategories: Maybe<CrCategories>;
  header: Maybe<Header>;
  hubPageContent: Maybe<HubPageContent>;
  hubPageLatestNews: Maybe<LatestNews>;
  latestNews: Maybe<LatestNews>;
  meta: Maybe<Meta>;
  newsArticles: Maybe<NewsArticles>;
  policyAndInsightLandingCollection: Maybe<PolicyAndInsightLandingContent>;
  relatedGuides: Maybe<RelatedGuides>;
  reviewsCategories: Maybe<ReviewsCategories>;
  sharingData: Maybe<SharingData>;
  showResubBanner: Maybe<Scalars['Boolean']['output']>;
  subVerticalOptionalData: Maybe<SubVerticalOptionalData>;
  taxonomyConversionBanner: Maybe<TaxonomyConversionBanner>;
  taxonomyHierarchyWithCounts: Maybe<TaxonomyHierarchyWithCounts>;
};

export type SubscribeToNewsletterResult = {
  __typename?: 'SubscribeToNewsletterResult';
  message: Maybe<Scalars['String']['output']>;
  newsletter: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SubscribeToNewslettersResult = {
  __typename?: 'SubscribeToNewslettersResult';
  subscriptionResults: Maybe<Array<SubscribeToNewsletterResult>>;
};

export type SuggestedAlternative = {
  __typename?: 'SuggestedAlternative';
  alertType: Maybe<Scalars['String']['output']>;
  badges: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  businessKey: Maybe<Scalars['String']['output']>;
  hasBadgeZone: Maybe<Scalars['Boolean']['output']>;
  hasRetailers: Maybe<Scalars['Boolean']['output']>;
  image: Maybe<ImageWithSources>;
  manufacturer: Maybe<Scalars['String']['output']>;
  model: Maybe<Scalars['String']['output']>;
  price: Maybe<Scalars['String']['output']>;
  productScoreGauge: Maybe<ProductScoreGauge>;
  slug: Maybe<Scalars['String']['output']>;
  suggestedAlternativeLabel: Maybe<Scalars['String']['output']>;
  tags: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SuperCategorySection = {
  __typename?: 'SuperCategorySection';
  cards: Maybe<Array<Maybe<SuperCategorySectionCard>>>;
  collectionName: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  sectionId: Maybe<Scalars['String']['output']>;
};

export type SuperCategorySectionCard = {
  __typename?: 'SuperCategorySectionCard';
  heading: Maybe<Scalars['String']['output']>;
  image: Maybe<ImageWithSources>;
  items: Maybe<Array<Maybe<CardItem>>>;
  link: Maybe<Link>;
  titleLink: Maybe<Scalars['String']['output']>;
};

export type Tag = {
  __typename?: 'Tag';
  label: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
};

export type Taxonomy = {
  __typename?: 'Taxonomy';
  akeneoCode: Maybe<Scalars['String']['output']>;
  children: Maybe<Array<Maybe<Taxonomy>>>;
  id: Scalars['Int']['output'];
  introText: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  parentId: Maybe<Scalars['Int']['output']>;
  position: Scalars['Int']['output'];
  seoData: SeoData;
  shortDescription: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
};

export type TaxonomyConversionBanner = {
  __typename?: 'TaxonomyConversionBanner';
  buttonText: Maybe<Scalars['String']['output']>;
  buttonURL: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  descriptionMobile: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type TaxonomyHierarchy = {
  __typename?: 'TaxonomyHierarchy';
  category: Maybe<Scalars['JSON']['output']>;
  subVertical: Maybe<Scalars['JSON']['output']>;
  superCategory: Maybe<Scalars['JSON']['output']>;
  vertical: Scalars['JSON']['output'];
};

export type TaxonomyHierarchyWithCounts = {
  __typename?: 'TaxonomyHierarchyWithCounts';
  categories: Maybe<Array<Maybe<TaxonomyWithCounts>>>;
  count: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
};

export type TaxonomyWithCounts = {
  __typename?: 'TaxonomyWithCounts';
  count: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
};

export type TechSupportFormRequest = {
  device: Scalars['String']['input'];
  email: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  operatingSystem: Scalars['String']['input'];
  problem: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  topic: Scalars['String']['input'];
  webformType: Scalars['String']['input'];
};

export type TestScore = {
  __typename?: 'TestScore';
  overallScore: Maybe<Scalars['Int']['output']>;
  textVariation: Maybe<Scalars['String']['output']>;
};

export type ToolCta = {
  __typename?: 'ToolCta';
  button: Maybe<Link>;
  description: Maybe<Scalars['String']['output']>;
  image: Maybe<ImageWithSources>;
  linksListExpandableData: Maybe<LinksListExpandableData>;
  title: Maybe<Scalars['String']['output']>;
  widgetImageAspectRatio: Maybe<WidgetImageAspectRatio>;
};

export type ToolPage = {
  __typename?: 'ToolPage';
  consumerRightsFooter: Maybe<LocalFooter>;
  transformTypeDecision: Maybe<Scalars['String']['output']>;
};

export type ToolSignpost = {
  __typename?: 'ToolSignpost';
  button: Maybe<Link>;
  description: Maybe<Scalars['String']['output']>;
  identifier: Maybe<Scalars['String']['output']>;
  image: Maybe<ImageWithSources>;
  title: Maybe<Scalars['String']['output']>;
};

export type Tooltip = {
  __typename?: 'Tooltip';
  ariaLabel: Maybe<Scalars['String']['output']>;
  contents: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type TopArticles = {
  __typename?: 'TopArticles';
  articles: Array<Maybe<ExtendedArticles>>;
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type TopicHeading = {
  __typename?: 'TopicHeading';
  category: Maybe<Scalars['String']['output']>;
  icon: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
};

export type UserAccessState = {
  __typename?: 'UserAccessState';
  transformTypeDecision: Maybe<Scalars['String']['output']>;
  userLoggedIn: Maybe<Scalars['Boolean']['output']>;
};

export type UserAuthentication = Authentication | AuthenticationError;

export type UserForgotPassword = ForgotPasswordError | ForgotPasswordSuccess;

export type UserRegistration = Registration | RegistrationError;

export type UserResetPassword = ResetPasswordError | ResetPasswordSuccess;

export type VariantPriceRange = {
  __typename?: 'VariantPriceRange';
  max: Maybe<Price>;
  min: Maybe<Price>;
};

export type VariantProducts = {
  __typename?: 'VariantProducts';
  badges: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  businessKey: Maybe<Scalars['String']['output']>;
  hasRetailers: Maybe<Scalars['Boolean']['output']>;
  image: Maybe<ImageWithSources>;
  model: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  tags: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  variantValues: Maybe<Array<Maybe<VariantValue>>>;
};

export type VariantValue = {
  __typename?: 'VariantValue';
  code: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type VerticalHeader = {
  __typename?: 'VerticalHeader';
  backgroundColour: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  image: Maybe<ImageWithSources>;
  links: Maybe<Array<Maybe<Link>>>;
  standfirst: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type VerticalPage = {
  __typename?: 'VerticalPage';
  aboutWhich: Maybe<AboutWhich>;
  adviceCards: Maybe<AdviceCards>;
  articleCards: Maybe<ArticleCards>;
  breadcrumb: Maybe<Breadcrumb>;
  callout: Maybe<Callout>;
  campaignsHomepageContent: Maybe<CampaignsHomepageContent>;
  consumerRegulations: Maybe<ConsumerRegulations>;
  consumerRightsFooter: Maybe<LocalFooter>;
  header: Maybe<VerticalHeader>;
  latestNews: Maybe<LatestNews>;
  meta: Maybe<Meta>;
  newsArticles: Maybe<NewsArticles>;
  newsCardsCollections: Maybe<NewsCardsCollections>;
  optionalData: Maybe<OptionalData>;
  pensionScheme: Maybe<PensionScheme>;
  policyAndInsightCardsCollections: Maybe<PolicyAndInsightCardsCollections>;
  policyAndInsightCategories: Maybe<PolicyAndInsightCategories>;
  showResubBanner: Maybe<Scalars['Boolean']['output']>;
  sitemapMenu: Maybe<SitemapMenu>;
  subVerticalLinks: Maybe<SubVerticalLinks>;
  taxonomyConversionBanner: Maybe<TaxonomyConversionBanner>;
};

export type VideoSeo = {
  __typename?: 'VideoSEO';
  contentUrl: Maybe<Scalars['String']['output']>;
  dateCreated: Maybe<Scalars['String']['output']>;
  dateModified: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  duration: Maybe<Scalars['String']['output']>;
  embedUrl: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  thumbnailUrl: Maybe<Scalars['String']['output']>;
  uploadDate: Maybe<Scalars['String']['output']>;
};

export type WcdImageSource = {
  __typename?: 'WCDImageSource';
  sizes: Maybe<Scalars['String']['output']>;
  srcset: Scalars['String']['output'];
  type: Maybe<Scalars['String']['output']>;
};

export type WcdPrice = {
  __typename?: 'WCDPrice';
  code: Maybe<Scalars['String']['output']>;
  formatted: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
  symbol: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['Float']['output']>;
};

export type WcdProduct = {
  __typename?: 'WCDProduct';
  badges: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  category: Maybe<Scalars['String']['output']>;
  hasRetailers: Maybe<Scalars['Boolean']['output']>;
  imageSources: Maybe<Array<Maybe<WcdImageSource>>>;
  imageSrc: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
  manufacturer: Maybe<Scalars['String']['output']>;
  model: Maybe<Scalars['String']['output']>;
  overallScore: Maybe<Scalars['Int']['output']>;
  price: Maybe<WcdPrice>;
  slug: Maybe<Scalars['String']['output']>;
  textVariation: Maybe<Scalars['String']['output']>;
  toolTip: WcdToolTip;
};

export type WcdRelatedProducts = {
  __typename?: 'WCDRelatedProducts';
  categoryLabel: Maybe<Scalars['String']['output']>;
  categoryLabelSingular: Maybe<Scalars['String']['output']>;
  categorySlug: Maybe<Scalars['String']['output']>;
  products: Maybe<Array<WcdProduct>>;
};

export type WcdToolTip = {
  __typename?: 'WCDToolTip';
  ariaLabel: Scalars['String']['output'];
  contents: Scalars['String']['output'];
};

export type WidgetImageAspectRatio =
  | 'ar_1to1_'
  | 'ar_2to1_';

export type CreateCaseInSf = {
  __typename?: 'createCaseInSF';
  status: Maybe<Scalars['String']['output']>;
};

export type CreateGardeningCaseInSf = {
  __typename?: 'createGardeningCaseInSF';
  caseId: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
};

export type CreateTechSupportCaseInSf = {
  __typename?: 'createTechSupportCaseInSF';
  caseId: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
};

export type IsMigratedMember = {
  __typename?: 'isMigratedMember';
  response: Maybe<Scalars['JSON']['output']>;
  status: Maybe<Scalars['String']['output']>;
};

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: { __typename: 'ForgotPasswordError', status: string, isRedirectToKinde: boolean } | { __typename: 'ForgotPasswordSuccess', status: string, isRedirectToKinde: boolean } };

export type LoginMutationVariables = Exact<{
  username: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename: 'Authentication', loginStatus: string, response: any, responseProfile: any, responseSF: any, headers: any } | { __typename: 'AuthenticationError', loginStatus: string } };

export type RegisterMutationVariables = Exact<{
  registerRequest: RegisterRequest;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register: { __typename: 'Registration', status: string, headers: any, masterId: string } | { __typename: 'RegistrationError', status: string } };

export type ArticleListingCrPageQueryVariables = Exact<{
  subVerticalSlug: Scalars['String']['input'];
  categorySlug: Scalars['String']['input'];
  context: Scalars['String']['input'];
  url: Scalars['String']['input'];
}>;


export type ArticleListingCrPageQuery = { __typename?: 'Query', articleListingPage: { __typename: 'ArticleListingPage', showResubBanner: boolean, meta: { __typename?: 'Meta', title: string, desc: string, dataLayer: any, pageType: string, canonical: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any, subVertical: any, category: any, superCategory: any } }, breadcrumb: { __typename?: 'Breadcrumb', baseUrl: string, heading: { __typename?: 'Link', href: string, text: string }, links: Array<{ __typename?: 'Link', href: string, text: string }>, currentPage: { __typename?: 'Link', href: string, text: string } }, taxonomyConversionBanner: { __typename?: 'TaxonomyConversionBanner', title: string, description: string, descriptionMobile: string, buttonText: string, buttonURL: string }, consumerRightsArticles: { __typename?: 'ConsumerRightsArticles', featuredArticles: Array<{ __typename?: 'BaseArticleListingData', headline: string, summary: string, url: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> }, authors: Array<{ __typename?: 'Author', name: string, jobTitle: string, image: { __typename?: 'ImageWithSources', src: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> } }> }>, nonFeaturedArticles: Array<{ __typename?: 'BaseArticleListingData', headline: string, summary: string, url: string, authors: Array<{ __typename?: 'Author', name: string, jobTitle: string, image: { __typename?: 'ImageWithSources', src: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> } }> }>, letterArticles: { __typename?: 'CRCategorisedArticles', title: string, articles: Array<{ __typename?: 'CRCategorisedArticle', title: string, href: string, strapline: string }> }, regulationArticles: { __typename?: 'CRCategorisedArticles', title: string, articles: Array<{ __typename?: 'CRCategorisedArticle', title: string, href: string, strapline: string }> } }, consumerRightsFooter: { __typename?: 'LocalFooter', title: string, description: string, items: Array<{ __typename?: 'LocalFooterItem', title: string, links: Array<{ __typename?: 'Link', href: string, text: string }> }>, social: Array<{ __typename?: 'LocalFooterSocial', text: string, href: string, type: string }> }, callout: { __typename?: 'Callout', byline: string, description: string, imageFormat: ImageFormat, title: string, items: Array<{ __typename?: 'CalloutItem', strapline: string, title: string, href: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> } }> }, header: { __typename?: 'ArticleListingHeader', name: string, description: string } } };

export type ArticleListingAuthorPageQueryVariables = Exact<{
  verticalSlug: Scalars['String']['input'];
  filterSlug: Scalars['String']['input'];
  filterValue: Scalars['String']['input'];
  context: Scalars['String']['input'];
  pageNumber: InputMaybe<Scalars['Int']['input']>;
}>;


export type ArticleListingAuthorPageQuery = { __typename?: 'Query', articleListingPage: { __typename: 'ArticleListingFilteredPage', showResubBanner: boolean, meta: { __typename?: 'Meta', title: string, desc: string, dataLayer: any, pageType: string, canonical: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any, subVertical: any, category: any, superCategory: any } }, breadcrumb: { __typename?: 'Breadcrumb', baseUrl: string, heading: { __typename?: 'Link', href: string, text: string }, links: Array<{ __typename?: 'Link', href: string, text: string }>, currentPage: { __typename?: 'Link', href: string, text: string } }, newsAuthorHeader: { __typename?: 'NewsAuthorHeader', author: { __typename?: 'Author', name: string, jobTitle: string, image: { __typename?: 'ImageWithSources', src: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> } } }, newsAuthorArticles: { __typename?: 'NewsAuthorArticles', pagedArticles: { __typename?: 'PagedFlatArticles', total: number, articles: Array<{ __typename?: 'BaseNewsArticleListingData', headline: string, summary: string, url: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> }, primaryTaxonomy: { __typename?: 'PrimaryTaxonomy', name: string, url: string }, updatedDate: { __typename?: 'DateInfo', rendered: string, iso: string } }> } } } };

export type ArticleListingNewsPageQueryVariables = Exact<{
  subVerticalSlug: Scalars['String']['input'];
  categorySlug: Scalars['String']['input'];
  context: Scalars['String']['input'];
  url: Scalars['String']['input'];
  pageNumber: InputMaybe<Scalars['Int']['input']>;
}>;


export type ArticleListingNewsPageQuery = { __typename?: 'Query', articleListingPage: { __typename: 'ArticleListingPage', showResubBanner: boolean, meta: { __typename?: 'Meta', title: string, desc: string, dataLayer: any, pageType: string, canonical: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any, subVertical: any, category: any, superCategory: any } }, breadcrumb: { __typename?: 'Breadcrumb', baseUrl: string, heading: { __typename?: 'Link', href: string, text: string }, links: Array<{ __typename?: 'Link', href: string, text: string }>, currentPage: { __typename?: 'Link', href: string, text: string } }, taxonomyConversionBanner: { __typename?: 'TaxonomyConversionBanner', title: string, description: string, descriptionMobile: string, buttonText: string, buttonURL: string }, header: { __typename?: 'ArticleListingHeader', name: string, description: string }, taxonomyHierarchyWithCounts: { __typename?: 'TaxonomyHierarchyWithCounts', slug: string, name: string, count: number, categories: Array<{ __typename?: 'TaxonomyWithCounts', slug: string, name: string, count: number }> }, newsArticles: { __typename?: 'NewsArticles', pagedArticles: { __typename?: 'PagedFlatArticles', total: number, articles: Array<{ __typename?: 'BaseNewsArticleListingData', headline: string, summary: string, url: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> }, primaryTaxonomy: { __typename?: 'PrimaryTaxonomy', name: string, url: string }, updatedDate: { __typename?: 'DateInfo', rendered: string, iso: string } }> } } } };

export type ArticleListingTagPageQueryVariables = Exact<{
  verticalSlug: Scalars['String']['input'];
  filterSlug: Scalars['String']['input'];
  filterValue: Scalars['String']['input'];
  context: Scalars['String']['input'];
  pageNumber: InputMaybe<Scalars['Int']['input']>;
}>;


export type ArticleListingTagPageQuery = { __typename?: 'Query', articleListingPage: { __typename: 'ArticleListingFilteredPage', showResubBanner: boolean, meta: { __typename?: 'Meta', title: string, desc: string, dataLayer: any, pageType: string, canonical: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any, subVertical: any, category: any, superCategory: any } }, breadcrumb: { __typename?: 'Breadcrumb', baseUrl: string, heading: { __typename?: 'Link', href: string, text: string }, links: Array<{ __typename?: 'Link', href: string, text: string }>, currentPage: { __typename?: 'Link', href: string, text: string } }, newsTagHeader: { __typename?: 'ArticleListingHeader', name: string, description: string }, newsTagArticles: { __typename?: 'NewsTagArticles', pagedArticles: { __typename?: 'PagedFlatArticles', total: number, articles: Array<{ __typename?: 'BaseNewsArticleListingData', headline: string, summary: string, url: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> }, primaryTaxonomy: { __typename?: 'PrimaryTaxonomy', name: string, url: string }, updatedDate: { __typename?: 'DateInfo', rendered: string, iso: string } }> } } } };

export type ArticleListingReviewsPageQueryVariables = Exact<{
  subVerticalSlug: InputMaybe<Scalars['String']['input']>;
  categorySlug: Scalars['String']['input'];
  context: Scalars['String']['input'];
  url: Scalars['String']['input'];
}>;


export type ArticleListingReviewsPageQuery = { __typename?: 'Query', articleListingPage: { __typename: 'ArticleListingPage', showResubBanner: boolean, meta: { __typename?: 'Meta', title: string, desc: string, dataLayer: any, pageType: string, canonical: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any, subVertical: any, category: any, superCategory: any } }, breadcrumb: { __typename?: 'Breadcrumb', baseUrl: string, heading: { __typename?: 'Link', href: string, text: string }, links: Array<{ __typename?: 'Link', href: string, text: string }>, currentPage: { __typename?: 'Link', href: string, text: string } }, taxonomyConversionBanner: { __typename?: 'TaxonomyConversionBanner', title: string, description: string, descriptionMobile: string, buttonText: string, buttonURL: string }, reviewsArticles: { __typename?: 'ReviewsArticles', featuredArticles: Array<{ __typename?: 'FeaturedArticles', date: string, title: string, image: string, strapline: string, href: string, glideId: string, multipageArticles: Array<{ __typename?: 'MultipageArticle', label: string, href: string }> }>, nonFeaturedArticles: Array<{ __typename?: 'FeaturedArticles', date: string, title: string, image: string, strapline: string, href: string, glideId: string, multipageArticles: Array<{ __typename?: 'MultipageArticle', label: string, href: string }> }> }, header: { __typename?: 'ArticleListingHeader', name: string, description: string }, latestNews: { __typename?: 'LatestNews', name: string, articles: Array<{ __typename?: 'LatestNewsArticle', title: string, href: string, dateInfo: { __typename?: 'DateInfo', rendered: string, iso: string }, imageWithSources: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, media: string, sizes: string }> } }> }, articleListingOptionalData: { __typename?: 'SubVerticalOptionalData', components: { __typename?: 'OptionalComponents', bannerSignUpComponentData: { __typename?: 'BannerSignUp', title: string, text: string, linkText: string, linkUrl: string, backgroundColour: string, facebookUrl: string, twitterUrl: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, media: string, type: string, sizes: string }> } }, toolCTA: { __typename?: 'ToolCta', title: string, description: string, widgetImageAspectRatio: WidgetImageAspectRatio, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, media: string, type: string, sizes: string }> }, button: { __typename?: 'Link', href: string, text: string }, linksListExpandableData: { __typename?: 'LinksListExpandableData', button: { __typename?: 'LinksButton', text: string, ariaLabel: string }, items: Array<{ __typename?: 'CtaItems', href: string, label: string }> } }, localFooter: { __typename?: 'LocalFooter', description: string, items: Array<{ __typename?: 'LocalFooterItem', title: string, links: Array<{ __typename?: 'Link', href: string, text: string }> }>, social: Array<{ __typename?: 'LocalFooterSocial', text: string, href: string, type: string }> } } }, recommendations: { __typename?: 'Recommendations', models: Array<{ __typename?: 'RecommendedModel', model: string, content: Array<{ __typename: 'RecommendedArticle', type: string, id: string, href: string, title: string, subheading: string, image: string } | { __typename: 'RecommendedProduct', type: string, image: string, href: string, model: string, slug: string, testScore: number, price: string, manufacturer: string }> }> } } };

export type AboutWhichPageQueryVariables = Exact<{
  url: Scalars['String']['input'];
  context: Scalars['String']['input'];
}>;


export type AboutWhichPageQuery = { __typename?: 'Query', articlePage: { __typename: 'ArticlePage', articleBodyTemplate: any, showResubBanner: boolean, meta: { __typename?: 'Meta', title: string, desc: string, contentId: string, dataLayer: any, facebookDesc: string, facebookImage: string, facebookTitle: string, fbAppId: string, twitterDesc: string, twitterImage: string, twitterTitle: string, pageType: string, keywords: Array<string>, canonical: string, headCodeBlock: string, publishedDate: string, publishedDateTime: number, updatedDateTime: number, systemContentPublishedDate: string, systemContentUpdatedDate: string, glideCurationDate: string, frequencyOfUpdate: string, reviewSchema: string, significantUpdate: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any, subVertical: any, category: any, superCategory: any } }, breadcrumb: { __typename?: 'Breadcrumb', baseUrl: string, heading: { __typename?: 'Link', href: string, text: string }, links: Array<{ __typename?: 'Link', href: string, text: string }>, currentPage: { __typename?: 'Link', href: string, text: string } }, sharingData: { __typename?: 'SharingData', facebook: string, twitter: string, whatsapp: string, mail: string, metaData: { __typename?: 'SharingMetaData', url: string, headline: string, fbAppId: string, facebookText: string, twitterText: string, subject: string } }, jumpLinks: Array<{ __typename?: 'ArticleJumpLinks', name: string, slug: string }>, header: { __typename?: 'ArticleHeader', headline: string, addMarginOffsetClass: boolean, standfirst: string, date: { __typename?: 'DateInfo', rendered: string, iso: string } }, moreOnArticles: { __typename?: 'AssociatedArticles', title: string, links: Array<{ __typename?: 'ImageLink', href: string, text: string }> } } | { __typename: 'Redirect', redirectUrl: string, status: string } };

export type ConsumerRightsArticleQueryVariables = Exact<{
  url: Scalars['String']['input'];
  context: Scalars['String']['input'];
}>;


export type ConsumerRightsArticleQuery = { __typename?: 'Query', articlePage: { __typename: 'ArticlePage', articleBodyTemplate: any, showResubBanner: boolean, introParagraph: string, meta: { __typename?: 'Meta', title: string, desc: string, contentId: string, dataLayer: any, facebookDesc: string, facebookImage: string, facebookTitle: string, fbAppId: string, twitterDesc: string, twitterImage: string, twitterTitle: string, pageType: string, keywords: Array<string>, canonical: string, headCodeBlock: string, publishedDate: string, publishedDateTime: number, updatedDateTime: number, systemContentPublishedDate: string, systemContentUpdatedDate: string, glideCurationDate: string, frequencyOfUpdate: string, reviewSchema: string, significantUpdate: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any, subVertical: any, category: any, superCategory: any } }, breadcrumb: { __typename?: 'Breadcrumb', baseUrl: string, heading: { __typename?: 'Link', href: string, text: string }, links: Array<{ __typename?: 'Link', href: string, text: string }>, currentPage: { __typename?: 'Link', href: string, text: string } }, articleConfig: { __typename?: 'ArticleConfig', affiliateDisclaimer: boolean, whichConnectMessage: boolean, articleArea: string, articleType: string, adviceType: string, inlinePageScripts: Array<string> }, authors: Array<{ __typename?: 'Author', name: string, jobTitle: string, slug: string, about: string, image: { __typename?: 'ImageWithSources', src: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> } }>, jumpLinks: Array<{ __typename?: 'ArticleJumpLinks', name: string, slug: string }>, header: { __typename?: 'ArticleHeader', headline: string, addMarginOffsetClass: boolean, standfirst: string, date: { __typename?: 'DateInfo', rendered: string, iso: string } }, sharingData: { __typename?: 'SharingData', facebook: string, twitter: string, whatsapp: string, mail: string, metaData: { __typename?: 'SharingMetaData', url: string, headline: string, fbAppId: string, facebookText: string, twitterText: string, subject: string } }, heroImage: { __typename?: 'ImageWithSources', src: string, alt: string, caption: string, renditions: Array<string>, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }>, dimensions: { __typename?: 'Dimensions', width: string, height: string } }, relatedProducts: { __typename?: 'WCDRelatedProducts', categorySlug: string, categoryLabel: string, categoryLabelSingular: string, products: Array<{ __typename?: 'WCDProduct', slug: string, model: string, badges: Array<string>, overallScore: number, manufacturer: string, hasRetailers: boolean, imageSrc: string, label: string, textVariation: string, price: { __typename?: 'WCDPrice', formatted: string, label: string }, toolTip: { __typename?: 'WCDToolTip', ariaLabel: string, contents: string } }> }, latestNews: { __typename?: 'LatestNews', name: string, articles: Array<{ __typename?: 'LatestNewsArticle', title: string, href: string, dateInfo: { __typename?: 'DateInfo', rendered: string, iso: string }, imageWithSources: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, media: string, sizes: string }> } }> }, onwardJourney: { __typename?: 'ArticleOnwardJourney', component: string, props: { __typename?: 'ToolSignpost', title: string, description: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> } } }, optionalArticleData: { __typename?: 'OptionalArticleData', components: { __typename?: 'ArticleOptionalComponents', localFooter: { __typename?: 'LocalFooter', description: string, items: Array<{ __typename?: 'LocalFooterItem', title: string, links: Array<{ __typename?: 'Link', href: string, text: string }> }>, social: Array<{ __typename?: 'LocalFooterSocial', text: string, href: string, type: string }> }, moneyPromoBlock: { __typename?: 'PromoBlock', title: string, description: string, ctaLabel: string, ctaLink: string } } }, moreOnArticles: { __typename?: 'AssociatedArticles', title: string, links: Array<{ __typename?: 'ImageLink', href: string, text: string }> }, relatedArticles: { __typename?: 'AssociatedArticles', title: string, links: Array<{ __typename?: 'ImageLink', href: string, text: string }> }, consumerRightsFooter: { __typename?: 'LocalFooter', description: string, items: Array<{ __typename?: 'LocalFooterItem', title: string, links: Array<{ __typename?: 'Link', href: string, text: string }> }>, social: Array<{ __typename?: 'LocalFooterSocial', text: string, href: string, type: string }> } } | { __typename: 'Redirect', redirectUrl: string, status: string } };

export type ConsumerRightsScamsArticleQueryVariables = Exact<{
  url: Scalars['String']['input'];
  context: Scalars['String']['input'];
}>;


export type ConsumerRightsScamsArticleQuery = { __typename?: 'Query', articlePage: { __typename: 'ArticlePage', articleBodyTemplate: any, showResubBanner: boolean, meta: { __typename?: 'Meta', title: string, desc: string, contentId: string, dataLayer: any, facebookDesc: string, facebookImage: string, facebookTitle: string, fbAppId: string, twitterDesc: string, twitterImage: string, twitterTitle: string, pageType: string, keywords: Array<string>, canonical: string, headCodeBlock: string, publishedDate: string, publishedDateTime: number, updatedDateTime: number, systemContentPublishedDate: string, systemContentUpdatedDate: string, glideCurationDate: string, frequencyOfUpdate: string, reviewSchema: string, significantUpdate: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any, subVertical: any, category: any, superCategory: any } }, breadcrumb: { __typename?: 'Breadcrumb', baseUrl: string, heading: { __typename?: 'Link', href: string, text: string }, links: Array<{ __typename?: 'Link', href: string, text: string }>, currentPage: { __typename?: 'Link', href: string, text: string } }, articleConfig: { __typename?: 'ArticleConfig', whichConnectMessage: boolean, inlinePageScripts: Array<string> }, jumpLinks: Array<{ __typename?: 'ArticleJumpLinks', name: string, slug: string }>, header: { __typename?: 'ArticleHeader', headline: string, addMarginOffsetClass: boolean, standfirst: string }, consumerRightsFooter: { __typename?: 'LocalFooter', description: string, items: Array<{ __typename?: 'LocalFooterItem', title: string, links: Array<{ __typename?: 'Link', href: string, text: string }> }>, social: Array<{ __typename?: 'LocalFooterSocial', text: string, href: string, type: string }> }, latestNews: { __typename?: 'LatestNews', articles: Array<{ __typename?: 'LatestNewsArticle', title: string, href: string, imageWithSources: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> }, dateInfo: { __typename?: 'DateInfo', rendered: string } }> } } | { __typename: 'Redirect', redirectUrl: string, status: string } };

export type NewsArticlePageQueryVariables = Exact<{
  url: Scalars['String']['input'];
  context: Scalars['String']['input'];
}>;


export type NewsArticlePageQuery = { __typename?: 'Query', articlePage: { __typename: 'ArticlePage', articleBodyTemplate: any, showResubBanner: boolean, introParagraph: string, meta: { __typename?: 'Meta', title: string, desc: string, contentId: string, dataLayer: any, facebookDesc: string, facebookImage: string, facebookTitle: string, fbAppId: string, twitterDesc: string, twitterImage: string, twitterTitle: string, pageType: string, keywords: Array<string>, canonical: string, headCodeBlock: string, publishedDate: string, publishedDateTime: number, updatedDateTime: number, systemContentPublishedDate: string, systemContentUpdatedDate: string, glideCurationDate: string, frequencyOfUpdate: string, reviewSchema: string, significantUpdate: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any, subVertical: any, category: any, superCategory: any } }, breadcrumb: { __typename?: 'Breadcrumb', baseUrl: string, heading: { __typename?: 'Link', href: string, text: string }, links: Array<{ __typename?: 'Link', href: string, text: string }>, currentPage: { __typename?: 'Link', href: string, text: string } }, articleConfig: { __typename?: 'ArticleConfig', affiliateDisclaimer: boolean, whichConnectMessage: boolean, articleArea: string, articleType: string, adviceType: string, inlinePageScripts: Array<string> }, authors: Array<{ __typename?: 'Author', name: string, jobTitle: string, slug: string, about: string, image: { __typename?: 'ImageWithSources', src: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> } }>, header: { __typename?: 'ArticleHeader', headline: string, addMarginOffsetClass: boolean, standfirst: string, date: { __typename?: 'DateInfo', rendered: string, iso: string } }, sharingData: { __typename?: 'SharingData', facebook: string, twitter: string, whatsapp: string, mail: string, metaData: { __typename?: 'SharingMetaData', url: string, headline: string, fbAppId: string, facebookText: string, twitterText: string, subject: string } }, heroImage: { __typename?: 'ImageWithSources', src: string, alt: string, caption: string, renditions: Array<string>, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }>, dimensions: { __typename?: 'Dimensions', width: string, height: string } }, heroVideo: { __typename?: 'HeroVideo', videoClient: string, videoId: string, brightcoveAccountId: string, seo: { __typename?: 'VideoSEO', name: string, description: string, thumbnailUrl: string, dateCreated: string, dateModified: string, uploadDate: string, duration: string, embedUrl: string, contentUrl: string } }, videosSeoData: Array<{ __typename?: 'VideoSEO', name: string, description: string, thumbnailUrl: string, dateCreated: string, dateModified: string, uploadDate: string, duration: string, embedUrl: string, contentUrl: string }>, tags: Array<{ __typename?: 'Tag', label: string, slug: string }>, moreOnArticles: { __typename?: 'AssociatedArticles', title: string, links: Array<{ __typename?: 'ImageLink', href: string, text: string, img: string }> }, relatedArticles: { __typename?: 'AssociatedArticles', title: string, links: Array<{ __typename?: 'ImageLink', href: string, text: string, img: string }> }, promoBlock: { __typename?: 'PromoBlock', title: string, description: string, ctaLabel: string, ctaLink: string }, optionalArticleData: { __typename?: 'OptionalArticleData', components: { __typename?: 'ArticleOptionalComponents', localFooter: { __typename?: 'LocalFooter', description: string, items: Array<{ __typename?: 'LocalFooterItem', title: string, links: Array<{ __typename?: 'Link', href: string, text: string }> }>, social: Array<{ __typename?: 'LocalFooterSocial', text: string, href: string, type: string }> } } } } | { __typename: 'Redirect', redirectUrl: string, status: string } };

export type PensionPageQueryVariables = Exact<{
  url: Scalars['String']['input'];
  context: Scalars['String']['input'];
}>;


export type PensionPageQuery = { __typename?: 'Query', articlePage: { __typename: 'ArticlePage', articleBodyTemplate: any, showResubBanner: boolean, meta: { __typename?: 'Meta', title: string, desc: string, contentId: string, dataLayer: any, facebookDesc: string, facebookImage: string, facebookTitle: string, fbAppId: string, twitterDesc: string, twitterImage: string, twitterTitle: string, pageType: string, keywords: Array<string>, canonical: string, headCodeBlock: string, publishedDate: string, publishedDateTime: number, updatedDateTime: number, systemContentPublishedDate: string, systemContentUpdatedDate: string, glideCurationDate: string, frequencyOfUpdate: string, reviewSchema: string, significantUpdate: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any, subVertical: any, category: any, superCategory: any } }, breadcrumb: { __typename?: 'Breadcrumb', baseUrl: string, heading: { __typename?: 'Link', href: string, text: string }, links: Array<{ __typename?: 'Link', href: string, text: string }>, currentPage: { __typename?: 'Link', href: string, text: string } }, sharingData: { __typename?: 'SharingData', facebook: string, twitter: string, whatsapp: string, mail: string, metaData: { __typename?: 'SharingMetaData', url: string, headline: string, fbAppId: string, facebookText: string, twitterText: string, subject: string } }, jumpLinks: Array<{ __typename?: 'ArticleJumpLinks', name: string, slug: string }>, header: { __typename?: 'ArticleHeader', headline: string, addMarginOffsetClass: boolean, standfirst: string, date: { __typename?: 'DateInfo', rendered: string, iso: string } }, moreOnArticles: { __typename?: 'AssociatedArticles', title: string, links: Array<{ __typename?: 'ImageLink', href: string, text: string }> } } | { __typename: 'Redirect', redirectUrl: string, status: string } };

export type PolicyAndInsightPageQueryVariables = Exact<{
  url: Scalars['String']['input'];
  context: Scalars['String']['input'];
}>;


export type PolicyAndInsightPageQuery = { __typename?: 'Query', articlePage: { __typename: 'ArticlePage', articleBodyTemplate: any, showResubBanner: boolean, articleExcelDataSheet: any, articlePdf: any, estimatedReadingTime: string, meta: { __typename?: 'Meta', title: string, desc: string, contentId: string, dataLayer: any, facebookDesc: string, facebookImage: string, facebookTitle: string, fbAppId: string, twitterDesc: string, twitterImage: string, twitterTitle: string, pageType: string, keywords: Array<string>, canonical: string, headCodeBlock: string, publishedDate: string, publishedDateTime: number, updatedDateTime: number, systemContentPublishedDate: string, systemContentUpdatedDate: string, glideCurationDate: string, frequencyOfUpdate: string, reviewSchema: string, significantUpdate: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any, subVertical: any, category: any, superCategory: any } }, breadcrumb: { __typename?: 'Breadcrumb', baseUrl: string, heading: { __typename?: 'Link', href: string, text: string }, links: Array<{ __typename?: 'Link', href: string, text: string }>, currentPage: { __typename?: 'Link', href: string, text: string } }, articleConfig: { __typename?: 'ArticleConfig', affiliateDisclaimer: boolean, whichConnectMessage: boolean, articleArea: string, articleType: string, adviceType: string, inlinePageScripts: Array<string> }, authors: Array<{ __typename?: 'Author', name: string, jobTitle: string, slug: string, about: string, image: { __typename?: 'ImageWithSources', src: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> } }>, jumpLinks: Array<{ __typename?: 'ArticleJumpLinks', name: string, slug: string }>, header: { __typename?: 'ArticleHeader', headline: string, addMarginOffsetClass: boolean, standfirst: string, date: { __typename?: 'DateInfo', rendered: string, iso: string } }, sharingData: { __typename?: 'SharingData', facebook: string, twitter: string, whatsapp: string, mail: string, metaData: { __typename?: 'SharingMetaData', url: string, headline: string, fbAppId: string, facebookText: string, twitterText: string, subject: string } }, heroImage: { __typename?: 'ImageWithSources', src: string, alt: string, caption: string, renditions: Array<string>, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }>, dimensions: { __typename?: 'Dimensions', width: string, height: string } }, moreOnArticles: { __typename?: 'AssociatedArticles', title: string, links: Array<{ __typename?: 'ImageLink', href: string, text: string }> }, relatedArticles: { __typename?: 'AssociatedArticles', title: string, links: Array<{ __typename?: 'ImageLink', href: string, text: string }> } } | { __typename: 'Redirect', redirectUrl: string, status: string } };

export type RecommendedForYouArticlesQueryVariables = Exact<{ [key: string]: never; }>;


export type RecommendedForYouArticlesQuery = { __typename?: 'Query', homePage: { __typename?: 'HomePage', recommendations: { __typename?: 'Recommendations', models: Array<{ __typename?: 'RecommendedModel', model: string, content: Array<{ __typename: 'RecommendedArticle', type: string, id: string, href: string, title: string, subheading: string, image: string } | { __typename: 'RecommendedProduct' }> }> } } };

export type ReviewsAdviceMultiQueryVariables = Exact<{
  url: Scalars['String']['input'];
  context: Scalars['String']['input'];
}>;


export type ReviewsAdviceMultiQuery = { __typename?: 'Query', articlePage: { __typename: 'ArticlePage', articleBodyTemplate: any, showResubBanner: boolean, introParagraph: string, meta: { __typename?: 'Meta', title: string, desc: string, contentId: string, dataLayer: any, facebookDesc: string, facebookImage: string, facebookTitle: string, fbAppId: string, twitterDesc: string, twitterImage: string, twitterTitle: string, pageType: string, keywords: Array<string>, canonical: string, headCodeBlock: string, publishedDate: string, publishedDateTime: number, updatedDateTime: number, systemContentPublishedDate: string, systemContentUpdatedDate: string, glideCurationDate: string, frequencyOfUpdate: string, reviewSchema: string, significantUpdate: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any, subVertical: any, category: any, superCategory: any } }, breadcrumb: { __typename?: 'Breadcrumb', baseUrl: string, heading: { __typename?: 'Link', href: string, text: string }, links: Array<{ __typename?: 'Link', href: string, text: string }>, currentPage: { __typename?: 'Link', href: string, text: string } }, articleConfig: { __typename?: 'ArticleConfig', affiliateDisclaimer: boolean, whichConnectMessage: boolean, articleArea: string, articleType: string, adviceType: string, inlinePageScripts: Array<string> }, authors: Array<{ __typename?: 'Author', name: string, jobTitle: string, slug: string, about: string, image: { __typename?: 'ImageWithSources', src: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> } }>, jumpLinks: Array<{ __typename?: 'ArticleJumpLinks', name: string, slug: string }>, header: { __typename?: 'ArticleHeader', headline: string, addMarginOffsetClass: boolean, standfirst: string, date: { __typename?: 'DateInfo', rendered: string, iso: string } }, sharingData: { __typename?: 'SharingData', facebook: string, twitter: string, whatsapp: string, mail: string, metaData: { __typename?: 'SharingMetaData', url: string, headline: string, fbAppId: string, facebookText: string, twitterText: string, subject: string } }, heroImage: { __typename?: 'ImageWithSources', src: string, alt: string, caption: string, renditions: Array<string>, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }>, dimensions: { __typename?: 'Dimensions', width: string, height: string } }, relatedProducts: { __typename?: 'WCDRelatedProducts', categorySlug: string, categoryLabel: string, categoryLabelSingular: string, products: Array<{ __typename?: 'WCDProduct', slug: string, model: string, badges: Array<string>, overallScore: number, manufacturer: string, hasRetailers: boolean, imageSrc: string, label: string, textVariation: string, price: { __typename?: 'WCDPrice', formatted: string, label: string }, toolTip: { __typename?: 'WCDToolTip', ariaLabel: string, contents: string } }> }, latestNews: { __typename?: 'LatestNews', name: string, articles: Array<{ __typename?: 'LatestNewsArticle', title: string, href: string, dateInfo: { __typename?: 'DateInfo', rendered: string, iso: string }, imageWithSources: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, media: string, sizes: string }> } }> }, onwardJourney: { __typename?: 'ArticleOnwardJourney', component: string, props: { __typename?: 'ToolSignpost', title: string, description: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> } } }, optionalArticleData: { __typename?: 'OptionalArticleData', components: { __typename?: 'ArticleOptionalComponents', localFooter: { __typename?: 'LocalFooter', description: string, items: Array<{ __typename?: 'LocalFooterItem', title: string, links: Array<{ __typename?: 'Link', href: string, text: string }> }>, social: Array<{ __typename?: 'LocalFooterSocial', text: string, href: string, type: string }> }, moneyPromoBlock: { __typename?: 'PromoBlock', title: string, description: string, ctaLabel: string, ctaLink: string } } }, heroCTA: { __typename?: 'HeroCTA', title: string, button_url: string, component: string, button_text: string, link_anchor: string, caption_text: string, description: string, image_alt_text: string, links_list_label: string, secondary_tool_url: string, links_list_aria_label: string, widget_image_aspect_ratio: string }, multiPageGuide: { __typename?: 'AssociatedArticles', title: string, links: Array<{ __typename?: 'ImageLink', href: string, text: string }> } } | { __typename: 'Redirect', redirectUrl: string, status: string } };

export type ReviewsAdviceSingleQueryVariables = Exact<{
  url: Scalars['String']['input'];
  context: Scalars['String']['input'];
}>;


export type ReviewsAdviceSingleQuery = { __typename?: 'Query', articlePage: { __typename: 'ArticlePage', articleBodyTemplate: any, showResubBanner: boolean, introParagraph: string, meta: { __typename?: 'Meta', title: string, desc: string, contentId: string, dataLayer: any, facebookDesc: string, facebookImage: string, facebookTitle: string, fbAppId: string, twitterDesc: string, twitterImage: string, twitterTitle: string, pageType: string, keywords: Array<string>, canonical: string, headCodeBlock: string, publishedDate: string, publishedDateTime: number, updatedDateTime: number, systemContentPublishedDate: string, systemContentUpdatedDate: string, glideCurationDate: string, frequencyOfUpdate: string, reviewSchema: string, significantUpdate: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any, subVertical: any, category: any, superCategory: any } }, breadcrumb: { __typename?: 'Breadcrumb', baseUrl: string, heading: { __typename?: 'Link', href: string, text: string }, links: Array<{ __typename?: 'Link', href: string, text: string }>, currentPage: { __typename?: 'Link', href: string, text: string } }, articleConfig: { __typename?: 'ArticleConfig', affiliateDisclaimer: boolean, whichConnectMessage: boolean, articleArea: string, articleType: string, adviceType: string, inlinePageScripts: Array<string> }, authors: Array<{ __typename?: 'Author', name: string, jobTitle: string, slug: string, about: string, image: { __typename?: 'ImageWithSources', src: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> } }>, jumpLinks: Array<{ __typename?: 'ArticleJumpLinks', name: string, slug: string }>, header: { __typename?: 'ArticleHeader', headline: string, addMarginOffsetClass: boolean, standfirst: string, date: { __typename?: 'DateInfo', rendered: string, iso: string } }, sharingData: { __typename?: 'SharingData', facebook: string, twitter: string, whatsapp: string, mail: string, metaData: { __typename?: 'SharingMetaData', url: string, headline: string, fbAppId: string, facebookText: string, twitterText: string, subject: string } }, heroImage: { __typename?: 'ImageWithSources', src: string, alt: string, caption: string, renditions: Array<string>, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }>, dimensions: { __typename?: 'Dimensions', width: string, height: string } }, relatedProducts: { __typename?: 'WCDRelatedProducts', categorySlug: string, categoryLabel: string, categoryLabelSingular: string, products: Array<{ __typename?: 'WCDProduct', slug: string, model: string, badges: Array<string>, overallScore: number, manufacturer: string, hasRetailers: boolean, imageSrc: string, label: string, textVariation: string, price: { __typename?: 'WCDPrice', formatted: string, label: string }, toolTip: { __typename?: 'WCDToolTip', ariaLabel: string, contents: string } }> }, latestNews: { __typename?: 'LatestNews', name: string, articles: Array<{ __typename?: 'LatestNewsArticle', title: string, href: string, dateInfo: { __typename?: 'DateInfo', rendered: string, iso: string }, imageWithSources: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, media: string, sizes: string }> } }> }, onwardJourney: { __typename?: 'ArticleOnwardJourney', component: string, props: { __typename?: 'ToolSignpost', title: string, description: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> } } }, optionalArticleData: { __typename?: 'OptionalArticleData', components: { __typename?: 'ArticleOptionalComponents', localFooter: { __typename?: 'LocalFooter', description: string, items: Array<{ __typename?: 'LocalFooterItem', title: string, links: Array<{ __typename?: 'Link', href: string, text: string }> }>, social: Array<{ __typename?: 'LocalFooterSocial', text: string, href: string, type: string }> }, moneyPromoBlock: { __typename?: 'PromoBlock', title: string, description: string, ctaLabel: string, ctaLink: string } } }, heroCTA: { __typename?: 'HeroCTA', title: string, button_url: string, component: string, button_text: string, link_anchor: string, caption_text: string, description: string, image_alt_text: string, links_list_label: string, secondary_tool_url: string, links_list_aria_label: string, widget_image_aspect_ratio: string }, moreOnArticles: { __typename?: 'AssociatedArticles', title: string, links: Array<{ __typename?: 'ImageLink', href: string, text: string }> }, relatedArticles: { __typename?: 'AssociatedArticles', title: string, links: Array<{ __typename?: 'ImageLink', href: string, text: string }> } } | { __typename: 'Redirect', redirectUrl: string, status: string } };

export type AuthorArticlesQueryVariables = Exact<{
  authorSlug: Scalars['String']['input'];
}>;


export type AuthorArticlesQuery = { __typename?: 'Query', authorArticles: { __typename?: 'PolicyAndInsightAuthorPage', label: string, total: number, articles: Array<{ __typename?: 'PolicyAndInsightArticle', title: string, standFirst: string, date: string, image: string, href: string, imageAlt: string, estimatedReadingTime: string, topicHeading: { __typename?: 'TopicHeading', text: string, icon: string, category: string }, authors: Array<{ __typename?: 'Author', name: string, jobTitle: string, image: { __typename?: 'ImageWithSources', src: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> } }> }>, author: { __typename?: 'PolicyAndInsightAuthor', name: string, jobTitle: string, about: string, slug: string, image: { __typename?: 'ImageWithSources', id: string, src: string }, links: Array<{ __typename?: 'ContactLink', icon: string, href: string, text: string }> }, sharingData: { __typename?: 'SharingData', facebook: string, twitter: string, whatsapp: string, mail: string, metaData: { __typename?: 'SharingMetaData', url: string, headline: string, fbAppId: string, facebookText: string, twitterText: string, subject: string } } } };

export type ArticleTypePageQueryVariables = Exact<{
  articleTypeSlug: Scalars['String']['input'];
  url: Scalars['String']['input'];
}>;


export type ArticleTypePageQuery = { __typename?: 'Query', articleTypePage: { __typename?: 'ArticleTypePage', meta: { __typename?: 'Meta', title: string, desc: string, fbAppId: string, dataLayer: any, pageType: string, canonical: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any, subVertical: any, category: any, superCategory: any } }, topArticles: { __typename?: 'TopArticles', title: string, description: string, articles: Array<{ __typename?: 'ExtendedArticles', title: string, href: string, strapline: string }> }, popularArticles: { __typename?: 'PopularArticles', title: string, articlesList: Array<{ __typename?: 'ArticlesList', title: string, image: { __typename?: 'ImageWithSources', src: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> }, articles: Array<{ __typename?: 'ArticleLink', title: string, href: string }> }> }, consumerRightsFooter: { __typename?: 'LocalFooter', title: string, description: string, items: Array<{ __typename?: 'LocalFooterItem', title: string, links: Array<{ __typename?: 'Link', href: string, text: string }> }>, social: Array<{ __typename?: 'LocalFooterSocial', text: string, href: string, type: string }> }, taxonomyConversionBanner: { __typename?: 'TaxonomyConversionBanner', title: string, description: string, descriptionMobile: string, buttonText: string, buttonURL: string }, breadcrumb: { __typename?: 'Breadcrumb', baseUrl: string, heading: { __typename?: 'Link', href: string, text: string }, links: Array<{ __typename?: 'Link', href: string, text: string }>, currentPage: { __typename?: 'Link', href: string, text: string } } } };

export type EnergyPageQueryVariables = Exact<{
  rootCollectionName: Scalars['String']['input'];
}>;


export type EnergyPageQuery = { __typename?: 'Query', energyPage: { __typename?: 'EnergyPage', meta: { __typename?: 'PageMeta', title: string, desc: string, fbAppId: string, canonical: string, taxonomySlug: string }, header: { __typename?: 'Header', title: string, intro: string, backgroundColour: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> } }, contentItems: Array<{ __typename: 'PicksContentItem', title: string, intro: string, jumpLinks: { __typename?: 'PicksJumpLink', id: string, label: string }, productListingLink: { __typename?: 'PicksProductListingLink', href: string, label: string }, inlineArticles: Array<{ __typename?: 'Link', href: string, text: string }>, items: Array<{ __typename: 'PicksArticleCard', title: string, description: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> }, link: { __typename?: 'Link', href: string, text: string } } | { __typename: 'PicksProductCard', title: string, description: string, model: string, manufacturer: string, typicalPrice: string, reviewUrl: string, usesPimData: boolean, articleLink: string, articleLinkLabel: string, affiliateItems: Array<{ __typename?: 'AffiliateItem', url: string, isTrackable: boolean, retailer: string, price: string }>, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> }, annualRunningCost: { __typename?: 'PicksAnnualRunningCost', label: string, formatted: string } }> } | { __typename: 'PicksPromo', component: string, props: any }>, relatedArticleLinks: Array<{ __typename?: 'Link', href: string, text: string }>, authors: Array<{ __typename?: 'PicksAuthor', id: number, name: string, jobTitle: string, slug: string, about: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> } }> } };

export type MemberBenefitsInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type MemberBenefitsInfoQuery = { __typename?: 'Query', memberBenefitsInfo: { __typename?: 'MemberBenefitsInfo', isLoggedIn: boolean, calloutText: string, caption: string, overline: string, offerPrice: string, previousOfferPrice: string, links: Array<{ __typename?: 'MemberBenefitPageLink', href: string, image: string, text: string } | { __typename?: 'MemberBenefitWidgetLink', image: string, text: string, content: Array<{ __typename?: 'MemberBenefitContent', heading: string, subheader: string, icon: string }> }>, offer: { __typename?: 'MemberBenefitOffer', heading: string, href: string, text: string }, creative: { __typename?: 'Creative', val: string, isQueryParam: boolean }, renewalOffer: { __typename?: 'MemberBenefitRenewalOffer', heading: string, body: string, phoneNumber: string, footerText: string } } };

export type HomePageQueryVariables = Exact<{ [key: string]: never; }>;


export type HomePageQuery = { __typename?: 'Query', homePage: { __typename?: 'HomePage', imageUrl: string, showResubBanner: boolean, meta: { __typename?: 'Meta', title: string, desc: string, fbAppId: string, dataLayer: any, pageType: string, canonical: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any, subVertical: any, category: any, superCategory: any } }, toolCTAs: Array<{ __typename?: 'ToolSignpost', identifier: string, title: string, description: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, id: string, caption: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, media: string, type: string, sizes: string }>, dimensions: { __typename?: 'Dimensions', width: string, height: string } }, button: { __typename?: 'Link', href: string, text: string } }>, freeAccountExclusive: { __typename?: 'FreeAccountExclusive', title: string, description: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, id: string, caption: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, media: string, type: string, sizes: string }>, dimensions: { __typename?: 'Dimensions', width: string, height: string } } }, featuredLinks: Array<{ __typename?: 'FeaturedLinks', identifier: string, title: string, strapline: string, onwardLinkText: string, onwardLinkUrl: string, backgroundColour: string, mainFeaturedArticle: { __typename?: 'MainFeaturedArticle', title: string, href: string, standfirst: string, isLive: boolean, dateInfo: { __typename?: 'DateInfo', rendered: string, iso: string }, image: { __typename?: 'ImageWithSources', renditions: Array<string>, src: string, alt: string, id: string, caption: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, media: string, type: string, sizes: string }>, dimensions: { __typename?: 'Dimensions', width: string, height: string } } }, featuredArticles: Array<{ __typename?: 'FeaturedContent', title: string, href: string, dateInfo: { __typename?: 'DateInfo', rendered: string, iso: string }, imageWithSources: { __typename?: 'ImageWithSources', renditions: Array<string>, src: string, alt: string, id: string, caption: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, media: string, type: string, sizes: string }>, dimensions: { __typename?: 'Dimensions', width: string, height: string } } }> }>, mostReadLinks: { __typename?: 'MostReadLinks', title: string, links: Array<{ __typename?: 'Link', href: string, text: string }> }, magazineLinks: { __typename?: 'MagazineLinks', title: string, strapline: string, links: Array<{ __typename?: 'MagazineLink', title: string, strapline: string, href: string, image: { __typename?: 'ImageWithSources', src: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> } }> } } };

export type LiveReportPageQueryVariables = Exact<{
  liveReportUrl: Scalars['String']['input'];
}>;


export type LiveReportPageQuery = { __typename?: 'Query', liveReportPage: { __typename?: 'LiveReportPage', liveReportHeader: { __typename?: 'LiveReportHeader', headline: string, catchline: string, description: string, summary: string, isLive: boolean, promoImageSrcList: Array<string>, coverageEndTime: string, datePublishedIso: string, dateModifiedIso: string }, liveReportPosts: Array<{ __typename?: 'LiveReportPostData', id: number, headline: string, catchline: string, authors: string, postBodyTemplate: any, postBodyString: string, publishedAtIso: string, updatedAtIso: string }>, sharingData: { __typename?: 'SharingData', facebook: string, twitter: string, whatsapp: string, mail: string, metaData: { __typename?: 'SharingMetaData', url: string, headline: string, fbAppId: string, facebookText: string, twitterText: string, subject: string } }, meta: { __typename?: 'Meta', title: string, contentId: string, canonical: string, desc: string, facebookImage: string, twitterImage: string, keywords: Array<string>, dataLayer: any } } };

export type MarketingHubPageQueryVariables = Exact<{ [key: string]: never; }>;


export type MarketingHubPageQuery = { __typename?: 'Query', marketingHubPage: { __typename?: 'MarketingHubPage', footer: string, contentItems: Array<{ __typename: 'MarketingHubContentItem', title: string, cards: Array<{ __typename?: 'MarketingHubCard', url: string, title: string, subTitle: string, smallPrint: string }>, jumplink: { __typename?: 'BasicJumpLink', label: string, id: string } } | { __typename: 'MarketingHubWidget', component: string, props: any }>, header: { __typename?: 'MarketingHubHeader', catchline: string, description: string, backgroundColour: string, image: { __typename?: 'MarketingHubHeaderImage', src: string, alt: string, sources: Array<{ __typename?: 'MarketingHubImageSource', srcset: string, sizes: string }> } }, meta: { __typename?: 'PageMeta', title: string, desc: string, fbAppId: string, taxonomySlug: string, canonical: string, publishedDateTime: number, updatedDateTime: number, socialData: { __typename?: 'SocialData', twitter: { __typename?: 'SocialDataTwitter', image: string, description: string, title: string }, og: { __typename?: 'SocialDataOG', image: string, description: string, title: string } } } } };

export type ProductHubPageQueryVariables = Exact<{
  subVerticalSlug: Scalars['String']['input'];
  productSlug: Scalars['String']['input'];
}>;


export type ProductHubPageQuery = { __typename?: 'Query', productHubPage: { __typename?: 'ProductHubPage', productHubEnabled: boolean, isLoggedIn: boolean, transformTypeDecision: string, showResubBanner: boolean, breadcrumb: { __typename?: 'Breadcrumb', baseUrl: string, heading: { __typename?: 'Link', href: string, text: string }, links: Array<{ __typename?: 'Link', href: string, text: string }>, currentPage: { __typename?: 'Link', href: string, text: string } }, header: { __typename?: 'Header', title: string, description: string, image: { __typename?: 'ImageWithSources', renditions: Array<string>, src: string, alt: string, id: string, caption: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, media: string, type: string, sizes: string }>, dimensions: { __typename?: 'Dimensions', width: string, height: string } } }, meta: { __typename?: 'Meta', title: string, desc: string, facebookTitle: string, facebookDesc: string, facebookImage: string, twitterTitle: string, twitterDesc: string, twitterImage: string, fbAppId: string, dataLayer: any, pageType: string, canonical: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any, subVertical: any, category: any, superCategory: any } }, productReviews: { __typename?: 'ProductReviews', heading: string, subText: string, productSlug: string, brands: { __typename?: 'Brand', heading: string, relatedArticle: { __typename?: 'RelatedArticle', link: string, linkText: string }, items: Array<{ __typename?: 'BrandItem', link: string, linkText: string }> }, productData: Array<{ __typename?: 'ProductReview', manufacturer: string, model: string, businessKey: string, price: string, retailers: boolean, slug: string, tags: Array<string>, badges: Array<string>, image: { __typename?: 'ProductReviewImage', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, media: string, type: string, sizes: string }> }, variantValues: Array<{ __typename?: 'VariantValue', code: string, value: string, label: string }>, variantPriceRange: { __typename?: 'VariantPriceRange', min: { __typename?: 'Price', formatted: string }, max: { __typename?: 'Price', formatted: string } }, productScoreGauge: { __typename?: 'ProductScoreGauge', label: string, variant: string, testScoreGauge: { __typename?: 'TestScore', overallScore: number, textVariation: string }, tooltip: { __typename?: 'Tooltip', contents: string, title: string, ariaLabel: string } } }>, productCount: { __typename?: 'ProductCount', total: number } }, helpAndAdvice: { __typename?: 'HelpAndAdvice', title: string, subtitle: string, featuredArticle: { __typename?: 'HelpAndAdviceFeaturedArticle', title: string, description: string, path: string, image: { __typename?: 'HelpAndAdviceImage', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, media: string, type: string, sizes: string }> } }, topArticles: Array<{ __typename?: 'HelpAndAdviceArticle', title: string, description: string, path: string, image: { __typename?: 'HelpAndAdviceImage', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, media: string, type: string, sizes: string }> } }>, allArticles: Array<{ __typename?: 'HelpAndAdviceArticle', title: string, description: string, path: string, image: { __typename?: 'HelpAndAdviceImage', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, media: string, type: string, sizes: string }> } }> }, categoryTypes: { __typename?: 'CategoryTypes', title: string, relatedArticleLink: { __typename?: 'RelatedArticle', link: string, linkText: string }, cards: Array<{ __typename?: 'CategoryType', title: string, link: string, image: { __typename?: 'ImageWithSources', renditions: Array<string>, src: string, alt: string, id: string, caption: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, media: string, type: string, sizes: string }>, dimensions: { __typename?: 'Dimensions', width: string, height: string } } }> } } };

export type ProductComparisonPageQueryVariables = Exact<{
  categorySlug: Scalars['String']['input'];
  context: Scalars['String']['input'];
  productsIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ProductComparisonPageQuery = { __typename?: 'Query', productComparisonPage: { __typename?: 'ProductComparisonPage', breadcrumb: { __typename?: 'Breadcrumb', baseUrl: string, heading: { __typename?: 'Link', href: string, text: string }, links: Array<{ __typename?: 'Link', href: string, text: string }>, currentPage: { __typename?: 'Link', href: string, text: string } }, comparisonTable: { __typename?: 'ComparisonTable', taxonomySlug: string, tableData: Array<{ __typename?: 'ComparisonTableData', label: string, groupHelpText: string, dataType: string, rows: Array<{ __typename?: 'CompareRow', rowCode: string, rowLabel: string, rowValues: Array<any>, helpText: string }> }>, productDetails: Array<{ __typename?: 'ProductDetail', alertType: string, badges: Array<string>, businessKey: string, model: string, price: string, pros: Array<string>, cons: Array<string>, slug: string, testedType: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string, type: string }> }, manufacturer: { __typename?: 'ProductDetailManufacturer', name: string }, offers: Array<{ __typename?: 'ProductOffer', url: string, isTrackable: boolean, priceValue: number, formattedPrice: string, availableInStock: number, retailer: { __typename?: 'Retailer', name: string } }>, productScoreGauge: { __typename?: 'ProductDetailScoreGauge', label: string, variant: any, testScoreGauge: { __typename?: 'ProductDetailTestScore', overallScore: number, textVariation: any }, tooltip: { __typename?: 'Tooltip', contents: string, title: string, ariaLabel: string } }, editorialReview: { __typename?: 'ProductEditorialReview', cta: string, verdict: string, content: string, isPadlocked: boolean, teaser: string } }> }, meta: { __typename?: 'Meta', title: string, desc: string, dataLayer: any, pageType: string, canonical: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any, subVertical: any, category: any, superCategory: any } } } };

export type ProductListingPageQueryVariables = Exact<{
  categorySlug: Scalars['String']['input'];
  context: Scalars['String']['input'];
  pageNumber: Scalars['String']['input'];
  sortBy: Scalars['String']['input'];
  basicFilterData: Scalars['JSON']['input'];
  needsBasedFilterData: Scalars['JSON']['input'];
  selectedNeedsBasedFilters: Scalars['JSON']['input'];
  channel: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductListingPageQuery = { __typename?: 'Query', productListingPage: { __typename?: 'ProductListingPage', showResubBanner: boolean, seoContentBlock: string, breadcrumb: { __typename?: 'Breadcrumb', baseUrl: string, heading: { __typename?: 'Link', href: string, text: string }, links: Array<{ __typename?: 'Link', href: string, text: string }>, currentPage: { __typename?: 'Link', href: string, text: string } }, attributesCount: { __typename?: 'AttributesCount', productsCount: number, testedProductsCount: number, notTestedProductsCount: number, bestBuyCount: number, dontBuyCount: number, firstLookCount: number }, filters: Array<{ __typename?: 'Filter', attributeGroup: string, predicateType: string, externalId: string, filterLabel: string, caption: string, componentType: string, exclusion: boolean, disabled: boolean, order: number, filterLabelTooltip: { __typename?: 'FilterTooltip', label: string, description: string }, filterItems: Array<{ __typename: 'FilterItemWithOptions', code: string, label: string, order: number, options: Array<{ __typename?: 'FilterItemOptionsWithValueBoolean', label: string, optionValueBool: boolean, optionCount: number } | { __typename?: 'FilterItemOptionsWithValueString', label: string, optionValueStr: string, optionCount: number }>, tooltip: { __typename?: 'FilterTooltip', label: string, description: string } } | { __typename: 'FilterItemWithToFrom', code: string, label: string, to: number, from: number, count: number, order: number, tooltip: { __typename?: 'FilterTooltip', label: string, description: string } } | { __typename: 'FilterItemWithValueBoolean', valueBool: boolean, code: string, label: string, count: number, order: number, tooltip: { __typename?: 'FilterTooltip', label: string, description: string } } | { __typename: 'FilterItemWithValueString', valueStr: string, code: string, label: string, count: number, order: number, tooltip: { __typename?: 'FilterTooltip', label: string, description: string } }> }>, needsBasedFilters: Array<{ __typename?: 'NeedsBasedFilter', questionText: string, externalId: string, disabled: boolean, answers: Array<{ __typename?: 'NeedsBasedAnswer', caption: string, icon: string, label: string, needsBasedAnswerOptions: Array<{ __typename?: 'NeedsBasedAnswerOption', code: string, attributeGroup: string, predicateType: string, externalId: string, valueStr: string, valueBool: boolean, to: number, from: number, bucketLabel: string, label: string, componentType: string }> }> }>, productsWithPagination: { __typename?: 'ProductsWithPagination', numberOfPages: number, taxonomySlug: string, totalRunningCostCount: number, productCount: { __typename?: 'ProductCount', description: string, start: number, end: number, total: number }, mappedSortedProducts: { __typename?: 'MappedSortedProducts', productsSortedByHighestScore: Array<{ __typename?: 'ReviewsProduct', category: string, overallScore: number, manufacturer: string, model: string, price: string, slug: string, badges: Array<string>, tags: Array<string>, retailers: boolean, alertType: string, businessKey: string, features: Array<{ __typename?: 'Features', list: Array<string>, type: string, count: number }>, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string, type: string }> }, productScoreGauge: { __typename?: 'ProductScoreGauge', label: string, testScoreGauge: { __typename?: 'TestScore', overallScore: number, textVariation: string }, tooltip: { __typename?: 'Tooltip', contents: string, title: string, ariaLabel: string } }, annualRunningCost: { __typename?: 'AnnualRunningCost', priceLabel: string, tooltip: { __typename?: 'Tooltip', contents: string, title: string, ariaLabel: string } }, variantValues: Array<{ __typename?: 'VariantValue', code: string, value: string, label: string }>, variantProducts: Array<{ __typename?: 'VariantProducts', model: string, slug: string, businessKey: string, tags: Array<string>, variantValues: Array<{ __typename?: 'VariantValue', code: string, value: string, label: string }>, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string, type: string }> } }>, variantPriceRange: { __typename?: 'VariantPriceRange', min: { __typename?: 'Price', formatted: string }, max: { __typename?: 'Price', formatted: string } } }>, productsSortedByMostRecentlyReviewed: Array<{ __typename?: 'ReviewsProduct', category: string, overallScore: number, manufacturer: string, model: string, price: string, slug: string, badges: Array<string>, tags: Array<string>, retailers: boolean, alertType: string, businessKey: string, features: Array<{ __typename?: 'Features', list: Array<string>, type: string, count: number }>, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string, type: string }> }, productScoreGauge: { __typename?: 'ProductScoreGauge', label: string, testScoreGauge: { __typename?: 'TestScore', overallScore: number, textVariation: string }, tooltip: { __typename?: 'Tooltip', contents: string, title: string, ariaLabel: string } }, annualRunningCost: { __typename?: 'AnnualRunningCost', priceLabel: string, tooltip: { __typename?: 'Tooltip', contents: string, title: string, ariaLabel: string } }, variantValues: Array<{ __typename?: 'VariantValue', code: string, value: string, label: string }>, variantProducts: Array<{ __typename?: 'VariantProducts', model: string, slug: string, businessKey: string, tags: Array<string>, variantValues: Array<{ __typename?: 'VariantValue', code: string, value: string, label: string }>, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string, type: string }> } }>, variantPriceRange: { __typename?: 'VariantPriceRange', min: { __typename?: 'Price', formatted: string }, max: { __typename?: 'Price', formatted: string } } }> }, products: Array<{ __typename?: 'ReviewsProduct', category: string, overallScore: number, manufacturer: string, model: string, price: string, slug: string, badges: Array<string>, tags: Array<string>, retailers: boolean, alertType: string, businessKey: string, features: Array<{ __typename?: 'Features', list: Array<string>, type: string, count: number }>, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string, type: string }> }, productScoreGauge: { __typename?: 'ProductScoreGauge', label: string, testScoreGauge: { __typename?: 'TestScore', overallScore: number, textVariation: string }, tooltip: { __typename?: 'Tooltip', contents: string, title: string, ariaLabel: string } }, annualRunningCost: { __typename?: 'AnnualRunningCost', priceLabel: string, ranking: number, rankingTotal: number, tooltip: { __typename?: 'Tooltip', contents: string, title: string, ariaLabel: string } }, variantValues: Array<{ __typename?: 'VariantValue', code: string, value: string, label: string }>, variantProducts: Array<{ __typename?: 'VariantProducts', model: string, slug: string, businessKey: string, badges: Array<string>, tags: Array<string>, hasRetailers: boolean, variantValues: Array<{ __typename?: 'VariantValue', code: string, value: string, label: string }>, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string, type: string }> } }>, variantPriceRange: { __typename?: 'VariantPriceRange', min: { __typename?: 'Price', formatted: string }, max: { __typename?: 'Price', formatted: string } } }> }, meta: { __typename?: 'Meta', title: string, desc: string, dataLayer: any, pageType: string, canonical: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any, subVertical: any, category: any, superCategory: any } }, sortByMenu: { __typename?: 'SortByMenu', defaultOption: number, items: Array<{ __typename?: 'SortByMenuItem', label: string, icon: string, value: string }> }, header: { __typename?: 'ProductListingHeader', description: string, heading: string, labTested: boolean, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, media: string, type: string, sizes: string }> } }, scoreStatement: { __typename?: 'ScoreStatement', title: string, content: string }, articleListingWithImage: { __typename?: 'ArticleListingWithImage', title: string, categoryLabel: string, categorySlug: string, articles: Array<{ __typename?: 'Articles', id: number, label: string, slug: string }> }, optionalRedirect: { __typename?: 'ProductListingRedirect', url: string, isExternal: boolean } } };

export type ProductPageQueryVariables = Exact<{
  categorySlug: Scalars['String']['input'];
  context: Scalars['String']['input'];
  productSlug: Scalars['String']['input'];
  channel: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductPageQuery = { __typename?: 'Query', productPage: { __typename?: 'ProductPage', transformTypeDecision: string, showResubBanner: boolean, breadcrumb: { __typename?: 'Breadcrumb', baseUrl: string, heading: { __typename?: 'Link', href: string, text: string }, links: Array<{ __typename?: 'Link', href: string, text: string }>, currentPage: { __typename?: 'Link', href: string, text: string } }, meta: { __typename?: 'Meta', title: string, desc: string, dataLayer: any, pageType: string, canonical: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any, subVertical: any, category: any, superCategory: any } }, productDetails: { __typename?: 'ProductDetails', businessKey: string, secondHandText: string, manufacturer: string, tags: Array<string>, price: string, priceValue: number, slug: string, hasRetailers: boolean, testedType: string, badges: Array<string>, model: string, pros: Array<string>, cons: Array<string>, testedDate: string, launchDate: string, curationDate: string, variantProductModel: string, keyTestResults: Array<{ __typename?: 'KeyTestResults', label: string, value: string, tooltip: string, isPadlocked: boolean }>, productScoreGauge: { __typename?: 'ProductScoreGauge', label: string, testScoreGauge: { __typename?: 'TestScore', overallScore: number, textVariation: string }, tooltip: { __typename?: 'Tooltip', contents: string, title: string, ariaLabel: string } }, editorialReview: { __typename?: 'ProductEditorialReview', cta: string, verdict: string, content: string, isPadlocked: boolean, teaser: string }, expertReview: { __typename?: 'ExpertReview', heading: string, sectionHeadings: Array<string>, sections: Array<{ __typename?: 'ExpertReviewSections', title: string, content: Array<{ __typename?: 'ReviewSectionContent', appearance: string, listItems: Array<string>, paragraph: string, imageSrc: string, imageAlt: string, videoId: string, brightcoveAccountId: string, techSpecs: Array<{ __typename?: 'SpecificationsSection', sectionLabel: string, rows: Array<{ __typename?: 'SpecificationsRow', rowLabel: string, value: any, helpText: string }> }>, testResults: Array<{ __typename?: 'ProductTestResult', heading: string, overallScore: string, subHeading: string, description: string, scores: Array<{ __typename?: 'ProductTestResultScore', label: string, starRating: string }> }> }> }> }, specifications: Array<{ __typename?: 'SpecificationsSection', sectionLabel: string, rows: Array<{ __typename?: 'SpecificationsRow', rowLabel: string, value: any, helpText: string, restricted: boolean }> }>, testResults: { __typename?: 'ProductPageTestResults', howWeTest: { __typename?: 'HowWeTest', title: string, url: string, updatedDate: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string, type: string }> } }, results: Array<{ __typename?: 'ProductTestResult', heading: string, overallScore: string, subHeading: string, description: string, scores: Array<{ __typename?: 'ProductTestResultScore', label: string, starRating: string }> }> }, supply: { __typename?: 'ProductSupply', indicationPrice: number, offers: Array<{ __typename?: 'ProductOffer', url: string, isTrackable: boolean, formattedPrice: string, priceValue: number, availableInStock: number, retailer: { __typename?: 'Retailer', hasScore: boolean, name: string, score: number } }> }, images: Array<{ __typename?: 'ProductImage', alt: string, thumbnailAlt: string, src: string, width: number, height: number, zoomSrc: string, zoomWidth: number, zoomHeight: number, sources: { __typename?: 'ProductImageAllSources', main: Array<{ __typename?: 'ProductImageSource', srcset: string, sizes: string, type: string }>, thumb: Array<{ __typename?: 'ProductImageSource', srcset: string, sizes: string, type: string }> }, zoomSources: { __typename?: 'ProductImageZoomSources', medium: string, large: string } }>, alerts: Array<{ __typename?: 'ProductDetailsAlert', description: string, type: string }>, timeline: { __typename?: 'ProductTimeLine', helpText: string, dates: Array<{ __typename?: 'ProductDates', date: string, label: string }> }, categoryData: { __typename?: 'CategoryData', renderAccordion: boolean }, suggestedAlternatives: Array<{ __typename?: 'SuggestedAlternative', businessKey: string, alertType: string, suggestedAlternativeLabel: string, manufacturer: string, model: string, tags: Array<string>, price: string, slug: string, hasBadgeZone: boolean, hasRetailers: boolean, badges: Array<string>, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string, type: string }> }, productScoreGauge: { __typename?: 'ProductScoreGauge', label: string, variant: string, testScoreGauge: { __typename?: 'TestScore', overallScore: number, textVariation: string }, tooltip: { __typename?: 'Tooltip', contents: string, title: string, ariaLabel: string } } }>, scoreScale: { __typename?: 'ScoreScale', heading: string, product: { __typename?: 'ScoreScaleItemProduct', label: string, score: number, relativeScorePercentage: number, obfuscated: boolean }, lowest: { __typename?: 'ScoreScaleItem', label: string, score: number }, average: { __typename?: 'ScoreScaleItemAverage', label: string, score: number, relativeScorePercentage: number }, highest: { __typename?: 'ScoreScaleItem', label: string, score: number } }, variantValues: Array<{ __typename?: 'VariantValue', code: string, value: string, label: string }>, variantProducts: Array<{ __typename?: 'VariantProducts', slug: string, variantValues: Array<{ __typename?: 'VariantValue', code: string, value: string, label: string }> }> }, relatedArticles: { __typename?: 'ArticleListingWithImage', categoryLabel: string, categorySlug: string, articles: Array<{ __typename?: 'Articles', id: number, label: string, slug: string, standfirst: string }> }, reviewsSwitchingLink: { __typename?: 'ReviewsSwitchingLink', label: string, href: string, isExternal: boolean }, productCounts: { __typename?: 'ProductCounts', totalItemCount: number, bestBuysCount: number, dontBuysCount: number } } };

export type SavedPageQueryVariables = Exact<{ [key: string]: never; }>;


export type SavedPageQuery = { __typename?: 'Query', savedPage: { __typename?: 'SavedPage', isLoggedIn: boolean, meta: { __typename?: 'SavedPageMeta', dataLayer: any, title: string, desc: string, canonical: string }, items: Array<{ __typename?: 'SavedItem', category: string, categorySlug: string, products: Array<{ __typename?: 'SavedProduct', businessKey: string, alertType: string, manufacturer: string, model: string, tags: Array<string>, price: string, slug: string, badges: Array<string>, hasBadgeZone: boolean, hasRetailers: boolean, productScoreGauge: { __typename?: 'ProductScoreGauge', label: string, variant: string, testScoreGauge: { __typename?: 'TestScore', overallScore: number, textVariation: string }, tooltip: { __typename?: 'Tooltip', contents: string, title: string, ariaLabel: string } }, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string, type: string }> } }> }> } };

export type PolicyAndInsightSearchResultsQueryVariables = Exact<{ [key: string]: never; }>;


export type PolicyAndInsightSearchResultsQuery = { __typename?: 'Query', policyAndInsightArticles: { __typename?: 'PolicyAndInsightArticlesFeed', label: string, total: number, articles: Array<{ __typename?: 'PolicyAndInsightSearch', authors: Array<string>, date: string, estimatedReadingTime: string, href: string, image: string, imageAlt: string, standFirst: string, title: string, category: string, trendingTopics: string, topicHeading: { __typename?: 'TopicHeading', text: string, icon: string, category: string } }> } };

export type SubVerticalCampaignPetitionQueryVariables = Exact<{
  subVerticalSlug: Scalars['String']['input'];
  context: Scalars['String']['input'];
}>;


export type SubVerticalCampaignPetitionQuery = { __typename?: 'Query', subVerticalPage: { __typename?: 'SubVerticalPage', showResubBanner: boolean, meta: { __typename?: 'Meta', title: string, desc: string, dataLayer: any, pageType: string, canonical: string, headCodeBlock: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any, subVertical: any } }, breadcrumb: { __typename?: 'Breadcrumb', baseUrl: string, heading: { __typename?: 'Link', href: string, text: string }, links: Array<{ __typename?: 'Link', href: string, text: string }>, currentPage: { __typename?: 'Link', href: string, text: string } }, campaignsPetitionCollection: { __typename?: 'CampaignsPetitionContent', contentItems: Array<{ __typename?: 'CampaignsPetitionContentItem', type: string, data: any }>, header: { __typename?: 'Header', title: string, intro: string }, petitionDetails: { __typename?: 'PetitionDetails', formID: string, pageID: number, targetCount: string, manualAdjustment: string, activeCampaign: boolean, meta: { __typename?: 'PetitionMeta', title: string, description: string, image: string } } }, sharingData: { __typename?: 'SharingData', facebook: string, twitter: string, whatsapp: string, mail: string, metaData: { __typename?: 'SharingMetaData', url: string, headline: string, fbAppId: string, facebookText: string, twitterText: string, subject: string } } } };

export type SubVerticalCrScamsTopicPageQueryVariables = Exact<{
  subVerticalSlug: Scalars['String']['input'];
  context: Scalars['String']['input'];
}>;


export type SubVerticalCrScamsTopicPageQuery = { __typename?: 'Query', subVerticalPage: { __typename?: 'SubVerticalPage', showResubBanner: boolean, meta: { __typename?: 'Meta', title: string, desc: string, dataLayer: any, pageType: string, canonical: string, headCodeBlock: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any, subVertical: any } }, breadcrumb: { __typename?: 'Breadcrumb', baseUrl: string, heading: { __typename?: 'Link', href: string, text: string }, links: Array<{ __typename?: 'Link', href: string, text: string }>, currentPage: { __typename?: 'Link', href: string, text: string } }, header: { __typename?: 'Header', title: string, intro: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, media: string, sizes: string }> } }, taxonomyConversionBanner: { __typename?: 'TaxonomyConversionBanner', title: string, description: string, descriptionMobile: string, buttonText: string, buttonURL: string }, callout: { __typename?: 'Callout', byline: string, description: string, imageFormat: ImageFormat, title: string, items: Array<{ __typename?: 'CalloutItem', strapline: string, title: string, href: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> } }> }, consumerRightsFooter: { __typename?: 'LocalFooter', description: string, items: Array<{ __typename?: 'LocalFooterItem', title: string, links: Array<{ __typename?: 'Link', href: string, text: string }> }>, social: Array<{ __typename?: 'LocalFooterSocial', text: string, href: string, type: string }> } }, latestNews: { __typename?: 'LatestNewsFeed', articles: Array<{ __typename?: 'LatestNewsArticle', title: string, href: string, imageWithSources: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> } }> } };

export type SubVerticalCrTopicPageQueryVariables = Exact<{
  subVerticalSlug: Scalars['String']['input'];
  context: Scalars['String']['input'];
}>;


export type SubVerticalCrTopicPageQuery = { __typename?: 'Query', subVerticalPage: { __typename?: 'SubVerticalPage', showResubBanner: boolean, meta: { __typename?: 'Meta', title: string, desc: string, dataLayer: any, pageType: string, canonical: string, headCodeBlock: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any, subVertical: any } }, breadcrumb: { __typename?: 'Breadcrumb', baseUrl: string, heading: { __typename?: 'Link', href: string, text: string }, links: Array<{ __typename?: 'Link', href: string, text: string }>, currentPage: { __typename?: 'Link', href: string, text: string } }, header: { __typename?: 'Header', title: string, intro: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, media: string, sizes: string }> } }, taxonomyConversionBanner: { __typename?: 'TaxonomyConversionBanner', title: string, description: string, descriptionMobile: string, buttonText: string, buttonURL: string }, crCategories: { __typename?: 'CRCategories', jumpLinks: { __typename?: 'JumpLinks', links: Array<{ __typename?: 'JumpLink', id: number, label: string }> }, sections: Array<{ __typename?: 'CRCategory', title: string, id: number, description: string, articleLinks: Array<{ __typename?: 'Link', href: string, text: string }>, link: { __typename?: 'Link', href: string, text: string } }> }, callout: { __typename?: 'Callout', byline: string, description: string, imageFormat: ImageFormat, title: string, items: Array<{ __typename?: 'CalloutItem', strapline: string, title: string, href: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> } }> }, consumerRightsFooter: { __typename?: 'LocalFooter', description: string, items: Array<{ __typename?: 'LocalFooterItem', title: string, links: Array<{ __typename?: 'Link', href: string, text: string }> }>, social: Array<{ __typename?: 'LocalFooterSocial', text: string, href: string, type: string }> } } };

export type SubVerticalHubPageQueryVariables = Exact<{
  subVerticalSlug: Scalars['String']['input'];
  context: Scalars['String']['input'];
}>;


export type SubVerticalHubPageQuery = { __typename?: 'Query', subVerticalPage: { __typename?: 'SubVerticalPage', showResubBanner: boolean, meta: { __typename?: 'Meta', title: string, desc: string, dataLayer: any, pageType: string, canonical: string, headCodeBlock: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any, subVertical: any } }, breadcrumb: { __typename?: 'Breadcrumb', baseUrl: string, heading: { __typename?: 'Link', href: string, text: string }, links: Array<{ __typename?: 'Link', href: string, text: string }>, currentPage: { __typename?: 'Link', href: string, text: string } }, hubPageContent: { __typename?: 'HubPageContent', latestNewsTag: { __typename?: 'Tag', label: string, slug: string }, mainFeaturedArticle: { __typename?: 'NewsCard', heading: string, summary: string, url: string, date: { __typename?: 'DateInfo', rendered: string, iso: string }, image: { __typename?: 'ImageWithSources', id: string, src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> } }, contentItems: Array<{ __typename?: 'HubPageContentItem', type: string, data: any }>, header: { __typename?: 'Header', title: string, intro: string } }, hubPageLatestNews: { __typename?: 'LatestNews', articles: Array<{ __typename?: 'LatestNewsArticle', title: string, href: string, imageWithSources: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, media: string, sizes: string }> }, dateInfo: { __typename?: 'DateInfo', rendered: string, iso: string }, authors: Array<{ __typename?: 'Author', name: string, image: { __typename?: 'ImageWithSources', src: string } }> }> }, sharingData: { __typename?: 'SharingData', facebook: string, twitter: string, whatsapp: string, mail: string, metaData: { __typename?: 'SharingMetaData', url: string, headline: string, fbAppId: string, facebookText: string, twitterText: string, subject: string } } } };

export type SubVerticalNewsPageQueryVariables = Exact<{
  subVerticalSlug: Scalars['String']['input'];
  context: Scalars['String']['input'];
  pageNumber: InputMaybe<Scalars['Int']['input']>;
  verticalSlug: InputMaybe<Scalars['String']['input']>;
}>;


export type SubVerticalNewsPageQuery = { __typename?: 'Query', subVerticalPage: { __typename?: 'SubVerticalPage', showResubBanner: boolean, meta: { __typename?: 'Meta', title: string, desc: string, dataLayer: any, pageType: string, canonical: string, headCodeBlock: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any, subVertical: any } }, breadcrumb: { __typename?: 'Breadcrumb', baseUrl: string, heading: { __typename?: 'Link', href: string, text: string }, links: Array<{ __typename?: 'Link', href: string, text: string }>, currentPage: { __typename?: 'Link', href: string, text: string } }, header: { __typename?: 'Header', title: string, intro: string }, taxonomyHierarchyWithCounts: { __typename?: 'TaxonomyHierarchyWithCounts', slug: string, name: string, count: number, categories: Array<{ __typename?: 'TaxonomyWithCounts', slug: string, name: string, count: number }> }, newsArticles: { __typename?: 'NewsArticles', pagedArticles: { __typename?: 'PagedFlatArticles', total: number, articles: Array<{ __typename?: 'BaseNewsArticleListingData', headline: string, summary: string, url: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> }, primaryTaxonomy: { __typename?: 'PrimaryTaxonomy', name: string, url: string }, updatedDate: { __typename?: 'DateInfo', rendered: string, iso: string } }> } } } };

export type SubVerticalPolicyAndInsightLandingQueryVariables = Exact<{
  subVerticalSlug: Scalars['String']['input'];
  context: Scalars['String']['input'];
}>;


export type SubVerticalPolicyAndInsightLandingQuery = { __typename?: 'Query', subVerticalPage: { __typename?: 'SubVerticalPage', showResubBanner: boolean, meta: { __typename?: 'Meta', title: string, desc: string, dataLayer: any, pageType: string, canonical: string, headCodeBlock: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any, subVertical: any } }, breadcrumb: { __typename?: 'Breadcrumb', baseUrl: string, heading: { __typename?: 'Link', href: string, text: string }, links: Array<{ __typename?: 'Link', href: string, text: string }>, currentPage: { __typename?: 'Link', href: string, text: string } }, policyAndInsightLandingCollection: { __typename?: 'PolicyAndInsightLandingContent', contentItems: Array<{ __typename?: 'PolicyAndInsightLandingContentItem', type: string, data: any }>, meta: { __typename?: 'PolicyAndInsightLandingMeta', title: string, description: string, image: string } } } };

export type SubVerticalReviewsPageQueryVariables = Exact<{
  subVerticalSlug: Scalars['String']['input'];
  context: Scalars['String']['input'];
}>;


export type SubVerticalReviewsPageQuery = { __typename?: 'Query', subVerticalPage: { __typename?: 'SubVerticalPage', showResubBanner: boolean, meta: { __typename?: 'Meta', title: string, desc: string, dataLayer: any, pageType: string, canonical: string, headCodeBlock: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any, subVertical: any } }, breadcrumb: { __typename?: 'Breadcrumb', baseUrl: string, heading: { __typename?: 'Link', href: string, text: string }, links: Array<{ __typename?: 'Link', href: string, text: string }>, currentPage: { __typename?: 'Link', href: string, text: string } }, header: { __typename?: 'Header', title: string, intro: string, backgroundColour: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, media: string, sizes: string }> }, links: Array<{ __typename?: 'Link', href: string, text: string }> }, taxonomyConversionBanner: { __typename?: 'TaxonomyConversionBanner', title: string, description: string, descriptionMobile: string, buttonText: string, buttonURL: string }, reviewsCategories: { __typename?: 'ReviewsCategories', jumpLinks: { __typename?: 'JumpLinks', links: Array<{ __typename?: 'JumpLink', id: number, label: string, slug: string }> }, sections: Array<{ __typename?: 'SuperCategorySection', sectionId: string, id: number, collectionName: string, cards: Array<{ __typename?: 'SuperCategorySectionCard', titleLink: string, heading: string, link: { __typename?: 'Link', href: string, text: string }, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, media: string, sizes: string }> }, items: Array<{ __typename?: 'CardItem', href: string, text: string, linkType: string }> }> }> }, subVerticalOptionalData: { __typename?: 'SubVerticalOptionalData', components: { __typename?: 'OptionalComponents', bannerSignUpComponentData: { __typename?: 'BannerSignUp', title: string, text: string, linkText: string, linkUrl: string, backgroundColour: string, facebookUrl: string, twitterUrl: string, buttonType: string, image: { __typename?: 'ImageWithSources', src: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, media: string, type: string, sizes: string }> } }, toolCTA: { __typename?: 'ToolCta', title: string, description: string, widgetImageAspectRatio: WidgetImageAspectRatio, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, media: string, type: string, sizes: string }> }, button: { __typename?: 'Link', href: string, text: string }, linksListExpandableData: { __typename?: 'LinksListExpandableData', button: { __typename?: 'LinksButton', text: string, ariaLabel: string }, items: Array<{ __typename?: 'CtaItems', href: string, label: string }> } }, relatedGuides: { __typename?: 'RelatedGuides', title: string, guides: Array<{ __typename?: 'SuperCategorySectionCard', heading: string, items: Array<{ __typename?: 'CardItem', href: string, text: string }>, link: { __typename?: 'Link', href: string, text: string } }> }, localFooter: { __typename?: 'LocalFooter', description: string, items: Array<{ __typename?: 'LocalFooterItem', title: string, links: Array<{ __typename?: 'Link', href: string, text: string }> }>, social: Array<{ __typename?: 'LocalFooterSocial', text: string, href: string, type: string }> } } }, latestNews: { __typename?: 'LatestNews', name: string, articles: Array<{ __typename?: 'LatestNewsArticle', title: string, href: string, dateInfo: { __typename?: 'DateInfo', rendered: string, iso: string }, imageWithSources: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, media: string, sizes: string }> } }> }, categoryLinks: Array<{ __typename?: 'LinkBlock', href: string, children: string }> } };

export type ToolsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type ToolsPageQuery = { __typename?: 'Query', toolsPage: { __typename?: 'ToolPage', transformTypeDecision: string, consumerRightsFooter: { __typename?: 'LocalFooter', description: string, items: Array<{ __typename?: 'LocalFooterItem', title: string, links: Array<{ __typename?: 'Link', href: string, text: string }> }>, social: Array<{ __typename?: 'LocalFooterSocial', text: string, href: string, type: string }> } } };

export type NewsListingVerticalQueryVariables = Exact<{
  verticalSlug: Scalars['String']['input'];
  pageNumber: InputMaybe<Scalars['Int']['input']>;
}>;


export type NewsListingVerticalQuery = { __typename?: 'Query', verticalPage: { __typename: 'VerticalPage', meta: { __typename?: 'Meta', title: string, desc: string, fbAppId: string, dataLayer: any, pageType: string, canonical: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any } }, header: { __typename?: 'VerticalHeader', title: string, description: string, standfirst: string }, newsArticles: { __typename?: 'NewsArticles', pagedArticles: { __typename?: 'PagedFlatArticles', total: number, articles: Array<{ __typename?: 'BaseNewsArticleListingData', headline: string, summary: string, url: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> }, primaryTaxonomy: { __typename?: 'PrimaryTaxonomy', name: string, url: string }, updatedDate: { __typename?: 'DateInfo', rendered: string, iso: string } }> } } } };

export type NewsVerticalQueryVariables = Exact<{
  verticalSlug: Scalars['String']['input'];
}>;


export type NewsVerticalQuery = { __typename?: 'Query', verticalPage: { __typename: 'VerticalPage', meta: { __typename?: 'Meta', title: string, desc: string, fbAppId: string, dataLayer: any, pageType: string, canonical: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any } }, header: { __typename?: 'VerticalHeader', title: string, description: string, standfirst: string }, latestNews: { __typename?: 'LatestNews', name: string, articles: Array<{ __typename?: 'LatestNewsArticle', title: string, href: string, imageWithSources: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> }, dateInfo: { __typename?: 'DateInfo', rendered: string, iso: string } }> }, newsCardsCollections: { __typename?: 'NewsCardsCollections', mainFeaturedArticle: { __typename?: 'NewsCard', heading: string, summary: string, url: string, date: { __typename?: 'DateInfo', rendered: string, iso: string }, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> } }, mostReadArticles: { __typename?: 'MostReadArticles', title: string, links: Array<{ __typename?: 'Link', href: string, text: string }> }, collections: Array<{ __typename?: 'NewsCardsCollectionItem', taxonomy: { __typename?: 'NewsCollectionTaxonomy', name: string, slug: string }, featuredArticle: { __typename?: 'NewsCard', heading: string, summary: string, url: string, date: { __typename?: 'DateInfo', rendered: string, iso: string }, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> } }, cards: Array<{ __typename?: 'NewsCard', heading: string, url: string, date: { __typename?: 'DateInfo', rendered: string, iso: string }, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> } }> }> } } };

export type ReviewsVerticalQueryVariables = Exact<{
  verticalSlug: Scalars['String']['input'];
}>;


export type ReviewsVerticalQuery = { __typename?: 'Query', verticalPage: { __typename: 'VerticalPage', showResubBanner: boolean, meta: { __typename?: 'Meta', title: string, desc: string, fbAppId: string, dataLayer: any, pageType: string, canonical: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any } }, header: { __typename?: 'VerticalHeader', description: string, title: string, standfirst: string, backgroundColour: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, media: string, sizes: string }> }, links: Array<{ __typename?: 'Link', href: string, text: string }> }, subVerticalLinks: { __typename?: 'SubVerticalLinks', name: string, links: Array<{ __typename?: 'LinkBlock', href: string, children: string }> }, adviceCards: { __typename?: 'AdviceCards', heading: string, cards: Array<{ __typename?: 'AdviceCard', href: string, linkText: string, strapline: string, title: string }> }, articleCards: { __typename?: 'ArticleCards', heading: string, cards: Array<{ __typename?: 'ArticleCard', heading: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> }, links: Array<{ __typename?: 'Link', href: string, text: string }>, viewAll: { __typename?: 'Link', href: string, text: string } }> }, latestNews: { __typename?: 'LatestNews', name: string, articles: Array<{ __typename?: 'LatestNewsArticle', title: string, href: string, imageWithSources: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> }, dateInfo: { __typename?: 'DateInfo', rendered: string } }> }, optionalData: { __typename?: 'OptionalData', components: { __typename?: 'ComponentsData', newsletterSignUpWithImage: { __typename?: 'NewsletterSignUpCollectionItem', source: string, image: { __typename?: 'ImageWithSources', alt: string, caption: string, id: string, src: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> } }, podcastComponentData: { __typename?: 'PodcastComponentData', header: string, title: string, info: string, iframeContent: string, link: { __typename?: 'Link', href: string, text: string } }, bannerSignUpComponentData: { __typename?: 'BannerSignUp', title: string, text: string, linkText: string, linkUrl: string, backgroundColour: string, facebookUrl: string, twitterUrl: string, buttonType: string, image: { __typename?: 'ImageWithSources', src: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, media: string, type: string, sizes: string }> } } } } } };

export type VerticalAboutWhichPageQueryVariables = Exact<{
  verticalSlug: Scalars['String']['input'];
}>;


export type VerticalAboutWhichPageQuery = { __typename?: 'Query', verticalPage: { __typename: 'VerticalPage', showResubBanner: boolean, meta: { __typename?: 'Meta', title: string, desc: string, fbAppId: string, dataLayer: any, pageType: string, canonical: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any } }, header: { __typename?: 'VerticalHeader', description: string, title: string, standfirst: string, backgroundColour: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, media: string, sizes: string }> }, links: Array<{ __typename?: 'Link', href: string, text: string }> }, subVerticalLinks: { __typename?: 'SubVerticalLinks', name: string, links: Array<{ __typename?: 'LinkBlock', href: string, children: string }> }, adviceCards: { __typename?: 'AdviceCards', heading: string, cards: Array<{ __typename?: 'AdviceCard', href: string, linkText: string, strapline: string, title: string }> }, taxonomyConversionBanner: { __typename?: 'TaxonomyConversionBanner', title: string, description: string, descriptionMobile: string, buttonText: string, buttonURL: string }, aboutWhich: { __typename?: 'AboutWhich', subVerticalArticles: Array<{ __typename?: 'AboutWhichLink', url: string, title: string, description: string, image: string }>, promoUrls: Array<{ __typename?: 'AboutWhichLink', url: string, title: string, description: string, image: string }>, moreArticles: { __typename?: 'AboutWhichCardLinks', heading: string, cards: Array<{ __typename?: 'AboutWhichMoreLink', url: string, title: string, description: string, image: string, updatedAt: string }> } } } };

export type VerticalCampaignsPageQueryVariables = Exact<{
  verticalSlug: Scalars['String']['input'];
}>;


export type VerticalCampaignsPageQuery = { __typename?: 'Query', verticalPage: { __typename: 'VerticalPage', meta: { __typename?: 'Meta', title: string, desc: string, fbAppId: string, dataLayer: any, pageType: string, canonical: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any } }, campaignsHomepageContent: { __typename?: 'CampaignsHomepageContent', contentItems: Array<{ __typename?: 'CampaignsHomepageContentItem', type: string, data: any }> } } };

export type VerticalCrPageQueryVariables = Exact<{
  verticalSlug: Scalars['String']['input'];
}>;


export type VerticalCrPageQuery = { __typename?: 'Query', verticalPage: { __typename: 'VerticalPage', showResubBanner: boolean, meta: { __typename?: 'Meta', title: string, desc: string, fbAppId: string, dataLayer: any, pageType: string, canonical: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any } }, header: { __typename?: 'VerticalHeader', description: string, title: string, standfirst: string, backgroundColour: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, media: string, sizes: string }> }, links: Array<{ __typename?: 'Link', href: string, text: string }> }, subVerticalLinks: { __typename?: 'SubVerticalLinks', name: string, links: Array<{ __typename?: 'LinkBlock', href: string, children: string }> }, adviceCards: { __typename?: 'AdviceCards', heading: string, cards: Array<{ __typename?: 'AdviceCard', href: string, linkText: string, strapline: string, title: string }> }, taxonomyConversionBanner: { __typename?: 'TaxonomyConversionBanner', title: string, description: string, descriptionMobile: string, buttonText: string, buttonURL: string }, breadcrumb: { __typename?: 'Breadcrumb', baseUrl: string, heading: { __typename?: 'Link', href: string, text: string }, links: Array<{ __typename?: 'Link', href: string, text: string }>, currentPage: { __typename?: 'Link', href: string, text: string } }, callout: { __typename?: 'Callout', byline: string, description: string, imageFormat: ImageFormat, title: string, items: Array<{ __typename?: 'CalloutItem', strapline: string, title: string, href: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> } }> }, consumerRegulations: { __typename?: 'ConsumerRegulations', title: string, items: Array<{ __typename?: 'ConsumerRegulationsArticles', title: string, href: string, standfirst: string, authors: Array<{ __typename?: 'Author', name: string, image: { __typename?: 'ImageWithSources', src: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> } }> }>, all: { __typename?: 'Link', href: string, text: string } }, consumerRightsFooter: { __typename?: 'LocalFooter', description: string, items: Array<{ __typename?: 'LocalFooterItem', title: string, links: Array<{ __typename?: 'Link', href: string, text: string }> }>, social: Array<{ __typename?: 'LocalFooterSocial', text: string, href: string, type: string }> }, latestNews: { __typename?: 'LatestNews', name: string, articles: Array<{ __typename?: 'LatestNewsArticle', title: string, href: string, imageWithSources: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> }, authors: Array<{ __typename?: 'Author', name: string, image: { __typename?: 'ImageWithSources', src: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> } }> }> } } };

export type VerticalMyAppointmentsPageQueryVariables = Exact<{
  verticalSlug: Scalars['String']['input'];
}>;


export type VerticalMyAppointmentsPageQuery = { __typename?: 'Query', verticalPage: { __typename: 'VerticalPage', meta: { __typename?: 'Meta', title: string, desc: string, fbAppId: string, dataLayer: any, pageType: string, canonical: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any } }, header: { __typename?: 'VerticalHeader', title: string, description: string, standfirst: string } } };

export type VerticalNewsFullListingPageQueryVariables = Exact<{
  verticalSlug: Scalars['String']['input'];
  pageNumber: InputMaybe<Scalars['Int']['input']>;
}>;


export type VerticalNewsFullListingPageQuery = { __typename?: 'Query', verticalPage: { __typename: 'VerticalPage', meta: { __typename?: 'Meta', title: string, desc: string, fbAppId: string, dataLayer: any, pageType: string, canonical: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any } }, header: { __typename?: 'VerticalHeader', title: string, description: string, standfirst: string }, newsArticles: { __typename?: 'NewsArticles', pagedArticles: { __typename?: 'PagedFlatArticles', total: number, articles: Array<{ __typename?: 'BaseNewsArticleListingData', headline: string, summary: string, url: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> }, primaryTaxonomy: { __typename?: 'PrimaryTaxonomy', name: string, url: string }, updatedDate: { __typename?: 'DateInfo', rendered: string, iso: string } }> } } } };

export type VerticalNewsPageQueryVariables = Exact<{
  verticalSlug: Scalars['String']['input'];
}>;


export type VerticalNewsPageQuery = { __typename?: 'Query', verticalPage: { __typename: 'VerticalPage', meta: { __typename?: 'Meta', title: string, desc: string, fbAppId: string, dataLayer: any, pageType: string, canonical: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any } }, header: { __typename?: 'VerticalHeader', title: string, description: string, standfirst: string }, latestNews: { __typename?: 'LatestNews', name: string, articles: Array<{ __typename?: 'LatestNewsArticle', title: string, href: string, imageWithSources: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> }, dateInfo: { __typename?: 'DateInfo', rendered: string, iso: string } }> }, newsCardsCollections: { __typename?: 'NewsCardsCollections', mainFeaturedArticle: { __typename?: 'NewsCard', heading: string, summary: string, url: string, date: { __typename?: 'DateInfo', rendered: string, iso: string }, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> } }, mostReadArticles: { __typename?: 'MostReadArticles', title: string, links: Array<{ __typename?: 'Link', href: string, text: string }> }, collections: Array<{ __typename?: 'NewsCardsCollectionItem', taxonomy: { __typename?: 'NewsCollectionTaxonomy', name: string, slug: string }, featuredArticle: { __typename?: 'NewsCard', heading: string, summary: string, url: string, date: { __typename?: 'DateInfo', rendered: string, iso: string }, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> } }, cards: Array<{ __typename?: 'NewsCard', heading: string, url: string, date: { __typename?: 'DateInfo', rendered: string, iso: string }, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> } }> }> } } };

export type VerticalPensionSchemePageQueryVariables = Exact<{
  verticalSlug: Scalars['String']['input'];
}>;


export type VerticalPensionSchemePageQuery = { __typename?: 'Query', verticalPage: { __typename: 'VerticalPage', showResubBanner: boolean, meta: { __typename?: 'Meta', title: string, desc: string, fbAppId: string, dataLayer: any, pageType: string, canonical: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any } }, header: { __typename?: 'VerticalHeader', description: string, title: string, standfirst: string, backgroundColour: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, media: string, sizes: string }> }, links: Array<{ __typename?: 'Link', href: string, text: string }> }, subVerticalLinks: { __typename?: 'SubVerticalLinks', name: string, links: Array<{ __typename?: 'LinkBlock', href: string, children: string }> }, adviceCards: { __typename?: 'AdviceCards', heading: string, cards: Array<{ __typename?: 'AdviceCard', href: string, linkText: string, strapline: string, title: string }> }, taxonomyConversionBanner: { __typename?: 'TaxonomyConversionBanner', title: string, description: string, descriptionMobile: string, buttonText: string, buttonURL: string }, pensionScheme: { __typename?: 'PensionScheme', subVerticalArticles: Array<{ __typename?: 'AboutWhichLink', url: string, title: string, description: string, image: string }>, promoUrls: Array<{ __typename?: 'AboutWhichLink', url: string, title: string, description: string, image: string }>, moreArticles: { __typename?: 'AboutWhichCardLinks', heading: string, cards: Array<{ __typename?: 'AboutWhichMoreLink', url: string, title: string, description: string, image: string, updatedAt: string }> } } } };

export type VerticalPolicyAndInsightPageQueryVariables = Exact<{
  verticalSlug: Scalars['String']['input'];
}>;


export type VerticalPolicyAndInsightPageQuery = { __typename?: 'Query', verticalPage: { __typename: 'VerticalPage', meta: { __typename?: 'Meta', title: string, desc: string, fbAppId: string, dataLayer: any, pageType: string, canonical: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any } }, header: { __typename?: 'VerticalHeader', title: string, description: string, standfirst: string }, policyAndInsightCategories: { __typename?: 'PolicyAndInsightCategories', categories: Array<{ __typename?: 'Categories', name: string, slug: string }> }, policyAndInsightCardsCollections: { __typename?: 'PolicyAndInsightCardsCollections', collections: Array<{ __typename?: 'PolicyAndInsightCardsCollectionItem', taxonomy: { __typename?: 'PolicyAndInsightCollectionTaxonomy', name: string, slug: string }, cards: Array<{ __typename?: 'PolicyAndInsightCard', estimatedReadingTime: string, heading: string, summary: string, publishedAt: string, url: string, title: string, standfirst: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> }, topicHeading: { __typename?: 'TopicHeading', text: string, icon: string, category: string } }> }>, hero: { __typename?: 'PolicyAndInsightHero', taxonomy: { __typename?: 'PolicyAndInsightCollectionTaxonomy', name: string, slug: string }, cards: Array<{ __typename?: 'PolicyAndInsightHeroCard', title: string, linkUrl: string, standfirst: string, ariaLabel: string, buttonText: string, image: { __typename?: 'ImageWithSources', src: string, alt: string } }> } } } };

export type VerticalReviewsPageQueryVariables = Exact<{
  verticalSlug: Scalars['String']['input'];
}>;


export type VerticalReviewsPageQuery = { __typename?: 'Query', verticalPage: { __typename: 'VerticalPage', showResubBanner: boolean, meta: { __typename?: 'Meta', title: string, desc: string, fbAppId: string, dataLayer: any, pageType: string, canonical: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any } }, header: { __typename?: 'VerticalHeader', description: string, title: string, standfirst: string, backgroundColour: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, media: string, sizes: string }> }, links: Array<{ __typename?: 'Link', href: string, text: string }> }, subVerticalLinks: { __typename?: 'SubVerticalLinks', name: string, links: Array<{ __typename?: 'LinkBlock', href: string, children: string }> }, adviceCards: { __typename?: 'AdviceCards', heading: string, cards: Array<{ __typename?: 'AdviceCard', href: string, linkText: string, strapline: string, title: string }> }, taxonomyConversionBanner: { __typename?: 'TaxonomyConversionBanner', title: string, description: string, descriptionMobile: string, buttonText: string, buttonURL: string }, articleCards: { __typename?: 'ArticleCards', heading: string, cards: Array<{ __typename?: 'ArticleCard', heading: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> }, links: Array<{ __typename?: 'Link', href: string, text: string }>, viewAll: { __typename?: 'Link', href: string, text: string } }> }, latestNews: { __typename?: 'LatestNews', name: string, articles: Array<{ __typename?: 'LatestNewsArticle', title: string, href: string, imageWithSources: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> }, dateInfo: { __typename?: 'DateInfo', rendered: string } }> }, optionalData: { __typename?: 'OptionalData', components: { __typename?: 'ComponentsData', newsletterSignUpWithImage: { __typename?: 'NewsletterSignUpCollectionItem', source: string, image: { __typename?: 'ImageWithSources', alt: string, caption: string, id: string, src: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, sizes: string }> } }, podcastComponentData: { __typename?: 'PodcastComponentData', header: string, title: string, info: string, iframeContent: string, link: { __typename?: 'Link', href: string, text: string } }, bannerSignUpComponentData: { __typename?: 'BannerSignUp', title: string, text: string, linkText: string, linkUrl: string, backgroundColour: string, facebookUrl: string, twitterUrl: string, buttonType: string, image: { __typename?: 'ImageWithSources', src: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, media: string, type: string, sizes: string }> } } } } } };

export type VerticalSitemapPageQueryVariables = Exact<{
  verticalSlug: Scalars['String']['input'];
}>;


export type VerticalSitemapPageQuery = { __typename?: 'Query', verticalPage: { __typename: 'VerticalPage', showResubBanner: boolean, meta: { __typename?: 'Meta', title: string, desc: string, fbAppId: string, dataLayer: any, pageType: string, canonical: string, taxonomyHierarchy: { __typename?: 'TaxonomyHierarchy', vertical: any } }, header: { __typename?: 'VerticalHeader', description: string, title: string, standfirst: string, backgroundColour: string, image: { __typename?: 'ImageWithSources', src: string, alt: string, sources: Array<{ __typename?: 'ImageSources', srcset: string, media: string, sizes: string }> }, links: Array<{ __typename?: 'Link', href: string, text: string }> }, subVerticalLinks: { __typename?: 'SubVerticalLinks', name: string, links: Array<{ __typename?: 'LinkBlock', href: string, children: string }> }, adviceCards: { __typename?: 'AdviceCards', heading: string, cards: Array<{ __typename?: 'AdviceCard', href: string, linkText: string, strapline: string, title: string }> }, taxonomyConversionBanner: { __typename?: 'TaxonomyConversionBanner', title: string, description: string, descriptionMobile: string, buttonText: string, buttonURL: string }, sitemapMenu: { __typename?: 'SitemapMenu', name: string, items: Array<{ __typename?: 'SitemapMenuItems', label: string, url: string, children: Array<{ __typename?: 'SitemapMenuItems', label: string, url: string, children: Array<{ __typename?: 'SitemapMenuItems', label: string, url: string }> }> }> } } };

export type SavedItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type SavedItemsQuery = { __typename?: 'Query', savedItems: Array<{ __typename?: 'SavedItem', categorySlug: string, products: Array<{ __typename?: 'SavedProduct', id: string, saveId: string }> }> };

export type CreateCaseInSfMutationVariables = Exact<{
  formRequest: FormRequest;
}>;


export type CreateCaseInSfMutation = { __typename?: 'Mutation', createCaseInSF: { __typename?: 'createCaseInSF', status: string } };

export type IsMigratedMemberQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type IsMigratedMemberQuery = { __typename?: 'Query', isMigratedMember: { __typename?: 'isMigratedMember', status: string, response: any } };

export type GamPersonalisationInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GamPersonalisationInfoQuery = { __typename?: 'Query', personalisationInfo: { __typename?: 'PersonalisationInfo', newsletterSignups: Array<string>, newsletterRecommendation: string } };

export type CreateGardeningCaseInSfMutationVariables = Exact<{
  formRequest: GardeningFormRequest;
}>;


export type CreateGardeningCaseInSfMutation = { __typename?: 'Mutation', createGardeningCaseInSF: { __typename?: 'createGardeningCaseInSF', status: string, caseId: string } };

export type RecentlyViewedQueryVariables = Exact<{ [key: string]: never; }>;


export type RecentlyViewedQuery = { __typename?: 'Query', signupCompletePage: { __typename?: 'SignupCompletePage', recentlyViewed: { __typename?: 'RecentlyViewed', content: Array<{ __typename: 'Article', id: number, glide_id: string, url: string, path: string, headline: string, short_headline: string, standfirst: string, short_standfirst: string, published_at: string, updated_at: string, type: string, promo_image_url: string, article_type: { __typename?: 'ArticleType', name: string, id: number } } | { __typename: 'Product', imageUrl: string, productUrl: string, hasRetailers: boolean, badges: Array<string>, businessKey: string, model: string, slug: string, pros: Array<string>, cons: Array<string>, manufacturer: { __typename?: 'Manufacturer', name: string }, category: { __typename?: 'Category', slug: string }, price: { __typename?: 'Price', formatted: string }, testScore: { __typename?: 'TestScore', overallScore: number, textVariation: string } }> } } };

export type RecommendedForYouQueryVariables = Exact<{ [key: string]: never; }>;


export type RecommendedForYouQuery = { __typename?: 'Query', homePage: { __typename?: 'HomePage', recommendations: { __typename?: 'Recommendations', models: Array<{ __typename?: 'RecommendedModel', model: string, content: Array<{ __typename: 'RecommendedArticle', type: string, id: string, href: string, title: string, subheading: string, image: string } | { __typename: 'RecommendedProduct' }> }> } } };

export type ResubscribeBannerPersonalisationInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type ResubscribeBannerPersonalisationInfoQuery = { __typename?: 'Query', personalisationInfo: { __typename?: 'PersonalisationInfo', enableWinbackOffer: boolean } };

export type CreateTechSupportCaseInSfMutationVariables = Exact<{
  formRequest: TechSupportFormRequest;
}>;


export type CreateTechSupportCaseInSfMutation = { __typename?: 'Mutation', createTechSupportCaseInSF: { __typename?: 'createTechSupportCaseInSF', status: string, caseId: string } };

export type AddSavedItemMutationVariables = Exact<{
  item: SavedItemDetails;
}>;


export type AddSavedItemMutation = { __typename?: 'Mutation', addSavedItem: { __typename?: 'SavedItemError', success: boolean, errorResponse: string } | { __typename?: 'SavedItemSuccess', success: boolean } };

export type RemoveSavedItemMutationVariables = Exact<{
  itemId: Scalars['String']['input'];
}>;


export type RemoveSavedItemMutation = { __typename?: 'Mutation', removeSavedItem: { __typename?: 'SavedItemError', success: boolean, errorResponse: string } | { __typename?: 'SavedItemSuccess', success: boolean } };

export const BaseArticleListingFragmentFragmentDoc = gql`
    fragment BaseArticleListingFragment on ArticleListingPage {
  meta {
    title
    desc
    dataLayer
    pageType
    taxonomyHierarchy {
      vertical
      subVertical
      category
      superCategory
    }
    canonical
  }
  breadcrumb {
    heading {
      href
      text
    }
    links {
      href
      text
    }
    currentPage {
      href
      text
    }
    baseUrl
  }
  taxonomyConversionBanner {
    title
    description
    descriptionMobile
    buttonText
    buttonURL
  }
  showResubBanner
}
    `;
export const BaseFragmentFragmentDoc = gql`
    fragment BaseFragment on ArticlePage {
  articleBodyTemplate
  meta {
    title
    desc
    contentId
    dataLayer
    facebookDesc
    facebookImage
    facebookTitle
    fbAppId
    twitterDesc
    twitterImage
    twitterTitle
    pageType
    taxonomyHierarchy {
      vertical
      subVertical
      category
      superCategory
    }
    keywords
    canonical
    headCodeBlock
    publishedDate
    publishedDateTime
    updatedDateTime
    systemContentPublishedDate
    systemContentUpdatedDate
    glideCurationDate
    frequencyOfUpdate
    reviewSchema
    significantUpdate
  }
  breadcrumb {
    heading {
      href
      text
    }
    links {
      href
      text
    }
    currentPage {
      href
      text
    }
    baseUrl
  }
  showResubBanner
}
    `;
export const ReviewsBaseFragmentFragmentDoc = gql`
    fragment ReviewsBaseFragment on ArticlePage {
  articleConfig {
    affiliateDisclaimer
    whichConnectMessage
    articleArea
    articleType
    adviceType
    inlinePageScripts
  }
  authors {
    name
    jobTitle
    image {
      src
      sources {
        srcset
        sizes
      }
    }
    slug
    about
  }
  jumpLinks {
    name
    slug
  }
  header {
    headline
    addMarginOffsetClass
    standfirst
    date {
      rendered
      iso
    }
  }
  introParagraph
  sharingData {
    facebook
    twitter
    whatsapp
    mail
    metaData {
      url
      headline
      fbAppId
      facebookText
      twitterText
      subject
    }
  }
  heroImage {
    src
    alt
    caption
    renditions
    sources {
      srcset
      sizes
    }
    dimensions {
      width
      height
    }
  }
  relatedProducts {
    categorySlug
    categoryLabel
    categoryLabelSingular
    products {
      slug
      price {
        formatted
        label
      }
      model
      badges
      overallScore
      manufacturer
      hasRetailers
      imageSrc
      label
      textVariation
      toolTip {
        ariaLabel
        contents
      }
    }
  }
  latestNews {
    name
    articles {
      title
      dateInfo {
        rendered
        iso
      }
      imageWithSources {
        src
        alt
        sources {
          srcset
          media
          sizes
        }
      }
      href
    }
  }
  onwardJourney {
    component
    props {
      title
      description
      image {
        alt
        src
        sources {
          srcset
          sizes
        }
      }
    }
  }
  optionalArticleData {
    components {
      localFooter {
        description
        items {
          title
          links {
            text
            href
          }
        }
        social {
          text
          href
          type
        }
      }
      moneyPromoBlock {
        title
        description
        ctaLabel
        ctaLink
      }
    }
  }
  heroCTA {
    title
    button_url
    component
    button_text
    link_anchor
    caption_text
    description
    image_alt_text
    links_list_label
    secondary_tool_url
    links_list_aria_label
    widget_image_aspect_ratio
  }
}
    `;
export const BaseSubVerticalPageFragmentFragmentDoc = gql`
    fragment BaseSubVerticalPageFragment on SubVerticalPage {
  meta {
    title
    desc
    dataLayer
    pageType
    taxonomyHierarchy {
      vertical
      subVertical
    }
    canonical
    headCodeBlock
  }
  breadcrumb {
    heading {
      href
      text
    }
    links {
      href
      text
    }
    currentPage {
      href
      text
    }
    baseUrl
  }
  showResubBanner
}
    `;
export const BaseVerticalFragmentFragmentDoc = gql`
    fragment BaseVerticalFragment on VerticalPage {
  meta {
    title
    desc
    fbAppId
    dataLayer
    pageType
    canonical
    taxonomyHierarchy {
      vertical
    }
  }
  header {
    description
    title
    image {
      src
      sources {
        srcset
        media
        sizes
      }
      alt
    }
    standfirst
    links {
      href
      text
    }
    backgroundColour
  }
  subVerticalLinks {
    name
    links {
      href
      children
    }
  }
  adviceCards {
    heading
    cards {
      href
      linkText
      strapline
      title
    }
  }
  taxonomyConversionBanner {
    title
    description
    descriptionMobile
    buttonText
    buttonURL
  }
  showResubBanner
}
    `;
export const ForgotPasswordDocument = gql`
    mutation forgotPassword($email: String!) {
  forgotPassword(email: $email) {
    ... on ForgotPasswordSuccess {
      __typename
      status
      isRedirectToKinde
    }
    ... on ForgotPasswordError {
      __typename
      status
      isRedirectToKinde
    }
  }
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const LoginDocument = gql`
    mutation login($username: String!, $password: String!) {
  login(username: $username, password: $password) {
    ... on Authentication {
      __typename
      loginStatus
      response
      responseProfile
      responseSF
      headers
    }
    ... on AuthenticationError {
      __typename
      loginStatus
    }
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      username: // value for 'username'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const RegisterDocument = gql`
    mutation register($registerRequest: RegisterRequest!) {
  register(registerRequest: $registerRequest) {
    ... on Registration {
      __typename
      status
      headers
      masterId
    }
    ... on RegistrationError {
      __typename
      status
    }
  }
}
    `;
export type RegisterMutationFn = Apollo.MutationFunction<RegisterMutation, RegisterMutationVariables>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      registerRequest: // value for 'registerRequest'
 *   },
 * });
 */
export function useRegisterMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMutation, RegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, options);
      }
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<RegisterMutation, RegisterMutationVariables>;
export const ArticleListingCrPageDocument = gql`
    query articleListingCRPage($subVerticalSlug: String!, $categorySlug: String!, $context: String!, $url: String!) {
  articleListingPage(
    subVerticalSlug: $subVerticalSlug
    categorySlug: $categorySlug
    context: $context
    url: $url
  ) {
    __typename
    ...BaseArticleListingFragment
    consumerRightsArticles {
      featuredArticles {
        headline
        summary
        url
        image {
          src
          sources {
            srcset
            sizes
          }
          alt
        }
        authors {
          name
          jobTitle
          image {
            src
            sources {
              sizes
              srcset
            }
          }
        }
      }
      nonFeaturedArticles {
        headline
        summary
        url
        authors {
          name
          jobTitle
          image {
            src
            sources {
              sizes
              srcset
            }
          }
        }
      }
      letterArticles {
        title
        articles {
          title
          href
          strapline
        }
      }
      regulationArticles {
        title
        articles {
          title
          href
          strapline
        }
      }
    }
    consumerRightsFooter {
      title
      description
      items {
        title
        links {
          text
          href
        }
      }
      social {
        text
        href
        type
      }
    }
    callout {
      byline
      description
      imageFormat
      title
      items {
        image {
          alt
          src
          sources {
            srcset
            sizes
          }
        }
        strapline
        title
        href
      }
    }
    header {
      name
      description
    }
  }
}
    ${BaseArticleListingFragmentFragmentDoc}`;

/**
 * __useArticleListingCrPageQuery__
 *
 * To run a query within a React component, call `useArticleListingCrPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleListingCrPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleListingCrPageQuery({
 *   variables: {
 *      subVerticalSlug: // value for 'subVerticalSlug'
 *      categorySlug: // value for 'categorySlug'
 *      context: // value for 'context'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useArticleListingCrPageQuery(baseOptions: Apollo.QueryHookOptions<ArticleListingCrPageQuery, ArticleListingCrPageQueryVariables> & ({ variables: ArticleListingCrPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArticleListingCrPageQuery, ArticleListingCrPageQueryVariables>(ArticleListingCrPageDocument, options);
      }
export function useArticleListingCrPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArticleListingCrPageQuery, ArticleListingCrPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArticleListingCrPageQuery, ArticleListingCrPageQueryVariables>(ArticleListingCrPageDocument, options);
        }
export function useArticleListingCrPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ArticleListingCrPageQuery, ArticleListingCrPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ArticleListingCrPageQuery, ArticleListingCrPageQueryVariables>(ArticleListingCrPageDocument, options);
        }
export type ArticleListingCrPageQueryHookResult = ReturnType<typeof useArticleListingCrPageQuery>;
export type ArticleListingCrPageLazyQueryHookResult = ReturnType<typeof useArticleListingCrPageLazyQuery>;
export type ArticleListingCrPageSuspenseQueryHookResult = ReturnType<typeof useArticleListingCrPageSuspenseQuery>;
export type ArticleListingCrPageQueryResult = Apollo.QueryResult<ArticleListingCrPageQuery, ArticleListingCrPageQueryVariables>;
export const ArticleListingAuthorPageDocument = gql`
    query articleListingAuthorPage($verticalSlug: String!, $filterSlug: String!, $filterValue: String!, $context: String!, $pageNumber: Int) {
  articleListingPage: articleListingFilteredPage(
    verticalSlug: $verticalSlug
    filterSlug: $filterSlug
    filterValue: $filterValue
    context: $context
    pageNumber: $pageNumber
  ) {
    __typename
    meta {
      title
      desc
      dataLayer
      pageType
      taxonomyHierarchy {
        vertical
        subVertical
        category
        superCategory
      }
      canonical
    }
    breadcrumb {
      heading {
        href
        text
      }
      links {
        href
        text
      }
      currentPage {
        href
        text
      }
      baseUrl
    }
    newsAuthorHeader {
      author {
        name
        jobTitle
        image {
          src
          sources {
            sizes
            srcset
          }
        }
      }
    }
    newsAuthorArticles {
      pagedArticles {
        total
        articles {
          headline
          summary
          url
          image {
            src
            alt
            sources {
              srcset
              sizes
            }
          }
          primaryTaxonomy {
            name
            url
          }
          updatedDate {
            rendered
            iso
          }
        }
      }
    }
    showResubBanner
  }
}
    `;

/**
 * __useArticleListingAuthorPageQuery__
 *
 * To run a query within a React component, call `useArticleListingAuthorPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleListingAuthorPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleListingAuthorPageQuery({
 *   variables: {
 *      verticalSlug: // value for 'verticalSlug'
 *      filterSlug: // value for 'filterSlug'
 *      filterValue: // value for 'filterValue'
 *      context: // value for 'context'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useArticleListingAuthorPageQuery(baseOptions: Apollo.QueryHookOptions<ArticleListingAuthorPageQuery, ArticleListingAuthorPageQueryVariables> & ({ variables: ArticleListingAuthorPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArticleListingAuthorPageQuery, ArticleListingAuthorPageQueryVariables>(ArticleListingAuthorPageDocument, options);
      }
export function useArticleListingAuthorPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArticleListingAuthorPageQuery, ArticleListingAuthorPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArticleListingAuthorPageQuery, ArticleListingAuthorPageQueryVariables>(ArticleListingAuthorPageDocument, options);
        }
export function useArticleListingAuthorPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ArticleListingAuthorPageQuery, ArticleListingAuthorPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ArticleListingAuthorPageQuery, ArticleListingAuthorPageQueryVariables>(ArticleListingAuthorPageDocument, options);
        }
export type ArticleListingAuthorPageQueryHookResult = ReturnType<typeof useArticleListingAuthorPageQuery>;
export type ArticleListingAuthorPageLazyQueryHookResult = ReturnType<typeof useArticleListingAuthorPageLazyQuery>;
export type ArticleListingAuthorPageSuspenseQueryHookResult = ReturnType<typeof useArticleListingAuthorPageSuspenseQuery>;
export type ArticleListingAuthorPageQueryResult = Apollo.QueryResult<ArticleListingAuthorPageQuery, ArticleListingAuthorPageQueryVariables>;
export const ArticleListingNewsPageDocument = gql`
    query articleListingNewsPage($subVerticalSlug: String!, $categorySlug: String!, $context: String!, $url: String!, $pageNumber: Int) {
  articleListingPage(
    subVerticalSlug: $subVerticalSlug
    categorySlug: $categorySlug
    context: $context
    url: $url
    pageNumber: $pageNumber
  ) {
    __typename
    ...BaseArticleListingFragment
    header {
      name
      description
    }
    taxonomyHierarchyWithCounts {
      slug
      name
      count
      categories {
        slug
        name
        count
      }
    }
    newsArticles {
      pagedArticles {
        total
        articles {
          headline
          summary
          url
          image {
            src
            alt
            sources {
              srcset
              sizes
            }
          }
          primaryTaxonomy {
            name
            url
          }
          updatedDate {
            rendered
            iso
          }
        }
      }
    }
  }
}
    ${BaseArticleListingFragmentFragmentDoc}`;

/**
 * __useArticleListingNewsPageQuery__
 *
 * To run a query within a React component, call `useArticleListingNewsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleListingNewsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleListingNewsPageQuery({
 *   variables: {
 *      subVerticalSlug: // value for 'subVerticalSlug'
 *      categorySlug: // value for 'categorySlug'
 *      context: // value for 'context'
 *      url: // value for 'url'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useArticleListingNewsPageQuery(baseOptions: Apollo.QueryHookOptions<ArticleListingNewsPageQuery, ArticleListingNewsPageQueryVariables> & ({ variables: ArticleListingNewsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArticleListingNewsPageQuery, ArticleListingNewsPageQueryVariables>(ArticleListingNewsPageDocument, options);
      }
export function useArticleListingNewsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArticleListingNewsPageQuery, ArticleListingNewsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArticleListingNewsPageQuery, ArticleListingNewsPageQueryVariables>(ArticleListingNewsPageDocument, options);
        }
export function useArticleListingNewsPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ArticleListingNewsPageQuery, ArticleListingNewsPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ArticleListingNewsPageQuery, ArticleListingNewsPageQueryVariables>(ArticleListingNewsPageDocument, options);
        }
export type ArticleListingNewsPageQueryHookResult = ReturnType<typeof useArticleListingNewsPageQuery>;
export type ArticleListingNewsPageLazyQueryHookResult = ReturnType<typeof useArticleListingNewsPageLazyQuery>;
export type ArticleListingNewsPageSuspenseQueryHookResult = ReturnType<typeof useArticleListingNewsPageSuspenseQuery>;
export type ArticleListingNewsPageQueryResult = Apollo.QueryResult<ArticleListingNewsPageQuery, ArticleListingNewsPageQueryVariables>;
export const ArticleListingTagPageDocument = gql`
    query articleListingTagPage($verticalSlug: String!, $filterSlug: String!, $filterValue: String!, $context: String!, $pageNumber: Int) {
  articleListingPage: articleListingFilteredPage(
    verticalSlug: $verticalSlug
    filterSlug: $filterSlug
    filterValue: $filterValue
    context: $context
    pageNumber: $pageNumber
  ) {
    __typename
    meta {
      title
      desc
      dataLayer
      pageType
      taxonomyHierarchy {
        vertical
        subVertical
        category
        superCategory
      }
      canonical
    }
    breadcrumb {
      heading {
        href
        text
      }
      links {
        href
        text
      }
      currentPage {
        href
        text
      }
      baseUrl
    }
    newsTagHeader {
      name
      description
    }
    newsTagArticles {
      pagedArticles {
        total
        articles {
          headline
          summary
          url
          image {
            src
            alt
            sources {
              srcset
              sizes
            }
          }
          primaryTaxonomy {
            name
            url
          }
          updatedDate {
            rendered
            iso
          }
        }
      }
    }
    showResubBanner
  }
}
    `;

/**
 * __useArticleListingTagPageQuery__
 *
 * To run a query within a React component, call `useArticleListingTagPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleListingTagPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleListingTagPageQuery({
 *   variables: {
 *      verticalSlug: // value for 'verticalSlug'
 *      filterSlug: // value for 'filterSlug'
 *      filterValue: // value for 'filterValue'
 *      context: // value for 'context'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useArticleListingTagPageQuery(baseOptions: Apollo.QueryHookOptions<ArticleListingTagPageQuery, ArticleListingTagPageQueryVariables> & ({ variables: ArticleListingTagPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArticleListingTagPageQuery, ArticleListingTagPageQueryVariables>(ArticleListingTagPageDocument, options);
      }
export function useArticleListingTagPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArticleListingTagPageQuery, ArticleListingTagPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArticleListingTagPageQuery, ArticleListingTagPageQueryVariables>(ArticleListingTagPageDocument, options);
        }
export function useArticleListingTagPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ArticleListingTagPageQuery, ArticleListingTagPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ArticleListingTagPageQuery, ArticleListingTagPageQueryVariables>(ArticleListingTagPageDocument, options);
        }
export type ArticleListingTagPageQueryHookResult = ReturnType<typeof useArticleListingTagPageQuery>;
export type ArticleListingTagPageLazyQueryHookResult = ReturnType<typeof useArticleListingTagPageLazyQuery>;
export type ArticleListingTagPageSuspenseQueryHookResult = ReturnType<typeof useArticleListingTagPageSuspenseQuery>;
export type ArticleListingTagPageQueryResult = Apollo.QueryResult<ArticleListingTagPageQuery, ArticleListingTagPageQueryVariables>;
export const ArticleListingReviewsPageDocument = gql`
    query articleListingReviewsPage($subVerticalSlug: String, $categorySlug: String!, $context: String!, $url: String!) {
  articleListingPage(
    subVerticalSlug: $subVerticalSlug
    categorySlug: $categorySlug
    context: $context
    url: $url
  ) {
    __typename
    ...BaseArticleListingFragment
    reviewsArticles {
      featuredArticles {
        date
        title
        image
        multipageArticles {
          label
          href
        }
        strapline
        href
        glideId
      }
      nonFeaturedArticles {
        date
        title
        image
        multipageArticles {
          label
          href
        }
        strapline
        href
        glideId
      }
    }
    header {
      name
      description
    }
    latestNews {
      name
      articles {
        title
        href
        dateInfo {
          rendered
          iso
        }
        imageWithSources {
          src
          alt
          sources {
            srcset
            media
            sizes
          }
        }
      }
    }
    articleListingOptionalData {
      components {
        bannerSignUpComponentData {
          image {
            src
            sources {
              srcset
              media
              type
              sizes
            }
            alt
          }
          title
          text
          linkText
          linkUrl
          backgroundColour
          facebookUrl
          twitterUrl
        }
        toolCTA {
          title
          description
          widgetImageAspectRatio
          image {
            src
            sources {
              srcset
              media
              type
              sizes
            }
            alt
          }
          button {
            href
            text
          }
          linksListExpandableData {
            button {
              text
              ariaLabel
            }
            items {
              href
              label
            }
          }
        }
        localFooter {
          description
          items {
            title
            links {
              text
              href
            }
          }
          social {
            text
            href
            type
          }
        }
      }
    }
    recommendations {
      models {
        model
        content {
          __typename
          ... on RecommendedArticle {
            type
            id
            href
            title
            subheading
            image
          }
          ... on RecommendedProduct {
            type
            image
            href
            model
            slug
            testScore
            price
            manufacturer
          }
        }
      }
    }
  }
}
    ${BaseArticleListingFragmentFragmentDoc}`;

/**
 * __useArticleListingReviewsPageQuery__
 *
 * To run a query within a React component, call `useArticleListingReviewsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleListingReviewsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleListingReviewsPageQuery({
 *   variables: {
 *      subVerticalSlug: // value for 'subVerticalSlug'
 *      categorySlug: // value for 'categorySlug'
 *      context: // value for 'context'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useArticleListingReviewsPageQuery(baseOptions: Apollo.QueryHookOptions<ArticleListingReviewsPageQuery, ArticleListingReviewsPageQueryVariables> & ({ variables: ArticleListingReviewsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArticleListingReviewsPageQuery, ArticleListingReviewsPageQueryVariables>(ArticleListingReviewsPageDocument, options);
      }
export function useArticleListingReviewsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArticleListingReviewsPageQuery, ArticleListingReviewsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArticleListingReviewsPageQuery, ArticleListingReviewsPageQueryVariables>(ArticleListingReviewsPageDocument, options);
        }
export function useArticleListingReviewsPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ArticleListingReviewsPageQuery, ArticleListingReviewsPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ArticleListingReviewsPageQuery, ArticleListingReviewsPageQueryVariables>(ArticleListingReviewsPageDocument, options);
        }
export type ArticleListingReviewsPageQueryHookResult = ReturnType<typeof useArticleListingReviewsPageQuery>;
export type ArticleListingReviewsPageLazyQueryHookResult = ReturnType<typeof useArticleListingReviewsPageLazyQuery>;
export type ArticleListingReviewsPageSuspenseQueryHookResult = ReturnType<typeof useArticleListingReviewsPageSuspenseQuery>;
export type ArticleListingReviewsPageQueryResult = Apollo.QueryResult<ArticleListingReviewsPageQuery, ArticleListingReviewsPageQueryVariables>;
export const AboutWhichPageDocument = gql`
    query aboutWhichPage($url: String!, $context: String!) {
  articlePage(url: $url, context: $context) {
    ... on ArticlePage {
      __typename
      ...BaseFragment
      sharingData {
        facebook
        twitter
        whatsapp
        mail
        metaData {
          url
          headline
          fbAppId
          facebookText
          twitterText
          subject
        }
      }
      jumpLinks {
        name
        slug
      }
      header {
        headline
        addMarginOffsetClass
        standfirst
        date {
          rendered
          iso
        }
      }
      moreOnArticles {
        title
        links {
          href
          text
        }
      }
    }
    ... on Redirect {
      __typename
      redirectUrl
      status
    }
  }
}
    ${BaseFragmentFragmentDoc}`;

/**
 * __useAboutWhichPageQuery__
 *
 * To run a query within a React component, call `useAboutWhichPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAboutWhichPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAboutWhichPageQuery({
 *   variables: {
 *      url: // value for 'url'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useAboutWhichPageQuery(baseOptions: Apollo.QueryHookOptions<AboutWhichPageQuery, AboutWhichPageQueryVariables> & ({ variables: AboutWhichPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AboutWhichPageQuery, AboutWhichPageQueryVariables>(AboutWhichPageDocument, options);
      }
export function useAboutWhichPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AboutWhichPageQuery, AboutWhichPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AboutWhichPageQuery, AboutWhichPageQueryVariables>(AboutWhichPageDocument, options);
        }
export function useAboutWhichPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AboutWhichPageQuery, AboutWhichPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AboutWhichPageQuery, AboutWhichPageQueryVariables>(AboutWhichPageDocument, options);
        }
export type AboutWhichPageQueryHookResult = ReturnType<typeof useAboutWhichPageQuery>;
export type AboutWhichPageLazyQueryHookResult = ReturnType<typeof useAboutWhichPageLazyQuery>;
export type AboutWhichPageSuspenseQueryHookResult = ReturnType<typeof useAboutWhichPageSuspenseQuery>;
export type AboutWhichPageQueryResult = Apollo.QueryResult<AboutWhichPageQuery, AboutWhichPageQueryVariables>;
export const ConsumerRightsArticleDocument = gql`
    query consumerRightsArticle($url: String!, $context: String!) {
  articlePage(url: $url, context: $context) {
    ... on ArticlePage {
      __typename
      ...BaseFragment
      articleConfig {
        affiliateDisclaimer
        whichConnectMessage
        articleArea
        articleType
        adviceType
        inlinePageScripts
      }
      authors {
        name
        jobTitle
        image {
          src
          sources {
            srcset
            sizes
          }
        }
        slug
        about
      }
      jumpLinks {
        name
        slug
      }
      header {
        headline
        addMarginOffsetClass
        standfirst
        date {
          rendered
          iso
        }
      }
      introParagraph
      sharingData {
        facebook
        twitter
        whatsapp
        mail
        metaData {
          url
          headline
          fbAppId
          facebookText
          twitterText
          subject
        }
      }
      heroImage {
        src
        alt
        caption
        renditions
        sources {
          srcset
          sizes
        }
        dimensions {
          width
          height
        }
      }
      relatedProducts {
        categorySlug
        categoryLabel
        categoryLabelSingular
        products {
          slug
          price {
            formatted
            label
          }
          model
          badges
          overallScore
          manufacturer
          hasRetailers
          imageSrc
          label
          textVariation
          toolTip {
            ariaLabel
            contents
          }
        }
      }
      latestNews {
        name
        articles {
          title
          dateInfo {
            rendered
            iso
          }
          imageWithSources {
            src
            alt
            sources {
              srcset
              media
              sizes
            }
          }
          href
        }
      }
      onwardJourney {
        component
        props {
          title
          description
          image {
            alt
            src
            sources {
              srcset
              sizes
            }
          }
        }
      }
      optionalArticleData {
        components {
          localFooter {
            description
            items {
              title
              links {
                text
                href
              }
            }
            social {
              text
              href
              type
            }
          }
          moneyPromoBlock {
            title
            description
            ctaLabel
            ctaLink
          }
        }
      }
      moreOnArticles {
        title
        links {
          href
          text
        }
      }
      relatedArticles {
        title
        links {
          href
          text
        }
      }
      consumerRightsFooter {
        description
        items {
          title
          links {
            text
            href
          }
        }
        social {
          text
          href
          type
        }
      }
    }
    ... on Redirect {
      __typename
      redirectUrl
      status
    }
  }
}
    ${BaseFragmentFragmentDoc}`;

/**
 * __useConsumerRightsArticleQuery__
 *
 * To run a query within a React component, call `useConsumerRightsArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerRightsArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerRightsArticleQuery({
 *   variables: {
 *      url: // value for 'url'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useConsumerRightsArticleQuery(baseOptions: Apollo.QueryHookOptions<ConsumerRightsArticleQuery, ConsumerRightsArticleQueryVariables> & ({ variables: ConsumerRightsArticleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsumerRightsArticleQuery, ConsumerRightsArticleQueryVariables>(ConsumerRightsArticleDocument, options);
      }
export function useConsumerRightsArticleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsumerRightsArticleQuery, ConsumerRightsArticleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsumerRightsArticleQuery, ConsumerRightsArticleQueryVariables>(ConsumerRightsArticleDocument, options);
        }
export function useConsumerRightsArticleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConsumerRightsArticleQuery, ConsumerRightsArticleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConsumerRightsArticleQuery, ConsumerRightsArticleQueryVariables>(ConsumerRightsArticleDocument, options);
        }
export type ConsumerRightsArticleQueryHookResult = ReturnType<typeof useConsumerRightsArticleQuery>;
export type ConsumerRightsArticleLazyQueryHookResult = ReturnType<typeof useConsumerRightsArticleLazyQuery>;
export type ConsumerRightsArticleSuspenseQueryHookResult = ReturnType<typeof useConsumerRightsArticleSuspenseQuery>;
export type ConsumerRightsArticleQueryResult = Apollo.QueryResult<ConsumerRightsArticleQuery, ConsumerRightsArticleQueryVariables>;
export const ConsumerRightsScamsArticleDocument = gql`
    query consumerRightsScamsArticle($url: String!, $context: String!) {
  articlePage(url: $url, context: $context) {
    ... on ArticlePage {
      __typename
      ...BaseFragment
      articleConfig {
        whichConnectMessage
        inlinePageScripts
      }
      jumpLinks {
        name
        slug
      }
      header {
        headline
        addMarginOffsetClass
        standfirst
      }
      consumerRightsFooter {
        description
        items {
          title
          links {
            text
            href
          }
        }
        social {
          text
          href
          type
        }
      }
      latestNews {
        articles {
          title
          href
          imageWithSources {
            src
            alt
            sources {
              srcset
              sizes
            }
          }
          dateInfo {
            rendered
          }
        }
      }
    }
    ... on Redirect {
      __typename
      redirectUrl
      status
    }
  }
}
    ${BaseFragmentFragmentDoc}`;

/**
 * __useConsumerRightsScamsArticleQuery__
 *
 * To run a query within a React component, call `useConsumerRightsScamsArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerRightsScamsArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerRightsScamsArticleQuery({
 *   variables: {
 *      url: // value for 'url'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useConsumerRightsScamsArticleQuery(baseOptions: Apollo.QueryHookOptions<ConsumerRightsScamsArticleQuery, ConsumerRightsScamsArticleQueryVariables> & ({ variables: ConsumerRightsScamsArticleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsumerRightsScamsArticleQuery, ConsumerRightsScamsArticleQueryVariables>(ConsumerRightsScamsArticleDocument, options);
      }
export function useConsumerRightsScamsArticleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsumerRightsScamsArticleQuery, ConsumerRightsScamsArticleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsumerRightsScamsArticleQuery, ConsumerRightsScamsArticleQueryVariables>(ConsumerRightsScamsArticleDocument, options);
        }
export function useConsumerRightsScamsArticleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConsumerRightsScamsArticleQuery, ConsumerRightsScamsArticleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConsumerRightsScamsArticleQuery, ConsumerRightsScamsArticleQueryVariables>(ConsumerRightsScamsArticleDocument, options);
        }
export type ConsumerRightsScamsArticleQueryHookResult = ReturnType<typeof useConsumerRightsScamsArticleQuery>;
export type ConsumerRightsScamsArticleLazyQueryHookResult = ReturnType<typeof useConsumerRightsScamsArticleLazyQuery>;
export type ConsumerRightsScamsArticleSuspenseQueryHookResult = ReturnType<typeof useConsumerRightsScamsArticleSuspenseQuery>;
export type ConsumerRightsScamsArticleQueryResult = Apollo.QueryResult<ConsumerRightsScamsArticleQuery, ConsumerRightsScamsArticleQueryVariables>;
export const NewsArticlePageDocument = gql`
    query newsArticlePage($url: String!, $context: String!) {
  articlePage(url: $url, context: $context) {
    ... on ArticlePage {
      __typename
      ...BaseFragment
      articleConfig {
        affiliateDisclaimer
        whichConnectMessage
        articleArea
        articleType
        adviceType
        inlinePageScripts
      }
      authors {
        name
        jobTitle
        image {
          src
          sources {
            srcset
            sizes
          }
        }
        slug
        about
      }
      header {
        headline
        addMarginOffsetClass
        standfirst
        date {
          rendered
          iso
        }
      }
      introParagraph
      sharingData {
        facebook
        twitter
        whatsapp
        mail
        metaData {
          url
          headline
          fbAppId
          facebookText
          twitterText
          subject
        }
      }
      heroImage {
        src
        alt
        caption
        renditions
        sources {
          srcset
          sizes
        }
        dimensions {
          width
          height
        }
      }
      heroVideo {
        videoClient
        videoId
        brightcoveAccountId
        seo {
          name
          description
          thumbnailUrl
          dateCreated
          dateModified
          uploadDate
          duration
          embedUrl
          contentUrl
        }
      }
      videosSeoData {
        name
        description
        thumbnailUrl
        dateCreated
        dateModified
        uploadDate
        duration
        embedUrl
        contentUrl
      }
      tags {
        label
        slug
      }
      moreOnArticles {
        title
        links {
          href
          text
          img
        }
      }
      relatedArticles {
        title
        links {
          href
          text
          img
        }
      }
      promoBlock {
        title
        description
        ctaLabel
        ctaLink
      }
      optionalArticleData {
        components {
          localFooter {
            description
            items {
              title
              links {
                text
                href
              }
            }
            social {
              text
              href
              type
            }
          }
        }
      }
    }
    ... on Redirect {
      __typename
      redirectUrl
      status
    }
  }
}
    ${BaseFragmentFragmentDoc}`;

/**
 * __useNewsArticlePageQuery__
 *
 * To run a query within a React component, call `useNewsArticlePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsArticlePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsArticlePageQuery({
 *   variables: {
 *      url: // value for 'url'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useNewsArticlePageQuery(baseOptions: Apollo.QueryHookOptions<NewsArticlePageQuery, NewsArticlePageQueryVariables> & ({ variables: NewsArticlePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsArticlePageQuery, NewsArticlePageQueryVariables>(NewsArticlePageDocument, options);
      }
export function useNewsArticlePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsArticlePageQuery, NewsArticlePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsArticlePageQuery, NewsArticlePageQueryVariables>(NewsArticlePageDocument, options);
        }
export function useNewsArticlePageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NewsArticlePageQuery, NewsArticlePageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NewsArticlePageQuery, NewsArticlePageQueryVariables>(NewsArticlePageDocument, options);
        }
export type NewsArticlePageQueryHookResult = ReturnType<typeof useNewsArticlePageQuery>;
export type NewsArticlePageLazyQueryHookResult = ReturnType<typeof useNewsArticlePageLazyQuery>;
export type NewsArticlePageSuspenseQueryHookResult = ReturnType<typeof useNewsArticlePageSuspenseQuery>;
export type NewsArticlePageQueryResult = Apollo.QueryResult<NewsArticlePageQuery, NewsArticlePageQueryVariables>;
export const PensionPageDocument = gql`
    query pensionPage($url: String!, $context: String!) {
  articlePage(url: $url, context: $context) {
    ... on ArticlePage {
      __typename
      ...BaseFragment
      sharingData {
        facebook
        twitter
        whatsapp
        mail
        metaData {
          url
          headline
          fbAppId
          facebookText
          twitterText
          subject
        }
      }
      jumpLinks {
        name
        slug
      }
      header {
        headline
        addMarginOffsetClass
        standfirst
        date {
          rendered
          iso
        }
      }
      moreOnArticles {
        title
        links {
          href
          text
        }
      }
    }
    ... on Redirect {
      __typename
      redirectUrl
      status
    }
  }
}
    ${BaseFragmentFragmentDoc}`;

/**
 * __usePensionPageQuery__
 *
 * To run a query within a React component, call `usePensionPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePensionPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePensionPageQuery({
 *   variables: {
 *      url: // value for 'url'
 *      context: // value for 'context'
 *   },
 * });
 */
export function usePensionPageQuery(baseOptions: Apollo.QueryHookOptions<PensionPageQuery, PensionPageQueryVariables> & ({ variables: PensionPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PensionPageQuery, PensionPageQueryVariables>(PensionPageDocument, options);
      }
export function usePensionPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PensionPageQuery, PensionPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PensionPageQuery, PensionPageQueryVariables>(PensionPageDocument, options);
        }
export function usePensionPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PensionPageQuery, PensionPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PensionPageQuery, PensionPageQueryVariables>(PensionPageDocument, options);
        }
export type PensionPageQueryHookResult = ReturnType<typeof usePensionPageQuery>;
export type PensionPageLazyQueryHookResult = ReturnType<typeof usePensionPageLazyQuery>;
export type PensionPageSuspenseQueryHookResult = ReturnType<typeof usePensionPageSuspenseQuery>;
export type PensionPageQueryResult = Apollo.QueryResult<PensionPageQuery, PensionPageQueryVariables>;
export const PolicyAndInsightPageDocument = gql`
    query policyAndInsightPage($url: String!, $context: String!) {
  articlePage(url: $url, context: $context) {
    ... on ArticlePage {
      __typename
      ...BaseFragment
      articleConfig {
        affiliateDisclaimer
        whichConnectMessage
        articleArea
        articleType
        adviceType
        inlinePageScripts
      }
      articleExcelDataSheet
      articlePdf
      authors {
        name
        jobTitle
        image {
          src
          sources {
            srcset
            sizes
          }
        }
        slug
        about
      }
      jumpLinks {
        name
        slug
      }
      header {
        headline
        addMarginOffsetClass
        standfirst
        date {
          rendered
          iso
        }
      }
      sharingData {
        facebook
        twitter
        whatsapp
        mail
        metaData {
          url
          headline
          fbAppId
          facebookText
          twitterText
          subject
        }
      }
      heroImage {
        src
        alt
        caption
        renditions
        sources {
          srcset
          sizes
        }
        dimensions {
          width
          height
        }
      }
      moreOnArticles {
        title
        links {
          href
          text
        }
      }
      relatedArticles {
        title
        links {
          href
          text
        }
      }
      estimatedReadingTime
    }
    ... on Redirect {
      __typename
      redirectUrl
      status
    }
  }
}
    ${BaseFragmentFragmentDoc}`;

/**
 * __usePolicyAndInsightPageQuery__
 *
 * To run a query within a React component, call `usePolicyAndInsightPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolicyAndInsightPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePolicyAndInsightPageQuery({
 *   variables: {
 *      url: // value for 'url'
 *      context: // value for 'context'
 *   },
 * });
 */
export function usePolicyAndInsightPageQuery(baseOptions: Apollo.QueryHookOptions<PolicyAndInsightPageQuery, PolicyAndInsightPageQueryVariables> & ({ variables: PolicyAndInsightPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PolicyAndInsightPageQuery, PolicyAndInsightPageQueryVariables>(PolicyAndInsightPageDocument, options);
      }
export function usePolicyAndInsightPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PolicyAndInsightPageQuery, PolicyAndInsightPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PolicyAndInsightPageQuery, PolicyAndInsightPageQueryVariables>(PolicyAndInsightPageDocument, options);
        }
export function usePolicyAndInsightPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolicyAndInsightPageQuery, PolicyAndInsightPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PolicyAndInsightPageQuery, PolicyAndInsightPageQueryVariables>(PolicyAndInsightPageDocument, options);
        }
export type PolicyAndInsightPageQueryHookResult = ReturnType<typeof usePolicyAndInsightPageQuery>;
export type PolicyAndInsightPageLazyQueryHookResult = ReturnType<typeof usePolicyAndInsightPageLazyQuery>;
export type PolicyAndInsightPageSuspenseQueryHookResult = ReturnType<typeof usePolicyAndInsightPageSuspenseQuery>;
export type PolicyAndInsightPageQueryResult = Apollo.QueryResult<PolicyAndInsightPageQuery, PolicyAndInsightPageQueryVariables>;
export const RecommendedForYouArticlesDocument = gql`
    query recommendedForYouArticles {
  homePage {
    recommendations {
      models {
        model
        content {
          __typename
          ... on RecommendedArticle {
            type
            id
            href
            title
            subheading
            image
          }
        }
      }
    }
  }
}
    `;

/**
 * __useRecommendedForYouArticlesQuery__
 *
 * To run a query within a React component, call `useRecommendedForYouArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendedForYouArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendedForYouArticlesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecommendedForYouArticlesQuery(baseOptions?: Apollo.QueryHookOptions<RecommendedForYouArticlesQuery, RecommendedForYouArticlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecommendedForYouArticlesQuery, RecommendedForYouArticlesQueryVariables>(RecommendedForYouArticlesDocument, options);
      }
export function useRecommendedForYouArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecommendedForYouArticlesQuery, RecommendedForYouArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecommendedForYouArticlesQuery, RecommendedForYouArticlesQueryVariables>(RecommendedForYouArticlesDocument, options);
        }
export function useRecommendedForYouArticlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecommendedForYouArticlesQuery, RecommendedForYouArticlesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecommendedForYouArticlesQuery, RecommendedForYouArticlesQueryVariables>(RecommendedForYouArticlesDocument, options);
        }
export type RecommendedForYouArticlesQueryHookResult = ReturnType<typeof useRecommendedForYouArticlesQuery>;
export type RecommendedForYouArticlesLazyQueryHookResult = ReturnType<typeof useRecommendedForYouArticlesLazyQuery>;
export type RecommendedForYouArticlesSuspenseQueryHookResult = ReturnType<typeof useRecommendedForYouArticlesSuspenseQuery>;
export type RecommendedForYouArticlesQueryResult = Apollo.QueryResult<RecommendedForYouArticlesQuery, RecommendedForYouArticlesQueryVariables>;
export const ReviewsAdviceMultiDocument = gql`
    query reviewsAdviceMulti($url: String!, $context: String!) {
  articlePage(url: $url, context: $context) {
    ... on ArticlePage {
      __typename
      ...BaseFragment
      ...ReviewsBaseFragment
      multiPageGuide {
        title
        links {
          href
          text
        }
      }
    }
    ... on Redirect {
      __typename
      redirectUrl
      status
    }
  }
}
    ${BaseFragmentFragmentDoc}
${ReviewsBaseFragmentFragmentDoc}`;

/**
 * __useReviewsAdviceMultiQuery__
 *
 * To run a query within a React component, call `useReviewsAdviceMultiQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsAdviceMultiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewsAdviceMultiQuery({
 *   variables: {
 *      url: // value for 'url'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useReviewsAdviceMultiQuery(baseOptions: Apollo.QueryHookOptions<ReviewsAdviceMultiQuery, ReviewsAdviceMultiQueryVariables> & ({ variables: ReviewsAdviceMultiQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReviewsAdviceMultiQuery, ReviewsAdviceMultiQueryVariables>(ReviewsAdviceMultiDocument, options);
      }
export function useReviewsAdviceMultiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReviewsAdviceMultiQuery, ReviewsAdviceMultiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReviewsAdviceMultiQuery, ReviewsAdviceMultiQueryVariables>(ReviewsAdviceMultiDocument, options);
        }
export function useReviewsAdviceMultiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReviewsAdviceMultiQuery, ReviewsAdviceMultiQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReviewsAdviceMultiQuery, ReviewsAdviceMultiQueryVariables>(ReviewsAdviceMultiDocument, options);
        }
export type ReviewsAdviceMultiQueryHookResult = ReturnType<typeof useReviewsAdviceMultiQuery>;
export type ReviewsAdviceMultiLazyQueryHookResult = ReturnType<typeof useReviewsAdviceMultiLazyQuery>;
export type ReviewsAdviceMultiSuspenseQueryHookResult = ReturnType<typeof useReviewsAdviceMultiSuspenseQuery>;
export type ReviewsAdviceMultiQueryResult = Apollo.QueryResult<ReviewsAdviceMultiQuery, ReviewsAdviceMultiQueryVariables>;
export const ReviewsAdviceSingleDocument = gql`
    query reviewsAdviceSingle($url: String!, $context: String!) {
  articlePage(url: $url, context: $context) {
    ... on ArticlePage {
      __typename
      ...BaseFragment
      ...ReviewsBaseFragment
      moreOnArticles {
        title
        links {
          href
          text
        }
      }
      relatedArticles {
        title
        links {
          href
          text
        }
      }
    }
    ... on Redirect {
      __typename
      redirectUrl
      status
    }
  }
}
    ${BaseFragmentFragmentDoc}
${ReviewsBaseFragmentFragmentDoc}`;

/**
 * __useReviewsAdviceSingleQuery__
 *
 * To run a query within a React component, call `useReviewsAdviceSingleQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsAdviceSingleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewsAdviceSingleQuery({
 *   variables: {
 *      url: // value for 'url'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useReviewsAdviceSingleQuery(baseOptions: Apollo.QueryHookOptions<ReviewsAdviceSingleQuery, ReviewsAdviceSingleQueryVariables> & ({ variables: ReviewsAdviceSingleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReviewsAdviceSingleQuery, ReviewsAdviceSingleQueryVariables>(ReviewsAdviceSingleDocument, options);
      }
export function useReviewsAdviceSingleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReviewsAdviceSingleQuery, ReviewsAdviceSingleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReviewsAdviceSingleQuery, ReviewsAdviceSingleQueryVariables>(ReviewsAdviceSingleDocument, options);
        }
export function useReviewsAdviceSingleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReviewsAdviceSingleQuery, ReviewsAdviceSingleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReviewsAdviceSingleQuery, ReviewsAdviceSingleQueryVariables>(ReviewsAdviceSingleDocument, options);
        }
export type ReviewsAdviceSingleQueryHookResult = ReturnType<typeof useReviewsAdviceSingleQuery>;
export type ReviewsAdviceSingleLazyQueryHookResult = ReturnType<typeof useReviewsAdviceSingleLazyQuery>;
export type ReviewsAdviceSingleSuspenseQueryHookResult = ReturnType<typeof useReviewsAdviceSingleSuspenseQuery>;
export type ReviewsAdviceSingleQueryResult = Apollo.QueryResult<ReviewsAdviceSingleQuery, ReviewsAdviceSingleQueryVariables>;
export const AuthorArticlesDocument = gql`
    query authorArticles($authorSlug: String!) {
  authorArticles(authorSlug: $authorSlug) {
    label
    total
    articles {
      topicHeading {
        text
        icon
        category
      }
      title
      standFirst
      date
      image
      href
      imageAlt
      authors {
        name
        jobTitle
        image {
          src
          sources {
            sizes
            srcset
          }
        }
      }
      estimatedReadingTime
    }
    author {
      name
      jobTitle
      image {
        id
        src
      }
      about
      slug
      links {
        icon
        href
        text
      }
    }
    sharingData {
      facebook
      twitter
      whatsapp
      mail
      metaData {
        url
        headline
        fbAppId
        facebookText
        twitterText
        subject
      }
    }
  }
}
    `;

/**
 * __useAuthorArticlesQuery__
 *
 * To run a query within a React component, call `useAuthorArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorArticlesQuery({
 *   variables: {
 *      authorSlug: // value for 'authorSlug'
 *   },
 * });
 */
export function useAuthorArticlesQuery(baseOptions: Apollo.QueryHookOptions<AuthorArticlesQuery, AuthorArticlesQueryVariables> & ({ variables: AuthorArticlesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthorArticlesQuery, AuthorArticlesQueryVariables>(AuthorArticlesDocument, options);
      }
export function useAuthorArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthorArticlesQuery, AuthorArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthorArticlesQuery, AuthorArticlesQueryVariables>(AuthorArticlesDocument, options);
        }
export function useAuthorArticlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthorArticlesQuery, AuthorArticlesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthorArticlesQuery, AuthorArticlesQueryVariables>(AuthorArticlesDocument, options);
        }
export type AuthorArticlesQueryHookResult = ReturnType<typeof useAuthorArticlesQuery>;
export type AuthorArticlesLazyQueryHookResult = ReturnType<typeof useAuthorArticlesLazyQuery>;
export type AuthorArticlesSuspenseQueryHookResult = ReturnType<typeof useAuthorArticlesSuspenseQuery>;
export type AuthorArticlesQueryResult = Apollo.QueryResult<AuthorArticlesQuery, AuthorArticlesQueryVariables>;
export const ArticleTypePageDocument = gql`
    query articleTypePage($articleTypeSlug: String!, $url: String!) {
  articleTypePage(articleTypeSlug: $articleTypeSlug, url: $url) {
    meta {
      title
      desc
      fbAppId
      dataLayer
      pageType
      taxonomyHierarchy {
        vertical
        subVertical
        category
        superCategory
      }
      canonical
    }
    topArticles {
      title
      description
      articles {
        title
        href
        strapline
      }
    }
    popularArticles {
      title
      articlesList {
        title
        image {
          src
          sources {
            srcset
            sizes
          }
        }
        articles {
          title
          href
        }
      }
    }
    consumerRightsFooter {
      title
      description
      items {
        title
        links {
          text
          href
        }
      }
      social {
        text
        href
        type
      }
    }
    taxonomyConversionBanner {
      title
      description
      descriptionMobile
      buttonText
      buttonURL
    }
    breadcrumb {
      heading {
        href
        text
      }
      links {
        href
        text
      }
      currentPage {
        href
        text
      }
      baseUrl
    }
  }
}
    `;

/**
 * __useArticleTypePageQuery__
 *
 * To run a query within a React component, call `useArticleTypePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleTypePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleTypePageQuery({
 *   variables: {
 *      articleTypeSlug: // value for 'articleTypeSlug'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useArticleTypePageQuery(baseOptions: Apollo.QueryHookOptions<ArticleTypePageQuery, ArticleTypePageQueryVariables> & ({ variables: ArticleTypePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArticleTypePageQuery, ArticleTypePageQueryVariables>(ArticleTypePageDocument, options);
      }
export function useArticleTypePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArticleTypePageQuery, ArticleTypePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArticleTypePageQuery, ArticleTypePageQueryVariables>(ArticleTypePageDocument, options);
        }
export function useArticleTypePageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ArticleTypePageQuery, ArticleTypePageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ArticleTypePageQuery, ArticleTypePageQueryVariables>(ArticleTypePageDocument, options);
        }
export type ArticleTypePageQueryHookResult = ReturnType<typeof useArticleTypePageQuery>;
export type ArticleTypePageLazyQueryHookResult = ReturnType<typeof useArticleTypePageLazyQuery>;
export type ArticleTypePageSuspenseQueryHookResult = ReturnType<typeof useArticleTypePageSuspenseQuery>;
export type ArticleTypePageQueryResult = Apollo.QueryResult<ArticleTypePageQuery, ArticleTypePageQueryVariables>;
export const EnergyPageDocument = gql`
    query energyPage($rootCollectionName: String!) {
  energyPage(rootCollectionName: $rootCollectionName) {
    meta {
      title
      desc
      fbAppId
      canonical
      taxonomySlug
    }
    header {
      title
      intro
      image {
        src
        alt
        sources {
          srcset
          sizes
        }
      }
      backgroundColour
    }
    contentItems {
      ... on PicksContentItem {
        __typename
        title
        intro
        jumpLinks {
          id
          label
        }
        productListingLink {
          href
          label
        }
        inlineArticles {
          href
          text
        }
        items {
          ... on PicksProductCard {
            __typename
            title
            description
            model
            manufacturer
            typicalPrice
            affiliateItems {
              url
              isTrackable
              retailer
              price
            }
            image {
              src
              alt
              sources {
                srcset
                sizes
              }
            }
            reviewUrl
            usesPimData
            articleLink
            articleLinkLabel
            annualRunningCost {
              label
              formatted
            }
          }
          ... on PicksArticleCard {
            __typename
            title
            description
            image {
              src
              alt
              sources {
                srcset
                sizes
              }
            }
            link {
              text
              href
            }
          }
        }
      }
      ... on PicksPromo {
        __typename
        component
        props
      }
    }
    relatedArticleLinks {
      href
      text
    }
    authors {
      id
      name
      jobTitle
      image {
        src
        alt
        sources {
          srcset
          sizes
        }
      }
      slug
      about
    }
  }
}
    `;

/**
 * __useEnergyPageQuery__
 *
 * To run a query within a React component, call `useEnergyPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnergyPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergyPageQuery({
 *   variables: {
 *      rootCollectionName: // value for 'rootCollectionName'
 *   },
 * });
 */
export function useEnergyPageQuery(baseOptions: Apollo.QueryHookOptions<EnergyPageQuery, EnergyPageQueryVariables> & ({ variables: EnergyPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnergyPageQuery, EnergyPageQueryVariables>(EnergyPageDocument, options);
      }
export function useEnergyPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnergyPageQuery, EnergyPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnergyPageQuery, EnergyPageQueryVariables>(EnergyPageDocument, options);
        }
export function useEnergyPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EnergyPageQuery, EnergyPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EnergyPageQuery, EnergyPageQueryVariables>(EnergyPageDocument, options);
        }
export type EnergyPageQueryHookResult = ReturnType<typeof useEnergyPageQuery>;
export type EnergyPageLazyQueryHookResult = ReturnType<typeof useEnergyPageLazyQuery>;
export type EnergyPageSuspenseQueryHookResult = ReturnType<typeof useEnergyPageSuspenseQuery>;
export type EnergyPageQueryResult = Apollo.QueryResult<EnergyPageQuery, EnergyPageQueryVariables>;
export const MemberBenefitsInfoDocument = gql`
    query memberBenefitsInfo {
  memberBenefitsInfo {
    links {
      ... on MemberBenefitPageLink {
        href
        image
        text
      }
      ... on MemberBenefitWidgetLink {
        image
        text
        content {
          heading
          subheader
          icon
        }
      }
    }
    offer {
      heading
      href
      text
    }
    isLoggedIn
    calloutText
    caption
    creative {
      val
      isQueryParam
    }
    overline
    offerPrice
    previousOfferPrice
    renewalOffer {
      heading
      body
      phoneNumber
      footerText
    }
  }
}
    `;

/**
 * __useMemberBenefitsInfoQuery__
 *
 * To run a query within a React component, call `useMemberBenefitsInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberBenefitsInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberBenefitsInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useMemberBenefitsInfoQuery(baseOptions?: Apollo.QueryHookOptions<MemberBenefitsInfoQuery, MemberBenefitsInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemberBenefitsInfoQuery, MemberBenefitsInfoQueryVariables>(MemberBenefitsInfoDocument, options);
      }
export function useMemberBenefitsInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemberBenefitsInfoQuery, MemberBenefitsInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemberBenefitsInfoQuery, MemberBenefitsInfoQueryVariables>(MemberBenefitsInfoDocument, options);
        }
export function useMemberBenefitsInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MemberBenefitsInfoQuery, MemberBenefitsInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MemberBenefitsInfoQuery, MemberBenefitsInfoQueryVariables>(MemberBenefitsInfoDocument, options);
        }
export type MemberBenefitsInfoQueryHookResult = ReturnType<typeof useMemberBenefitsInfoQuery>;
export type MemberBenefitsInfoLazyQueryHookResult = ReturnType<typeof useMemberBenefitsInfoLazyQuery>;
export type MemberBenefitsInfoSuspenseQueryHookResult = ReturnType<typeof useMemberBenefitsInfoSuspenseQuery>;
export type MemberBenefitsInfoQueryResult = Apollo.QueryResult<MemberBenefitsInfoQuery, MemberBenefitsInfoQueryVariables>;
export const HomePageDocument = gql`
    query homePage {
  homePage {
    meta {
      title
      desc
      fbAppId
      dataLayer
      pageType
      taxonomyHierarchy {
        vertical
        subVertical
        category
        superCategory
      }
      canonical
    }
    imageUrl
    showResubBanner
    toolCTAs {
      identifier
      title
      description
      image {
        src
        sources {
          srcset
          sizes
          media
          type
        }
        alt
        id
        caption
        dimensions {
          width
          height
        }
      }
      button {
        href
        text
      }
    }
    freeAccountExclusive {
      title
      description
      image {
        src
        sources {
          srcset
          sizes
          media
          type
        }
        alt
        id
        caption
        dimensions {
          width
          height
        }
      }
    }
    featuredLinks {
      identifier
      title
      strapline
      onwardLinkText
      onwardLinkUrl
      backgroundColour
      mainFeaturedArticle {
        title
        href
        standfirst
        isLive
        dateInfo {
          rendered
          iso
        }
        image {
          renditions
          src
          sources {
            srcset
            sizes
            media
            type
          }
          alt
          id
          caption
          dimensions {
            width
            height
          }
        }
      }
      featuredArticles {
        title
        href
        dateInfo {
          rendered
          iso
        }
        imageWithSources {
          renditions
          src
          sources {
            srcset
            sizes
            media
            type
          }
          alt
          id
          caption
          dimensions {
            width
            height
          }
        }
      }
    }
    mostReadLinks {
      title
      links {
        href
        text
      }
    }
    magazineLinks {
      title
      strapline
      links {
        title
        strapline
        href
        image {
          src
          sources {
            sizes
            srcset
          }
        }
      }
    }
  }
}
    `;

/**
 * __useHomePageQuery__
 *
 * To run a query within a React component, call `useHomePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePageQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomePageQuery(baseOptions?: Apollo.QueryHookOptions<HomePageQuery, HomePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomePageQuery, HomePageQueryVariables>(HomePageDocument, options);
      }
export function useHomePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomePageQuery, HomePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomePageQuery, HomePageQueryVariables>(HomePageDocument, options);
        }
export function useHomePageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomePageQuery, HomePageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomePageQuery, HomePageQueryVariables>(HomePageDocument, options);
        }
export type HomePageQueryHookResult = ReturnType<typeof useHomePageQuery>;
export type HomePageLazyQueryHookResult = ReturnType<typeof useHomePageLazyQuery>;
export type HomePageSuspenseQueryHookResult = ReturnType<typeof useHomePageSuspenseQuery>;
export type HomePageQueryResult = Apollo.QueryResult<HomePageQuery, HomePageQueryVariables>;
export const LiveReportPageDocument = gql`
    query liveReportPage($liveReportUrl: String!) {
  liveReportPage(liveReportUrl: $liveReportUrl) {
    liveReportHeader {
      headline
      catchline
      description
      summary
      isLive
      promoImageSrcList
      coverageEndTime
      datePublishedIso
      dateModifiedIso
    }
    liveReportPosts {
      id
      headline
      catchline
      authors
      postBodyTemplate
      postBodyString
      publishedAtIso
      updatedAtIso
    }
    sharingData {
      facebook
      twitter
      whatsapp
      mail
      metaData {
        url
        headline
        fbAppId
        facebookText
        twitterText
        subject
      }
    }
    meta {
      title
      contentId
      canonical
      desc
      facebookImage
      twitterImage
      keywords
      dataLayer
    }
  }
}
    `;

/**
 * __useLiveReportPageQuery__
 *
 * To run a query within a React component, call `useLiveReportPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiveReportPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveReportPageQuery({
 *   variables: {
 *      liveReportUrl: // value for 'liveReportUrl'
 *   },
 * });
 */
export function useLiveReportPageQuery(baseOptions: Apollo.QueryHookOptions<LiveReportPageQuery, LiveReportPageQueryVariables> & ({ variables: LiveReportPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LiveReportPageQuery, LiveReportPageQueryVariables>(LiveReportPageDocument, options);
      }
export function useLiveReportPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LiveReportPageQuery, LiveReportPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LiveReportPageQuery, LiveReportPageQueryVariables>(LiveReportPageDocument, options);
        }
export function useLiveReportPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LiveReportPageQuery, LiveReportPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LiveReportPageQuery, LiveReportPageQueryVariables>(LiveReportPageDocument, options);
        }
export type LiveReportPageQueryHookResult = ReturnType<typeof useLiveReportPageQuery>;
export type LiveReportPageLazyQueryHookResult = ReturnType<typeof useLiveReportPageLazyQuery>;
export type LiveReportPageSuspenseQueryHookResult = ReturnType<typeof useLiveReportPageSuspenseQuery>;
export type LiveReportPageQueryResult = Apollo.QueryResult<LiveReportPageQuery, LiveReportPageQueryVariables>;
export const MarketingHubPageDocument = gql`
    query marketingHubPage {
  marketingHubPage {
    contentItems {
      ... on MarketingHubContentItem {
        __typename
        title
        cards {
          url
          title
          subTitle
          smallPrint
        }
        jumplink {
          label
          id
        }
      }
      ... on MarketingHubWidget {
        __typename
        component
        props
      }
    }
    header {
      catchline
      description
      image {
        src
        alt
        sources {
          srcset
          sizes
        }
      }
      backgroundColour
    }
    footer
    meta {
      title
      desc
      fbAppId
      taxonomySlug
      canonical
      publishedDateTime
      updatedDateTime
      socialData {
        twitter {
          image
          description
          title
        }
        og {
          image
          description
          title
        }
      }
    }
  }
}
    `;

/**
 * __useMarketingHubPageQuery__
 *
 * To run a query within a React component, call `useMarketingHubPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingHubPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingHubPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useMarketingHubPageQuery(baseOptions?: Apollo.QueryHookOptions<MarketingHubPageQuery, MarketingHubPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketingHubPageQuery, MarketingHubPageQueryVariables>(MarketingHubPageDocument, options);
      }
export function useMarketingHubPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingHubPageQuery, MarketingHubPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketingHubPageQuery, MarketingHubPageQueryVariables>(MarketingHubPageDocument, options);
        }
export function useMarketingHubPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MarketingHubPageQuery, MarketingHubPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MarketingHubPageQuery, MarketingHubPageQueryVariables>(MarketingHubPageDocument, options);
        }
export type MarketingHubPageQueryHookResult = ReturnType<typeof useMarketingHubPageQuery>;
export type MarketingHubPageLazyQueryHookResult = ReturnType<typeof useMarketingHubPageLazyQuery>;
export type MarketingHubPageSuspenseQueryHookResult = ReturnType<typeof useMarketingHubPageSuspenseQuery>;
export type MarketingHubPageQueryResult = Apollo.QueryResult<MarketingHubPageQuery, MarketingHubPageQueryVariables>;
export const ProductHubPageDocument = gql`
    query productHubPage($subVerticalSlug: String!, $productSlug: String!) {
  productHubPage(subVerticalSlug: $subVerticalSlug, productSlug: $productSlug) {
    productHubEnabled
    breadcrumb {
      baseUrl
      currentPage {
        href
        text
      }
      heading {
        href
        text
      }
      links {
        href
        text
      }
    }
    header {
      title
      description
      image {
        src
        sources {
          srcset
          sizes
          media
          type
        }
        alt
        id
        caption
        renditions
        dimensions {
          width
          height
        }
      }
    }
    meta {
      title
      desc
      facebookTitle
      facebookDesc
      facebookImage
      twitterTitle
      twitterDesc
      twitterImage
      fbAppId
      dataLayer
      pageType
      taxonomyHierarchy {
        vertical
        subVertical
        category
        superCategory
      }
      canonical
    }
    isLoggedIn
    transformTypeDecision
    showResubBanner
    productReviews {
      brands {
        heading
        relatedArticle {
          link
          linkText
        }
        items {
          link
          linkText
        }
      }
      heading
      subText
      productData {
        manufacturer
        model
        businessKey
        price
        image {
          src
          sources {
            media
            srcset
            sizes
            type
          }
          alt
        }
        retailers
        slug
        tags
        badges
        variantValues {
          code
          value
          label
        }
        variantPriceRange {
          min {
            formatted
          }
          max {
            formatted
          }
        }
        productScoreGauge {
          label
          testScoreGauge {
            overallScore
            textVariation
          }
          tooltip {
            contents
            title
            ariaLabel
          }
          variant
        }
      }
      productSlug
      productCount {
        total
      }
    }
    helpAndAdvice {
      title
      subtitle
      featuredArticle {
        title
        description
        path
        image {
          src
          sources {
            srcset
            sizes
            media
            type
          }
          alt
        }
      }
      topArticles {
        title
        description
        path
        image {
          src
          sources {
            srcset
            sizes
            media
            type
          }
          alt
        }
      }
      allArticles {
        title
        description
        path
        image {
          src
          sources {
            srcset
            sizes
            media
            type
          }
          alt
        }
      }
    }
    categoryTypes {
      title
      relatedArticleLink {
        link
        linkText
      }
      cards {
        title
        image {
          src
          sources {
            srcset
            sizes
            media
            type
          }
          alt
          id
          caption
          renditions
          dimensions {
            width
            height
          }
        }
        link
      }
    }
  }
}
    `;

/**
 * __useProductHubPageQuery__
 *
 * To run a query within a React component, call `useProductHubPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductHubPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductHubPageQuery({
 *   variables: {
 *      subVerticalSlug: // value for 'subVerticalSlug'
 *      productSlug: // value for 'productSlug'
 *   },
 * });
 */
export function useProductHubPageQuery(baseOptions: Apollo.QueryHookOptions<ProductHubPageQuery, ProductHubPageQueryVariables> & ({ variables: ProductHubPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductHubPageQuery, ProductHubPageQueryVariables>(ProductHubPageDocument, options);
      }
export function useProductHubPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductHubPageQuery, ProductHubPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductHubPageQuery, ProductHubPageQueryVariables>(ProductHubPageDocument, options);
        }
export function useProductHubPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductHubPageQuery, ProductHubPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductHubPageQuery, ProductHubPageQueryVariables>(ProductHubPageDocument, options);
        }
export type ProductHubPageQueryHookResult = ReturnType<typeof useProductHubPageQuery>;
export type ProductHubPageLazyQueryHookResult = ReturnType<typeof useProductHubPageLazyQuery>;
export type ProductHubPageSuspenseQueryHookResult = ReturnType<typeof useProductHubPageSuspenseQuery>;
export type ProductHubPageQueryResult = Apollo.QueryResult<ProductHubPageQuery, ProductHubPageQueryVariables>;
export const ProductComparisonPageDocument = gql`
    query productComparisonPage($categorySlug: String!, $context: String!, $productsIds: [String!]!) {
  productComparisonPage(
    categorySlug: $categorySlug
    context: $context
    productsIds: $productsIds
  ) {
    breadcrumb {
      heading {
        href
        text
      }
      links {
        href
        text
      }
      currentPage {
        href
        text
      }
      baseUrl
    }
    comparisonTable {
      taxonomySlug
      tableData {
        label
        groupHelpText
        rows {
          rowCode
          rowLabel
          rowValues
          helpText
        }
        dataType
      }
      productDetails {
        alertType
        badges
        businessKey
        image {
          src
          alt
          sources {
            srcset
            sizes
            type
          }
        }
        manufacturer {
          name
        }
        model
        offers {
          url
          isTrackable
          priceValue
          formattedPrice
          availableInStock
          retailer {
            name
          }
        }
        price
        productScoreGauge {
          label
          variant
          testScoreGauge {
            overallScore
            textVariation
          }
          tooltip {
            contents
            title
            ariaLabel
          }
        }
        pros
        cons
        slug
        testedType
        editorialReview {
          cta
          verdict
          content
          isPadlocked
          teaser
        }
      }
    }
    meta {
      title
      desc
      pageType
      dataLayer
      taxonomyHierarchy {
        vertical
        subVertical
        superCategory
        category
      }
      canonical
    }
  }
}
    `;

/**
 * __useProductComparisonPageQuery__
 *
 * To run a query within a React component, call `useProductComparisonPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductComparisonPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductComparisonPageQuery({
 *   variables: {
 *      categorySlug: // value for 'categorySlug'
 *      context: // value for 'context'
 *      productsIds: // value for 'productsIds'
 *   },
 * });
 */
export function useProductComparisonPageQuery(baseOptions: Apollo.QueryHookOptions<ProductComparisonPageQuery, ProductComparisonPageQueryVariables> & ({ variables: ProductComparisonPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductComparisonPageQuery, ProductComparisonPageQueryVariables>(ProductComparisonPageDocument, options);
      }
export function useProductComparisonPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductComparisonPageQuery, ProductComparisonPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductComparisonPageQuery, ProductComparisonPageQueryVariables>(ProductComparisonPageDocument, options);
        }
export function useProductComparisonPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductComparisonPageQuery, ProductComparisonPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductComparisonPageQuery, ProductComparisonPageQueryVariables>(ProductComparisonPageDocument, options);
        }
export type ProductComparisonPageQueryHookResult = ReturnType<typeof useProductComparisonPageQuery>;
export type ProductComparisonPageLazyQueryHookResult = ReturnType<typeof useProductComparisonPageLazyQuery>;
export type ProductComparisonPageSuspenseQueryHookResult = ReturnType<typeof useProductComparisonPageSuspenseQuery>;
export type ProductComparisonPageQueryResult = Apollo.QueryResult<ProductComparisonPageQuery, ProductComparisonPageQueryVariables>;
export const ProductListingPageDocument = gql`
    query productListingPage($categorySlug: String!, $context: String!, $pageNumber: String!, $sortBy: String!, $basicFilterData: JSON!, $needsBasedFilterData: JSON!, $selectedNeedsBasedFilters: JSON!, $channel: String) {
  productListingPage(
    categorySlug: $categorySlug
    context: $context
    pageNumber: $pageNumber
    sortBy: $sortBy
    basicFilterData: $basicFilterData
    needsBasedFilterData: $needsBasedFilterData
    selectedNeedsBasedFilters: $selectedNeedsBasedFilters
    channel: $channel
  ) {
    showResubBanner
    breadcrumb {
      heading {
        href
        text
      }
      links {
        href
        text
      }
      currentPage {
        href
        text
      }
      baseUrl
    }
    attributesCount {
      productsCount
      testedProductsCount
      notTestedProductsCount
      bestBuyCount
      dontBuyCount
      firstLookCount
    }
    filters {
      attributeGroup
      predicateType
      externalId
      filterLabel
      filterLabelTooltip {
        label
        description
      }
      caption
      componentType
      exclusion
      disabled
      filterItems {
        __typename
        ... on FilterItemWithValueString {
          valueStr
          code
          label
          count
          order
          tooltip {
            label
            description
          }
        }
        ... on FilterItemWithValueBoolean {
          valueBool
          code
          label
          count
          order
          tooltip {
            label
            description
          }
        }
        ... on FilterItemWithToFrom {
          code
          label
          to
          from
          count
          order
          tooltip {
            label
            description
          }
        }
        ... on FilterItemWithOptions {
          code
          label
          order
          options {
            ... on FilterItemOptionsWithValueBoolean {
              label
              optionValueBool
              optionCount
            }
            ... on FilterItemOptionsWithValueString {
              label
              optionValueStr
              optionCount
            }
          }
          tooltip {
            label
            description
          }
        }
      }
      order
    }
    needsBasedFilters {
      questionText
      externalId
      disabled
      answers {
        caption
        icon
        label
        needsBasedAnswerOptions {
          code
          attributeGroup
          predicateType
          externalId
          valueStr
          valueBool
          to
          from
          bucketLabel
          label
          componentType
        }
      }
    }
    productsWithPagination {
      numberOfPages
      taxonomySlug
      productCount {
        description
        start
        end
        total
      }
      mappedSortedProducts {
        productsSortedByHighestScore {
          category
          overallScore
          manufacturer
          model
          price
          features {
            list
            type
            count
          }
          slug
          badges
          tags
          retailers
          alertType
          image {
            src
            alt
            sources {
              srcset
              sizes
              type
            }
          }
          productScoreGauge {
            label
            testScoreGauge {
              overallScore
              textVariation
            }
            tooltip {
              contents
              title
              ariaLabel
            }
          }
          businessKey
          annualRunningCost {
            priceLabel
            tooltip {
              contents
              title
              ariaLabel
            }
          }
          variantValues {
            code
            value
            label
          }
          variantProducts {
            model
            slug
            variantValues {
              code
              value
              label
            }
            image {
              src
              alt
              sources {
                srcset
                sizes
                type
              }
            }
            businessKey
            tags
          }
          variantPriceRange {
            min {
              formatted
            }
            max {
              formatted
            }
          }
        }
        productsSortedByMostRecentlyReviewed {
          category
          overallScore
          manufacturer
          model
          price
          features {
            list
            type
            count
          }
          slug
          badges
          tags
          retailers
          alertType
          image {
            src
            alt
            sources {
              srcset
              sizes
              type
            }
          }
          productScoreGauge {
            label
            testScoreGauge {
              overallScore
              textVariation
            }
            tooltip {
              contents
              title
              ariaLabel
            }
          }
          businessKey
          annualRunningCost {
            priceLabel
            tooltip {
              contents
              title
              ariaLabel
            }
          }
          variantValues {
            code
            value
            label
          }
          variantProducts {
            model
            slug
            variantValues {
              code
              value
              label
            }
            image {
              src
              alt
              sources {
                srcset
                sizes
                type
              }
            }
            businessKey
            tags
          }
          variantPriceRange {
            min {
              formatted
            }
            max {
              formatted
            }
          }
        }
      }
      products {
        category
        overallScore
        manufacturer
        model
        price
        features {
          list
          type
          count
        }
        slug
        badges
        tags
        retailers
        alertType
        image {
          src
          alt
          sources {
            srcset
            sizes
            type
          }
        }
        productScoreGauge {
          label
          testScoreGauge {
            overallScore
            textVariation
          }
          tooltip {
            contents
            title
            ariaLabel
          }
        }
        businessKey
        annualRunningCost {
          priceLabel
          ranking
          rankingTotal
          tooltip {
            contents
            title
            ariaLabel
          }
        }
        variantValues {
          code
          value
          label
        }
        variantProducts {
          model
          slug
          variantValues {
            code
            value
            label
          }
          image {
            src
            alt
            sources {
              srcset
              sizes
              type
            }
          }
          businessKey
          badges
          tags
          hasRetailers
        }
        variantPriceRange {
          min {
            formatted
          }
          max {
            formatted
          }
        }
      }
      totalRunningCostCount
    }
    meta {
      title
      desc
      pageType
      dataLayer
      taxonomyHierarchy {
        vertical
        subVertical
        superCategory
        category
      }
      canonical
    }
    sortByMenu {
      defaultOption
      items {
        label
        icon
        value
      }
    }
    header {
      description
      heading
      image {
        src
        sources {
          srcset
          media
          sizes
          type
        }
        alt
      }
      labTested
    }
    scoreStatement {
      title
      content
    }
    articleListingWithImage {
      title
      categoryLabel
      categorySlug
      articles {
        id
        label
        slug
      }
    }
    seoContentBlock
    optionalRedirect {
      url
      isExternal
    }
  }
}
    `;

/**
 * __useProductListingPageQuery__
 *
 * To run a query within a React component, call `useProductListingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListingPageQuery({
 *   variables: {
 *      categorySlug: // value for 'categorySlug'
 *      context: // value for 'context'
 *      pageNumber: // value for 'pageNumber'
 *      sortBy: // value for 'sortBy'
 *      basicFilterData: // value for 'basicFilterData'
 *      needsBasedFilterData: // value for 'needsBasedFilterData'
 *      selectedNeedsBasedFilters: // value for 'selectedNeedsBasedFilters'
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function useProductListingPageQuery(baseOptions: Apollo.QueryHookOptions<ProductListingPageQuery, ProductListingPageQueryVariables> & ({ variables: ProductListingPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductListingPageQuery, ProductListingPageQueryVariables>(ProductListingPageDocument, options);
      }
export function useProductListingPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductListingPageQuery, ProductListingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductListingPageQuery, ProductListingPageQueryVariables>(ProductListingPageDocument, options);
        }
export function useProductListingPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductListingPageQuery, ProductListingPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductListingPageQuery, ProductListingPageQueryVariables>(ProductListingPageDocument, options);
        }
export type ProductListingPageQueryHookResult = ReturnType<typeof useProductListingPageQuery>;
export type ProductListingPageLazyQueryHookResult = ReturnType<typeof useProductListingPageLazyQuery>;
export type ProductListingPageSuspenseQueryHookResult = ReturnType<typeof useProductListingPageSuspenseQuery>;
export type ProductListingPageQueryResult = Apollo.QueryResult<ProductListingPageQuery, ProductListingPageQueryVariables>;
export const ProductPageDocument = gql`
    query productPage($categorySlug: String!, $context: String!, $productSlug: String!, $channel: String) {
  productPage(
    categorySlug: $categorySlug
    context: $context
    productSlug: $productSlug
    channel: $channel
  ) {
    transformTypeDecision
    showResubBanner
    breadcrumb {
      heading {
        href
        text
      }
      links {
        href
        text
      }
      currentPage {
        href
        text
      }
      baseUrl
    }
    meta {
      title
      desc
      pageType
      dataLayer
      taxonomyHierarchy {
        vertical
        subVertical
        superCategory
        category
      }
      canonical
    }
    productDetails {
      businessKey
      secondHandText
      keyTestResults {
        label
        value
        tooltip
        isPadlocked
      }
      manufacturer
      tags
      price
      priceValue
      slug
      hasRetailers
      testedType
      productScoreGauge {
        label
        testScoreGauge {
          overallScore
          textVariation
        }
        tooltip {
          contents
          title
          ariaLabel
        }
      }
      editorialReview {
        cta
        verdict
        content
        isPadlocked
        teaser
      }
      expertReview {
        heading
        sections {
          title
          content {
            appearance
            listItems
            paragraph
            imageSrc
            imageAlt
            videoId
            brightcoveAccountId
            techSpecs {
              sectionLabel
              rows {
                rowLabel
                value
                helpText
              }
            }
            testResults {
              heading
              overallScore
              subHeading
              description
              scores {
                label
                starRating
              }
            }
          }
        }
        sectionHeadings
      }
      specifications {
        sectionLabel
        rows {
          rowLabel
          value
          helpText
          restricted
        }
      }
      testResults {
        howWeTest {
          title
          url
          updatedDate
          image {
            src
            alt
            sources {
              srcset
              sizes
              type
            }
          }
        }
        results {
          heading
          overallScore
          subHeading
          description
          scores {
            label
            starRating
          }
        }
      }
      supply {
        indicationPrice
        offers {
          url
          isTrackable
          formattedPrice
          priceValue
          availableInStock
          retailer {
            hasScore
            name
            score
          }
        }
      }
      badges
      model
      pros
      cons
      images {
        alt
        thumbnailAlt
        src
        sources {
          main {
            srcset
            sizes
            type
          }
          thumb {
            srcset
            sizes
            type
          }
        }
        width
        height
        zoomSrc
        zoomSources {
          medium
          large
        }
        zoomWidth
        zoomHeight
      }
      alerts {
        description
        type
      }
      timeline {
        dates {
          date
          label
        }
        helpText
      }
      categoryData {
        renderAccordion
      }
      suggestedAlternatives {
        businessKey
        alertType
        suggestedAlternativeLabel
        manufacturer
        model
        tags
        price
        slug
        hasBadgeZone
        hasRetailers
        image {
          src
          alt
          sources {
            srcset
            sizes
            type
          }
        }
        productScoreGauge {
          label
          variant
          testScoreGauge {
            overallScore
            textVariation
          }
          tooltip {
            contents
            title
            ariaLabel
          }
        }
        badges
      }
      testedDate
      launchDate
      curationDate
      scoreScale {
        heading
        product {
          label
          score
          relativeScorePercentage
          obfuscated
        }
        lowest {
          label
          score
        }
        average {
          label
          score
          relativeScorePercentage
        }
        highest {
          label
          score
        }
      }
      variantValues {
        code
        value
        label
      }
      variantProducts {
        slug
        variantValues {
          code
          value
          label
        }
      }
      variantProductModel
    }
    relatedArticles {
      categoryLabel
      categorySlug
      articles {
        id
        label
        slug
        standfirst
      }
    }
    reviewsSwitchingLink {
      label
      href
      isExternal
    }
    productCounts {
      totalItemCount
      bestBuysCount
      dontBuysCount
    }
  }
}
    `;

/**
 * __useProductPageQuery__
 *
 * To run a query within a React component, call `useProductPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPageQuery({
 *   variables: {
 *      categorySlug: // value for 'categorySlug'
 *      context: // value for 'context'
 *      productSlug: // value for 'productSlug'
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function useProductPageQuery(baseOptions: Apollo.QueryHookOptions<ProductPageQuery, ProductPageQueryVariables> & ({ variables: ProductPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPageQuery, ProductPageQueryVariables>(ProductPageDocument, options);
      }
export function useProductPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPageQuery, ProductPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPageQuery, ProductPageQueryVariables>(ProductPageDocument, options);
        }
export function useProductPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductPageQuery, ProductPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductPageQuery, ProductPageQueryVariables>(ProductPageDocument, options);
        }
export type ProductPageQueryHookResult = ReturnType<typeof useProductPageQuery>;
export type ProductPageLazyQueryHookResult = ReturnType<typeof useProductPageLazyQuery>;
export type ProductPageSuspenseQueryHookResult = ReturnType<typeof useProductPageSuspenseQuery>;
export type ProductPageQueryResult = Apollo.QueryResult<ProductPageQuery, ProductPageQueryVariables>;
export const SavedPageDocument = gql`
    query savedPage {
  savedPage {
    meta {
      dataLayer
      title
      desc
      canonical
    }
    isLoggedIn
    items {
      category
      categorySlug
      products {
        businessKey
        alertType
        manufacturer
        model
        tags
        price
        slug
        badges
        hasBadgeZone
        hasRetailers
        productScoreGauge {
          label
          variant
          testScoreGauge {
            overallScore
            textVariation
          }
          tooltip {
            contents
            title
            ariaLabel
          }
        }
        image {
          src
          alt
          sources {
            srcset
            sizes
            type
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSavedPageQuery__
 *
 * To run a query within a React component, call `useSavedPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavedPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useSavedPageQuery(baseOptions?: Apollo.QueryHookOptions<SavedPageQuery, SavedPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SavedPageQuery, SavedPageQueryVariables>(SavedPageDocument, options);
      }
export function useSavedPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SavedPageQuery, SavedPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SavedPageQuery, SavedPageQueryVariables>(SavedPageDocument, options);
        }
export function useSavedPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SavedPageQuery, SavedPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SavedPageQuery, SavedPageQueryVariables>(SavedPageDocument, options);
        }
export type SavedPageQueryHookResult = ReturnType<typeof useSavedPageQuery>;
export type SavedPageLazyQueryHookResult = ReturnType<typeof useSavedPageLazyQuery>;
export type SavedPageSuspenseQueryHookResult = ReturnType<typeof useSavedPageSuspenseQuery>;
export type SavedPageQueryResult = Apollo.QueryResult<SavedPageQuery, SavedPageQueryVariables>;
export const PolicyAndInsightSearchResultsDocument = gql`
    query PolicyAndInsightSearchResults {
  policyAndInsightArticles {
    label
    total
    articles {
      authors
      date
      estimatedReadingTime
      href
      image
      imageAlt
      standFirst
      title
      topicHeading {
        text
        icon
        category
      }
      category
      trendingTopics
    }
  }
}
    `;

/**
 * __usePolicyAndInsightSearchResultsQuery__
 *
 * To run a query within a React component, call `usePolicyAndInsightSearchResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolicyAndInsightSearchResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePolicyAndInsightSearchResultsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePolicyAndInsightSearchResultsQuery(baseOptions?: Apollo.QueryHookOptions<PolicyAndInsightSearchResultsQuery, PolicyAndInsightSearchResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PolicyAndInsightSearchResultsQuery, PolicyAndInsightSearchResultsQueryVariables>(PolicyAndInsightSearchResultsDocument, options);
      }
export function usePolicyAndInsightSearchResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PolicyAndInsightSearchResultsQuery, PolicyAndInsightSearchResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PolicyAndInsightSearchResultsQuery, PolicyAndInsightSearchResultsQueryVariables>(PolicyAndInsightSearchResultsDocument, options);
        }
export function usePolicyAndInsightSearchResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolicyAndInsightSearchResultsQuery, PolicyAndInsightSearchResultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PolicyAndInsightSearchResultsQuery, PolicyAndInsightSearchResultsQueryVariables>(PolicyAndInsightSearchResultsDocument, options);
        }
export type PolicyAndInsightSearchResultsQueryHookResult = ReturnType<typeof usePolicyAndInsightSearchResultsQuery>;
export type PolicyAndInsightSearchResultsLazyQueryHookResult = ReturnType<typeof usePolicyAndInsightSearchResultsLazyQuery>;
export type PolicyAndInsightSearchResultsSuspenseQueryHookResult = ReturnType<typeof usePolicyAndInsightSearchResultsSuspenseQuery>;
export type PolicyAndInsightSearchResultsQueryResult = Apollo.QueryResult<PolicyAndInsightSearchResultsQuery, PolicyAndInsightSearchResultsQueryVariables>;
export const SubVerticalCampaignPetitionDocument = gql`
    query subVerticalCampaignPetition($subVerticalSlug: String!, $context: String!) {
  subVerticalPage(subVerticalSlug: $subVerticalSlug, context: $context) {
    ... on SubVerticalPage {
      ...BaseSubVerticalPageFragment
      campaignsPetitionCollection {
        contentItems {
          type
          data
        }
        header {
          title
          intro
        }
        petitionDetails {
          formID
          pageID
          targetCount
          manualAdjustment
          activeCampaign
          meta {
            title
            description
            image
          }
        }
      }
      sharingData {
        facebook
        twitter
        whatsapp
        mail
        metaData {
          url
          headline
          fbAppId
          facebookText
          twitterText
          subject
        }
      }
    }
  }
}
    ${BaseSubVerticalPageFragmentFragmentDoc}`;

/**
 * __useSubVerticalCampaignPetitionQuery__
 *
 * To run a query within a React component, call `useSubVerticalCampaignPetitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubVerticalCampaignPetitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubVerticalCampaignPetitionQuery({
 *   variables: {
 *      subVerticalSlug: // value for 'subVerticalSlug'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useSubVerticalCampaignPetitionQuery(baseOptions: Apollo.QueryHookOptions<SubVerticalCampaignPetitionQuery, SubVerticalCampaignPetitionQueryVariables> & ({ variables: SubVerticalCampaignPetitionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubVerticalCampaignPetitionQuery, SubVerticalCampaignPetitionQueryVariables>(SubVerticalCampaignPetitionDocument, options);
      }
export function useSubVerticalCampaignPetitionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubVerticalCampaignPetitionQuery, SubVerticalCampaignPetitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubVerticalCampaignPetitionQuery, SubVerticalCampaignPetitionQueryVariables>(SubVerticalCampaignPetitionDocument, options);
        }
export function useSubVerticalCampaignPetitionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubVerticalCampaignPetitionQuery, SubVerticalCampaignPetitionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubVerticalCampaignPetitionQuery, SubVerticalCampaignPetitionQueryVariables>(SubVerticalCampaignPetitionDocument, options);
        }
export type SubVerticalCampaignPetitionQueryHookResult = ReturnType<typeof useSubVerticalCampaignPetitionQuery>;
export type SubVerticalCampaignPetitionLazyQueryHookResult = ReturnType<typeof useSubVerticalCampaignPetitionLazyQuery>;
export type SubVerticalCampaignPetitionSuspenseQueryHookResult = ReturnType<typeof useSubVerticalCampaignPetitionSuspenseQuery>;
export type SubVerticalCampaignPetitionQueryResult = Apollo.QueryResult<SubVerticalCampaignPetitionQuery, SubVerticalCampaignPetitionQueryVariables>;
export const SubVerticalCrScamsTopicPageDocument = gql`
    query subVerticalCRScamsTopicPage($subVerticalSlug: String!, $context: String!) {
  subVerticalPage(subVerticalSlug: $subVerticalSlug, context: $context) {
    ... on SubVerticalPage {
      ...BaseSubVerticalPageFragment
      header {
        title
        image {
          sources {
            media
            srcset
            sizes
          }
          src
          alt
        }
        intro
      }
      taxonomyConversionBanner {
        title
        description
        descriptionMobile
        buttonText
        buttonURL
      }
      callout {
        byline
        description
        imageFormat
        title
        items {
          image {
            alt
            src
            sources {
              srcset
              sizes
            }
          }
          strapline
          title
          href
        }
      }
      consumerRightsFooter {
        description
        items {
          title
          links {
            text
            href
          }
        }
        social {
          text
          href
          type
        }
      }
    }
  }
  latestNews(tagSlug: $subVerticalSlug, pageSize: 4) {
    articles {
      title
      href
      imageWithSources {
        src
        alt
        sources {
          srcset
          sizes
        }
      }
    }
  }
}
    ${BaseSubVerticalPageFragmentFragmentDoc}`;

/**
 * __useSubVerticalCrScamsTopicPageQuery__
 *
 * To run a query within a React component, call `useSubVerticalCrScamsTopicPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubVerticalCrScamsTopicPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubVerticalCrScamsTopicPageQuery({
 *   variables: {
 *      subVerticalSlug: // value for 'subVerticalSlug'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useSubVerticalCrScamsTopicPageQuery(baseOptions: Apollo.QueryHookOptions<SubVerticalCrScamsTopicPageQuery, SubVerticalCrScamsTopicPageQueryVariables> & ({ variables: SubVerticalCrScamsTopicPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubVerticalCrScamsTopicPageQuery, SubVerticalCrScamsTopicPageQueryVariables>(SubVerticalCrScamsTopicPageDocument, options);
      }
export function useSubVerticalCrScamsTopicPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubVerticalCrScamsTopicPageQuery, SubVerticalCrScamsTopicPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubVerticalCrScamsTopicPageQuery, SubVerticalCrScamsTopicPageQueryVariables>(SubVerticalCrScamsTopicPageDocument, options);
        }
export function useSubVerticalCrScamsTopicPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubVerticalCrScamsTopicPageQuery, SubVerticalCrScamsTopicPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubVerticalCrScamsTopicPageQuery, SubVerticalCrScamsTopicPageQueryVariables>(SubVerticalCrScamsTopicPageDocument, options);
        }
export type SubVerticalCrScamsTopicPageQueryHookResult = ReturnType<typeof useSubVerticalCrScamsTopicPageQuery>;
export type SubVerticalCrScamsTopicPageLazyQueryHookResult = ReturnType<typeof useSubVerticalCrScamsTopicPageLazyQuery>;
export type SubVerticalCrScamsTopicPageSuspenseQueryHookResult = ReturnType<typeof useSubVerticalCrScamsTopicPageSuspenseQuery>;
export type SubVerticalCrScamsTopicPageQueryResult = Apollo.QueryResult<SubVerticalCrScamsTopicPageQuery, SubVerticalCrScamsTopicPageQueryVariables>;
export const SubVerticalCrTopicPageDocument = gql`
    query subVerticalCRTopicPage($subVerticalSlug: String!, $context: String!) {
  subVerticalPage(subVerticalSlug: $subVerticalSlug, context: $context) {
    ... on SubVerticalPage {
      ...BaseSubVerticalPageFragment
      header {
        title
        image {
          sources {
            media
            srcset
            sizes
          }
          src
          alt
        }
        intro
      }
      taxonomyConversionBanner {
        title
        description
        descriptionMobile
        buttonText
        buttonURL
      }
      crCategories {
        jumpLinks {
          links {
            id
            label
          }
        }
        sections {
          title
          id
          description
          articleLinks {
            text
            href
          }
          link {
            text
            href
          }
        }
      }
      callout {
        byline
        description
        imageFormat
        title
        items {
          image {
            alt
            src
            sources {
              srcset
              sizes
            }
          }
          strapline
          title
          href
        }
      }
      consumerRightsFooter {
        description
        items {
          title
          links {
            text
            href
          }
        }
        social {
          text
          href
          type
        }
      }
    }
  }
}
    ${BaseSubVerticalPageFragmentFragmentDoc}`;

/**
 * __useSubVerticalCrTopicPageQuery__
 *
 * To run a query within a React component, call `useSubVerticalCrTopicPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubVerticalCrTopicPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubVerticalCrTopicPageQuery({
 *   variables: {
 *      subVerticalSlug: // value for 'subVerticalSlug'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useSubVerticalCrTopicPageQuery(baseOptions: Apollo.QueryHookOptions<SubVerticalCrTopicPageQuery, SubVerticalCrTopicPageQueryVariables> & ({ variables: SubVerticalCrTopicPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubVerticalCrTopicPageQuery, SubVerticalCrTopicPageQueryVariables>(SubVerticalCrTopicPageDocument, options);
      }
export function useSubVerticalCrTopicPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubVerticalCrTopicPageQuery, SubVerticalCrTopicPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubVerticalCrTopicPageQuery, SubVerticalCrTopicPageQueryVariables>(SubVerticalCrTopicPageDocument, options);
        }
export function useSubVerticalCrTopicPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubVerticalCrTopicPageQuery, SubVerticalCrTopicPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubVerticalCrTopicPageQuery, SubVerticalCrTopicPageQueryVariables>(SubVerticalCrTopicPageDocument, options);
        }
export type SubVerticalCrTopicPageQueryHookResult = ReturnType<typeof useSubVerticalCrTopicPageQuery>;
export type SubVerticalCrTopicPageLazyQueryHookResult = ReturnType<typeof useSubVerticalCrTopicPageLazyQuery>;
export type SubVerticalCrTopicPageSuspenseQueryHookResult = ReturnType<typeof useSubVerticalCrTopicPageSuspenseQuery>;
export type SubVerticalCrTopicPageQueryResult = Apollo.QueryResult<SubVerticalCrTopicPageQuery, SubVerticalCrTopicPageQueryVariables>;
export const SubVerticalHubPageDocument = gql`
    query subVerticalHubPage($subVerticalSlug: String!, $context: String!) {
  subVerticalPage(subVerticalSlug: $subVerticalSlug, context: $context) {
    ... on SubVerticalPage {
      ...BaseSubVerticalPageFragment
      hubPageContent {
        latestNewsTag {
          label
          slug
        }
        mainFeaturedArticle {
          heading
          summary
          date {
            rendered
            iso
          }
          url
          image {
            id
            src
            alt
            sources {
              srcset
              sizes
            }
          }
        }
        contentItems {
          type
          data
        }
        header {
          title
          intro
        }
      }
      hubPageLatestNews {
        articles {
          title
          imageWithSources {
            src
            alt
            sources {
              srcset
              media
              sizes
            }
          }
          href
          dateInfo {
            rendered
            iso
          }
          authors {
            name
            image {
              src
            }
          }
        }
      }
      sharingData {
        facebook
        twitter
        whatsapp
        mail
        metaData {
          url
          headline
          fbAppId
          facebookText
          twitterText
          subject
        }
      }
    }
  }
}
    ${BaseSubVerticalPageFragmentFragmentDoc}`;

/**
 * __useSubVerticalHubPageQuery__
 *
 * To run a query within a React component, call `useSubVerticalHubPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubVerticalHubPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubVerticalHubPageQuery({
 *   variables: {
 *      subVerticalSlug: // value for 'subVerticalSlug'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useSubVerticalHubPageQuery(baseOptions: Apollo.QueryHookOptions<SubVerticalHubPageQuery, SubVerticalHubPageQueryVariables> & ({ variables: SubVerticalHubPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubVerticalHubPageQuery, SubVerticalHubPageQueryVariables>(SubVerticalHubPageDocument, options);
      }
export function useSubVerticalHubPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubVerticalHubPageQuery, SubVerticalHubPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubVerticalHubPageQuery, SubVerticalHubPageQueryVariables>(SubVerticalHubPageDocument, options);
        }
export function useSubVerticalHubPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubVerticalHubPageQuery, SubVerticalHubPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubVerticalHubPageQuery, SubVerticalHubPageQueryVariables>(SubVerticalHubPageDocument, options);
        }
export type SubVerticalHubPageQueryHookResult = ReturnType<typeof useSubVerticalHubPageQuery>;
export type SubVerticalHubPageLazyQueryHookResult = ReturnType<typeof useSubVerticalHubPageLazyQuery>;
export type SubVerticalHubPageSuspenseQueryHookResult = ReturnType<typeof useSubVerticalHubPageSuspenseQuery>;
export type SubVerticalHubPageQueryResult = Apollo.QueryResult<SubVerticalHubPageQuery, SubVerticalHubPageQueryVariables>;
export const SubVerticalNewsPageDocument = gql`
    query subVerticalNewsPage($subVerticalSlug: String!, $context: String!, $pageNumber: Int, $verticalSlug: String) {
  subVerticalPage(
    subVerticalSlug: $subVerticalSlug
    context: $context
    pageNumber: $pageNumber
    verticalSlug: $verticalSlug
  ) {
    ... on SubVerticalPage {
      ...BaseSubVerticalPageFragment
      header {
        title
        intro
      }
      taxonomyHierarchyWithCounts {
        slug
        name
        count
        categories {
          slug
          name
          count
        }
      }
      newsArticles {
        pagedArticles {
          total
          articles {
            headline
            summary
            url
            image {
              src
              alt
              sources {
                srcset
                sizes
              }
            }
            primaryTaxonomy {
              name
              url
            }
            updatedDate {
              rendered
              iso
            }
          }
        }
      }
    }
  }
}
    ${BaseSubVerticalPageFragmentFragmentDoc}`;

/**
 * __useSubVerticalNewsPageQuery__
 *
 * To run a query within a React component, call `useSubVerticalNewsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubVerticalNewsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubVerticalNewsPageQuery({
 *   variables: {
 *      subVerticalSlug: // value for 'subVerticalSlug'
 *      context: // value for 'context'
 *      pageNumber: // value for 'pageNumber'
 *      verticalSlug: // value for 'verticalSlug'
 *   },
 * });
 */
export function useSubVerticalNewsPageQuery(baseOptions: Apollo.QueryHookOptions<SubVerticalNewsPageQuery, SubVerticalNewsPageQueryVariables> & ({ variables: SubVerticalNewsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubVerticalNewsPageQuery, SubVerticalNewsPageQueryVariables>(SubVerticalNewsPageDocument, options);
      }
export function useSubVerticalNewsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubVerticalNewsPageQuery, SubVerticalNewsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubVerticalNewsPageQuery, SubVerticalNewsPageQueryVariables>(SubVerticalNewsPageDocument, options);
        }
export function useSubVerticalNewsPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubVerticalNewsPageQuery, SubVerticalNewsPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubVerticalNewsPageQuery, SubVerticalNewsPageQueryVariables>(SubVerticalNewsPageDocument, options);
        }
export type SubVerticalNewsPageQueryHookResult = ReturnType<typeof useSubVerticalNewsPageQuery>;
export type SubVerticalNewsPageLazyQueryHookResult = ReturnType<typeof useSubVerticalNewsPageLazyQuery>;
export type SubVerticalNewsPageSuspenseQueryHookResult = ReturnType<typeof useSubVerticalNewsPageSuspenseQuery>;
export type SubVerticalNewsPageQueryResult = Apollo.QueryResult<SubVerticalNewsPageQuery, SubVerticalNewsPageQueryVariables>;
export const SubVerticalPolicyAndInsightLandingDocument = gql`
    query subVerticalPolicyAndInsightLanding($subVerticalSlug: String!, $context: String!) {
  subVerticalPage(subVerticalSlug: $subVerticalSlug, context: $context) {
    ... on SubVerticalPage {
      ...BaseSubVerticalPageFragment
      policyAndInsightLandingCollection {
        contentItems {
          type
          data
        }
        meta {
          title
          description
          image
        }
      }
    }
  }
}
    ${BaseSubVerticalPageFragmentFragmentDoc}`;

/**
 * __useSubVerticalPolicyAndInsightLandingQuery__
 *
 * To run a query within a React component, call `useSubVerticalPolicyAndInsightLandingQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubVerticalPolicyAndInsightLandingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubVerticalPolicyAndInsightLandingQuery({
 *   variables: {
 *      subVerticalSlug: // value for 'subVerticalSlug'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useSubVerticalPolicyAndInsightLandingQuery(baseOptions: Apollo.QueryHookOptions<SubVerticalPolicyAndInsightLandingQuery, SubVerticalPolicyAndInsightLandingQueryVariables> & ({ variables: SubVerticalPolicyAndInsightLandingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubVerticalPolicyAndInsightLandingQuery, SubVerticalPolicyAndInsightLandingQueryVariables>(SubVerticalPolicyAndInsightLandingDocument, options);
      }
export function useSubVerticalPolicyAndInsightLandingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubVerticalPolicyAndInsightLandingQuery, SubVerticalPolicyAndInsightLandingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubVerticalPolicyAndInsightLandingQuery, SubVerticalPolicyAndInsightLandingQueryVariables>(SubVerticalPolicyAndInsightLandingDocument, options);
        }
export function useSubVerticalPolicyAndInsightLandingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubVerticalPolicyAndInsightLandingQuery, SubVerticalPolicyAndInsightLandingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubVerticalPolicyAndInsightLandingQuery, SubVerticalPolicyAndInsightLandingQueryVariables>(SubVerticalPolicyAndInsightLandingDocument, options);
        }
export type SubVerticalPolicyAndInsightLandingQueryHookResult = ReturnType<typeof useSubVerticalPolicyAndInsightLandingQuery>;
export type SubVerticalPolicyAndInsightLandingLazyQueryHookResult = ReturnType<typeof useSubVerticalPolicyAndInsightLandingLazyQuery>;
export type SubVerticalPolicyAndInsightLandingSuspenseQueryHookResult = ReturnType<typeof useSubVerticalPolicyAndInsightLandingSuspenseQuery>;
export type SubVerticalPolicyAndInsightLandingQueryResult = Apollo.QueryResult<SubVerticalPolicyAndInsightLandingQuery, SubVerticalPolicyAndInsightLandingQueryVariables>;
export const SubVerticalReviewsPageDocument = gql`
    query subVerticalReviewsPage($subVerticalSlug: String!, $context: String!) {
  subVerticalPage(subVerticalSlug: $subVerticalSlug, context: $context) {
    ... on SubVerticalPage {
      ...BaseSubVerticalPageFragment
      header {
        title
        image {
          sources {
            media
            srcset
            sizes
          }
          src
          alt
        }
        intro
        links {
          href
          text
        }
        backgroundColour
      }
      taxonomyConversionBanner {
        title
        description
        descriptionMobile
        buttonText
        buttonURL
      }
      reviewsCategories {
        jumpLinks {
          links {
            id
            label
            slug
          }
        }
        sections {
          sectionId
          id
          collectionName
          cards {
            link {
              text
              href
            }
            titleLink
            heading
            image {
              sources {
                srcset
                media
                sizes
              }
              src
              alt
            }
            items {
              href
              text
              linkType
            }
          }
        }
      }
      subVerticalOptionalData {
        components {
          bannerSignUpComponentData {
            image {
              src
              sources {
                srcset
                media
                type
                sizes
              }
            }
            title
            text
            linkText
            linkUrl
            backgroundColour
            facebookUrl
            twitterUrl
            buttonType
          }
          toolCTA {
            title
            description
            widgetImageAspectRatio
            image {
              src
              sources {
                srcset
                media
                type
                sizes
              }
              alt
            }
            button {
              href
              text
            }
            linksListExpandableData {
              button {
                text
                ariaLabel
              }
              items {
                href
                label
              }
            }
          }
          relatedGuides {
            title
            guides {
              heading
              items {
                href
                text
              }
              link {
                text
                href
              }
            }
          }
          localFooter {
            description
            items {
              title
              links {
                text
                href
              }
            }
            social {
              text
              href
              type
            }
          }
        }
      }
      latestNews {
        name
        articles {
          title
          href
          dateInfo {
            rendered
            iso
          }
          imageWithSources {
            src
            alt
            sources {
              srcset
              media
              sizes
            }
          }
        }
      }
      categoryLinks {
        href
        children
      }
    }
  }
}
    ${BaseSubVerticalPageFragmentFragmentDoc}`;

/**
 * __useSubVerticalReviewsPageQuery__
 *
 * To run a query within a React component, call `useSubVerticalReviewsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubVerticalReviewsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubVerticalReviewsPageQuery({
 *   variables: {
 *      subVerticalSlug: // value for 'subVerticalSlug'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useSubVerticalReviewsPageQuery(baseOptions: Apollo.QueryHookOptions<SubVerticalReviewsPageQuery, SubVerticalReviewsPageQueryVariables> & ({ variables: SubVerticalReviewsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubVerticalReviewsPageQuery, SubVerticalReviewsPageQueryVariables>(SubVerticalReviewsPageDocument, options);
      }
export function useSubVerticalReviewsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubVerticalReviewsPageQuery, SubVerticalReviewsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubVerticalReviewsPageQuery, SubVerticalReviewsPageQueryVariables>(SubVerticalReviewsPageDocument, options);
        }
export function useSubVerticalReviewsPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubVerticalReviewsPageQuery, SubVerticalReviewsPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubVerticalReviewsPageQuery, SubVerticalReviewsPageQueryVariables>(SubVerticalReviewsPageDocument, options);
        }
export type SubVerticalReviewsPageQueryHookResult = ReturnType<typeof useSubVerticalReviewsPageQuery>;
export type SubVerticalReviewsPageLazyQueryHookResult = ReturnType<typeof useSubVerticalReviewsPageLazyQuery>;
export type SubVerticalReviewsPageSuspenseQueryHookResult = ReturnType<typeof useSubVerticalReviewsPageSuspenseQuery>;
export type SubVerticalReviewsPageQueryResult = Apollo.QueryResult<SubVerticalReviewsPageQuery, SubVerticalReviewsPageQueryVariables>;
export const ToolsPageDocument = gql`
    query toolsPage {
  toolsPage {
    consumerRightsFooter {
      description
      items {
        title
        links {
          text
          href
        }
      }
      social {
        text
        href
        type
      }
    }
    transformTypeDecision
  }
}
    `;

/**
 * __useToolsPageQuery__
 *
 * To run a query within a React component, call `useToolsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useToolsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useToolsPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useToolsPageQuery(baseOptions?: Apollo.QueryHookOptions<ToolsPageQuery, ToolsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ToolsPageQuery, ToolsPageQueryVariables>(ToolsPageDocument, options);
      }
export function useToolsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ToolsPageQuery, ToolsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ToolsPageQuery, ToolsPageQueryVariables>(ToolsPageDocument, options);
        }
export function useToolsPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ToolsPageQuery, ToolsPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ToolsPageQuery, ToolsPageQueryVariables>(ToolsPageDocument, options);
        }
export type ToolsPageQueryHookResult = ReturnType<typeof useToolsPageQuery>;
export type ToolsPageLazyQueryHookResult = ReturnType<typeof useToolsPageLazyQuery>;
export type ToolsPageSuspenseQueryHookResult = ReturnType<typeof useToolsPageSuspenseQuery>;
export type ToolsPageQueryResult = Apollo.QueryResult<ToolsPageQuery, ToolsPageQueryVariables>;
export const NewsListingVerticalDocument = gql`
    query newsListingVertical($verticalSlug: String!, $pageNumber: Int) {
  verticalPage(verticalSlug: $verticalSlug, pageNumber: $pageNumber) {
    ... on VerticalPage {
      __typename
      meta {
        title
        desc
        fbAppId
        dataLayer
        pageType
        canonical
        taxonomyHierarchy {
          vertical
        }
      }
      header {
        title
        description
        standfirst
      }
      newsArticles {
        pagedArticles {
          total
          articles {
            headline
            summary
            url
            image {
              src
              alt
              sources {
                srcset
                sizes
              }
            }
            primaryTaxonomy {
              name
              url
            }
            updatedDate {
              rendered
              iso
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useNewsListingVerticalQuery__
 *
 * To run a query within a React component, call `useNewsListingVerticalQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsListingVerticalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsListingVerticalQuery({
 *   variables: {
 *      verticalSlug: // value for 'verticalSlug'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useNewsListingVerticalQuery(baseOptions: Apollo.QueryHookOptions<NewsListingVerticalQuery, NewsListingVerticalQueryVariables> & ({ variables: NewsListingVerticalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsListingVerticalQuery, NewsListingVerticalQueryVariables>(NewsListingVerticalDocument, options);
      }
export function useNewsListingVerticalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsListingVerticalQuery, NewsListingVerticalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsListingVerticalQuery, NewsListingVerticalQueryVariables>(NewsListingVerticalDocument, options);
        }
export function useNewsListingVerticalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NewsListingVerticalQuery, NewsListingVerticalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NewsListingVerticalQuery, NewsListingVerticalQueryVariables>(NewsListingVerticalDocument, options);
        }
export type NewsListingVerticalQueryHookResult = ReturnType<typeof useNewsListingVerticalQuery>;
export type NewsListingVerticalLazyQueryHookResult = ReturnType<typeof useNewsListingVerticalLazyQuery>;
export type NewsListingVerticalSuspenseQueryHookResult = ReturnType<typeof useNewsListingVerticalSuspenseQuery>;
export type NewsListingVerticalQueryResult = Apollo.QueryResult<NewsListingVerticalQuery, NewsListingVerticalQueryVariables>;
export const NewsVerticalDocument = gql`
    query newsVertical($verticalSlug: String!) {
  verticalPage(verticalSlug: $verticalSlug) {
    ... on VerticalPage {
      __typename
      meta {
        title
        desc
        fbAppId
        dataLayer
        pageType
        canonical
        taxonomyHierarchy {
          vertical
        }
      }
      header {
        title
        description
        standfirst
      }
      latestNews {
        name
        articles {
          title
          imageWithSources {
            src
            alt
            sources {
              srcset
              sizes
            }
          }
          href
          dateInfo {
            rendered
            iso
          }
        }
      }
      newsCardsCollections {
        mainFeaturedArticle {
          heading
          summary
          date {
            rendered
            iso
          }
          url
          image {
            src
            alt
            sources {
              srcset
              sizes
            }
          }
        }
        mostReadArticles {
          title
          links {
            href
            text
          }
        }
        collections {
          taxonomy {
            name
            slug
          }
          featuredArticle {
            heading
            summary
            date {
              rendered
              iso
            }
            url
            image {
              src
              alt
              sources {
                srcset
                sizes
              }
            }
          }
          cards {
            heading
            date {
              rendered
              iso
            }
            url
            image {
              src
              alt
              sources {
                srcset
                sizes
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useNewsVerticalQuery__
 *
 * To run a query within a React component, call `useNewsVerticalQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsVerticalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsVerticalQuery({
 *   variables: {
 *      verticalSlug: // value for 'verticalSlug'
 *   },
 * });
 */
export function useNewsVerticalQuery(baseOptions: Apollo.QueryHookOptions<NewsVerticalQuery, NewsVerticalQueryVariables> & ({ variables: NewsVerticalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsVerticalQuery, NewsVerticalQueryVariables>(NewsVerticalDocument, options);
      }
export function useNewsVerticalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsVerticalQuery, NewsVerticalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsVerticalQuery, NewsVerticalQueryVariables>(NewsVerticalDocument, options);
        }
export function useNewsVerticalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NewsVerticalQuery, NewsVerticalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NewsVerticalQuery, NewsVerticalQueryVariables>(NewsVerticalDocument, options);
        }
export type NewsVerticalQueryHookResult = ReturnType<typeof useNewsVerticalQuery>;
export type NewsVerticalLazyQueryHookResult = ReturnType<typeof useNewsVerticalLazyQuery>;
export type NewsVerticalSuspenseQueryHookResult = ReturnType<typeof useNewsVerticalSuspenseQuery>;
export type NewsVerticalQueryResult = Apollo.QueryResult<NewsVerticalQuery, NewsVerticalQueryVariables>;
export const ReviewsVerticalDocument = gql`
    query reviewsVertical($verticalSlug: String!) {
  verticalPage(verticalSlug: $verticalSlug) {
    ... on VerticalPage {
      __typename
      meta {
        title
        desc
        fbAppId
        dataLayer
        pageType
        canonical
        taxonomyHierarchy {
          vertical
        }
      }
      header {
        description
        title
        image {
          src
          sources {
            srcset
            media
            sizes
          }
          alt
        }
        standfirst
        links {
          href
          text
        }
        backgroundColour
      }
      subVerticalLinks {
        name
        links {
          href
          children
        }
      }
      adviceCards {
        heading
        cards {
          href
          linkText
          strapline
          title
        }
      }
      articleCards {
        cards {
          heading
          image {
            alt
            sources {
              srcset
              sizes
            }
            src
          }
          links {
            href
            text
          }
          viewAll {
            text
            href
          }
        }
        heading
      }
      latestNews {
        name
        articles {
          title
          href
          imageWithSources {
            src
            alt
            sources {
              srcset
              sizes
            }
          }
          dateInfo {
            rendered
          }
        }
      }
      optionalData {
        components {
          newsletterSignUpWithImage {
            source
            image {
              alt
              caption
              id
              src
              sources {
                srcset
                sizes
              }
            }
          }
          podcastComponentData {
            header
            title
            info
            iframeContent
            link {
              href
              text
            }
          }
          bannerSignUpComponentData {
            image {
              src
              sources {
                srcset
                media
                type
                sizes
              }
            }
            title
            text
            linkText
            linkUrl
            backgroundColour
            facebookUrl
            twitterUrl
            buttonType
          }
        }
      }
      showResubBanner
    }
  }
}
    `;

/**
 * __useReviewsVerticalQuery__
 *
 * To run a query within a React component, call `useReviewsVerticalQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsVerticalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewsVerticalQuery({
 *   variables: {
 *      verticalSlug: // value for 'verticalSlug'
 *   },
 * });
 */
export function useReviewsVerticalQuery(baseOptions: Apollo.QueryHookOptions<ReviewsVerticalQuery, ReviewsVerticalQueryVariables> & ({ variables: ReviewsVerticalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReviewsVerticalQuery, ReviewsVerticalQueryVariables>(ReviewsVerticalDocument, options);
      }
export function useReviewsVerticalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReviewsVerticalQuery, ReviewsVerticalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReviewsVerticalQuery, ReviewsVerticalQueryVariables>(ReviewsVerticalDocument, options);
        }
export function useReviewsVerticalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReviewsVerticalQuery, ReviewsVerticalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReviewsVerticalQuery, ReviewsVerticalQueryVariables>(ReviewsVerticalDocument, options);
        }
export type ReviewsVerticalQueryHookResult = ReturnType<typeof useReviewsVerticalQuery>;
export type ReviewsVerticalLazyQueryHookResult = ReturnType<typeof useReviewsVerticalLazyQuery>;
export type ReviewsVerticalSuspenseQueryHookResult = ReturnType<typeof useReviewsVerticalSuspenseQuery>;
export type ReviewsVerticalQueryResult = Apollo.QueryResult<ReviewsVerticalQuery, ReviewsVerticalQueryVariables>;
export const VerticalAboutWhichPageDocument = gql`
    query verticalAboutWhichPage($verticalSlug: String!) {
  verticalPage(verticalSlug: $verticalSlug) {
    ... on VerticalPage {
      __typename
      ...BaseVerticalFragment
      aboutWhich {
        subVerticalArticles {
          url
          title
          description
          image
        }
        promoUrls {
          url
          title
          description
          image
        }
        moreArticles {
          heading
          cards {
            url
            title
            description
            image
            updatedAt
          }
        }
      }
    }
  }
}
    ${BaseVerticalFragmentFragmentDoc}`;

/**
 * __useVerticalAboutWhichPageQuery__
 *
 * To run a query within a React component, call `useVerticalAboutWhichPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerticalAboutWhichPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerticalAboutWhichPageQuery({
 *   variables: {
 *      verticalSlug: // value for 'verticalSlug'
 *   },
 * });
 */
export function useVerticalAboutWhichPageQuery(baseOptions: Apollo.QueryHookOptions<VerticalAboutWhichPageQuery, VerticalAboutWhichPageQueryVariables> & ({ variables: VerticalAboutWhichPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerticalAboutWhichPageQuery, VerticalAboutWhichPageQueryVariables>(VerticalAboutWhichPageDocument, options);
      }
export function useVerticalAboutWhichPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerticalAboutWhichPageQuery, VerticalAboutWhichPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerticalAboutWhichPageQuery, VerticalAboutWhichPageQueryVariables>(VerticalAboutWhichPageDocument, options);
        }
export function useVerticalAboutWhichPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VerticalAboutWhichPageQuery, VerticalAboutWhichPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VerticalAboutWhichPageQuery, VerticalAboutWhichPageQueryVariables>(VerticalAboutWhichPageDocument, options);
        }
export type VerticalAboutWhichPageQueryHookResult = ReturnType<typeof useVerticalAboutWhichPageQuery>;
export type VerticalAboutWhichPageLazyQueryHookResult = ReturnType<typeof useVerticalAboutWhichPageLazyQuery>;
export type VerticalAboutWhichPageSuspenseQueryHookResult = ReturnType<typeof useVerticalAboutWhichPageSuspenseQuery>;
export type VerticalAboutWhichPageQueryResult = Apollo.QueryResult<VerticalAboutWhichPageQuery, VerticalAboutWhichPageQueryVariables>;
export const VerticalCampaignsPageDocument = gql`
    query verticalCampaignsPage($verticalSlug: String!) {
  verticalPage(verticalSlug: $verticalSlug) {
    ... on VerticalPage {
      __typename
      meta {
        title
        desc
        fbAppId
        dataLayer
        pageType
        canonical
        taxonomyHierarchy {
          vertical
        }
      }
      campaignsHomepageContent {
        contentItems {
          type
          data
        }
      }
    }
  }
}
    `;

/**
 * __useVerticalCampaignsPageQuery__
 *
 * To run a query within a React component, call `useVerticalCampaignsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerticalCampaignsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerticalCampaignsPageQuery({
 *   variables: {
 *      verticalSlug: // value for 'verticalSlug'
 *   },
 * });
 */
export function useVerticalCampaignsPageQuery(baseOptions: Apollo.QueryHookOptions<VerticalCampaignsPageQuery, VerticalCampaignsPageQueryVariables> & ({ variables: VerticalCampaignsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerticalCampaignsPageQuery, VerticalCampaignsPageQueryVariables>(VerticalCampaignsPageDocument, options);
      }
export function useVerticalCampaignsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerticalCampaignsPageQuery, VerticalCampaignsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerticalCampaignsPageQuery, VerticalCampaignsPageQueryVariables>(VerticalCampaignsPageDocument, options);
        }
export function useVerticalCampaignsPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VerticalCampaignsPageQuery, VerticalCampaignsPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VerticalCampaignsPageQuery, VerticalCampaignsPageQueryVariables>(VerticalCampaignsPageDocument, options);
        }
export type VerticalCampaignsPageQueryHookResult = ReturnType<typeof useVerticalCampaignsPageQuery>;
export type VerticalCampaignsPageLazyQueryHookResult = ReturnType<typeof useVerticalCampaignsPageLazyQuery>;
export type VerticalCampaignsPageSuspenseQueryHookResult = ReturnType<typeof useVerticalCampaignsPageSuspenseQuery>;
export type VerticalCampaignsPageQueryResult = Apollo.QueryResult<VerticalCampaignsPageQuery, VerticalCampaignsPageQueryVariables>;
export const VerticalCrPageDocument = gql`
    query verticalCrPage($verticalSlug: String!) {
  verticalPage(verticalSlug: $verticalSlug) {
    ... on VerticalPage {
      __typename
      ...BaseVerticalFragment
      breadcrumb {
        heading {
          href
          text
        }
        links {
          href
          text
        }
        currentPage {
          href
          text
        }
        baseUrl
      }
      callout {
        byline
        description
        imageFormat
        title
        items {
          image {
            alt
            src
            sources {
              srcset
              sizes
            }
          }
          strapline
          title
          href
        }
      }
      consumerRegulations {
        title
        items {
          title
          href
          standfirst
          authors {
            name
            image {
              src
              sources {
                srcset
                sizes
              }
            }
          }
        }
        all {
          text
          href
        }
      }
      consumerRightsFooter {
        description
        items {
          title
          links {
            text
            href
          }
        }
        social {
          text
          href
          type
        }
      }
      latestNews {
        name
        articles {
          title
          href
          imageWithSources {
            src
            alt
            sources {
              srcset
              sizes
            }
          }
          authors {
            name
            image {
              src
              sources {
                srcset
                sizes
              }
            }
          }
        }
      }
    }
  }
}
    ${BaseVerticalFragmentFragmentDoc}`;

/**
 * __useVerticalCrPageQuery__
 *
 * To run a query within a React component, call `useVerticalCrPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerticalCrPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerticalCrPageQuery({
 *   variables: {
 *      verticalSlug: // value for 'verticalSlug'
 *   },
 * });
 */
export function useVerticalCrPageQuery(baseOptions: Apollo.QueryHookOptions<VerticalCrPageQuery, VerticalCrPageQueryVariables> & ({ variables: VerticalCrPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerticalCrPageQuery, VerticalCrPageQueryVariables>(VerticalCrPageDocument, options);
      }
export function useVerticalCrPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerticalCrPageQuery, VerticalCrPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerticalCrPageQuery, VerticalCrPageQueryVariables>(VerticalCrPageDocument, options);
        }
export function useVerticalCrPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VerticalCrPageQuery, VerticalCrPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VerticalCrPageQuery, VerticalCrPageQueryVariables>(VerticalCrPageDocument, options);
        }
export type VerticalCrPageQueryHookResult = ReturnType<typeof useVerticalCrPageQuery>;
export type VerticalCrPageLazyQueryHookResult = ReturnType<typeof useVerticalCrPageLazyQuery>;
export type VerticalCrPageSuspenseQueryHookResult = ReturnType<typeof useVerticalCrPageSuspenseQuery>;
export type VerticalCrPageQueryResult = Apollo.QueryResult<VerticalCrPageQuery, VerticalCrPageQueryVariables>;
export const VerticalMyAppointmentsPageDocument = gql`
    query verticalMyAppointmentsPage($verticalSlug: String!) {
  verticalPage(verticalSlug: $verticalSlug) {
    ... on VerticalPage {
      __typename
      meta {
        title
        desc
        fbAppId
        dataLayer
        pageType
        canonical
        taxonomyHierarchy {
          vertical
        }
      }
      header {
        title
        description
        standfirst
      }
    }
  }
}
    `;

/**
 * __useVerticalMyAppointmentsPageQuery__
 *
 * To run a query within a React component, call `useVerticalMyAppointmentsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerticalMyAppointmentsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerticalMyAppointmentsPageQuery({
 *   variables: {
 *      verticalSlug: // value for 'verticalSlug'
 *   },
 * });
 */
export function useVerticalMyAppointmentsPageQuery(baseOptions: Apollo.QueryHookOptions<VerticalMyAppointmentsPageQuery, VerticalMyAppointmentsPageQueryVariables> & ({ variables: VerticalMyAppointmentsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerticalMyAppointmentsPageQuery, VerticalMyAppointmentsPageQueryVariables>(VerticalMyAppointmentsPageDocument, options);
      }
export function useVerticalMyAppointmentsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerticalMyAppointmentsPageQuery, VerticalMyAppointmentsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerticalMyAppointmentsPageQuery, VerticalMyAppointmentsPageQueryVariables>(VerticalMyAppointmentsPageDocument, options);
        }
export function useVerticalMyAppointmentsPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VerticalMyAppointmentsPageQuery, VerticalMyAppointmentsPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VerticalMyAppointmentsPageQuery, VerticalMyAppointmentsPageQueryVariables>(VerticalMyAppointmentsPageDocument, options);
        }
export type VerticalMyAppointmentsPageQueryHookResult = ReturnType<typeof useVerticalMyAppointmentsPageQuery>;
export type VerticalMyAppointmentsPageLazyQueryHookResult = ReturnType<typeof useVerticalMyAppointmentsPageLazyQuery>;
export type VerticalMyAppointmentsPageSuspenseQueryHookResult = ReturnType<typeof useVerticalMyAppointmentsPageSuspenseQuery>;
export type VerticalMyAppointmentsPageQueryResult = Apollo.QueryResult<VerticalMyAppointmentsPageQuery, VerticalMyAppointmentsPageQueryVariables>;
export const VerticalNewsFullListingPageDocument = gql`
    query verticalNewsFullListingPage($verticalSlug: String!, $pageNumber: Int) {
  verticalPage(verticalSlug: $verticalSlug, pageNumber: $pageNumber) {
    ... on VerticalPage {
      __typename
      meta {
        title
        desc
        fbAppId
        dataLayer
        pageType
        canonical
        taxonomyHierarchy {
          vertical
        }
      }
      header {
        title
        description
        standfirst
      }
      newsArticles {
        pagedArticles {
          total
          articles {
            headline
            summary
            url
            image {
              src
              alt
              sources {
                srcset
                sizes
              }
            }
            primaryTaxonomy {
              name
              url
            }
            updatedDate {
              rendered
              iso
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useVerticalNewsFullListingPageQuery__
 *
 * To run a query within a React component, call `useVerticalNewsFullListingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerticalNewsFullListingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerticalNewsFullListingPageQuery({
 *   variables: {
 *      verticalSlug: // value for 'verticalSlug'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useVerticalNewsFullListingPageQuery(baseOptions: Apollo.QueryHookOptions<VerticalNewsFullListingPageQuery, VerticalNewsFullListingPageQueryVariables> & ({ variables: VerticalNewsFullListingPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerticalNewsFullListingPageQuery, VerticalNewsFullListingPageQueryVariables>(VerticalNewsFullListingPageDocument, options);
      }
export function useVerticalNewsFullListingPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerticalNewsFullListingPageQuery, VerticalNewsFullListingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerticalNewsFullListingPageQuery, VerticalNewsFullListingPageQueryVariables>(VerticalNewsFullListingPageDocument, options);
        }
export function useVerticalNewsFullListingPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VerticalNewsFullListingPageQuery, VerticalNewsFullListingPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VerticalNewsFullListingPageQuery, VerticalNewsFullListingPageQueryVariables>(VerticalNewsFullListingPageDocument, options);
        }
export type VerticalNewsFullListingPageQueryHookResult = ReturnType<typeof useVerticalNewsFullListingPageQuery>;
export type VerticalNewsFullListingPageLazyQueryHookResult = ReturnType<typeof useVerticalNewsFullListingPageLazyQuery>;
export type VerticalNewsFullListingPageSuspenseQueryHookResult = ReturnType<typeof useVerticalNewsFullListingPageSuspenseQuery>;
export type VerticalNewsFullListingPageQueryResult = Apollo.QueryResult<VerticalNewsFullListingPageQuery, VerticalNewsFullListingPageQueryVariables>;
export const VerticalNewsPageDocument = gql`
    query verticalNewsPage($verticalSlug: String!) {
  verticalPage(verticalSlug: $verticalSlug) {
    ... on VerticalPage {
      __typename
      meta {
        title
        desc
        fbAppId
        dataLayer
        pageType
        canonical
        taxonomyHierarchy {
          vertical
        }
      }
      header {
        title
        description
        standfirst
      }
      latestNews {
        name
        articles {
          title
          imageWithSources {
            src
            alt
            sources {
              srcset
              sizes
            }
          }
          href
          dateInfo {
            rendered
            iso
          }
        }
      }
      newsCardsCollections {
        mainFeaturedArticle {
          heading
          summary
          date {
            rendered
            iso
          }
          url
          image {
            src
            alt
            sources {
              srcset
              sizes
            }
          }
        }
        mostReadArticles {
          title
          links {
            href
            text
          }
        }
        collections {
          taxonomy {
            name
            slug
          }
          featuredArticle {
            heading
            summary
            date {
              rendered
              iso
            }
            url
            image {
              src
              alt
              sources {
                srcset
                sizes
              }
            }
          }
          cards {
            heading
            date {
              rendered
              iso
            }
            url
            image {
              src
              alt
              sources {
                srcset
                sizes
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useVerticalNewsPageQuery__
 *
 * To run a query within a React component, call `useVerticalNewsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerticalNewsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerticalNewsPageQuery({
 *   variables: {
 *      verticalSlug: // value for 'verticalSlug'
 *   },
 * });
 */
export function useVerticalNewsPageQuery(baseOptions: Apollo.QueryHookOptions<VerticalNewsPageQuery, VerticalNewsPageQueryVariables> & ({ variables: VerticalNewsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerticalNewsPageQuery, VerticalNewsPageQueryVariables>(VerticalNewsPageDocument, options);
      }
export function useVerticalNewsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerticalNewsPageQuery, VerticalNewsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerticalNewsPageQuery, VerticalNewsPageQueryVariables>(VerticalNewsPageDocument, options);
        }
export function useVerticalNewsPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VerticalNewsPageQuery, VerticalNewsPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VerticalNewsPageQuery, VerticalNewsPageQueryVariables>(VerticalNewsPageDocument, options);
        }
export type VerticalNewsPageQueryHookResult = ReturnType<typeof useVerticalNewsPageQuery>;
export type VerticalNewsPageLazyQueryHookResult = ReturnType<typeof useVerticalNewsPageLazyQuery>;
export type VerticalNewsPageSuspenseQueryHookResult = ReturnType<typeof useVerticalNewsPageSuspenseQuery>;
export type VerticalNewsPageQueryResult = Apollo.QueryResult<VerticalNewsPageQuery, VerticalNewsPageQueryVariables>;
export const VerticalPensionSchemePageDocument = gql`
    query verticalPensionSchemePage($verticalSlug: String!) {
  verticalPage(verticalSlug: $verticalSlug) {
    ... on VerticalPage {
      __typename
      ...BaseVerticalFragment
      pensionScheme {
        subVerticalArticles {
          url
          title
          description
          image
        }
        promoUrls {
          url
          title
          description
          image
        }
        moreArticles {
          heading
          cards {
            url
            title
            description
            image
            updatedAt
          }
        }
      }
    }
  }
}
    ${BaseVerticalFragmentFragmentDoc}`;

/**
 * __useVerticalPensionSchemePageQuery__
 *
 * To run a query within a React component, call `useVerticalPensionSchemePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerticalPensionSchemePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerticalPensionSchemePageQuery({
 *   variables: {
 *      verticalSlug: // value for 'verticalSlug'
 *   },
 * });
 */
export function useVerticalPensionSchemePageQuery(baseOptions: Apollo.QueryHookOptions<VerticalPensionSchemePageQuery, VerticalPensionSchemePageQueryVariables> & ({ variables: VerticalPensionSchemePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerticalPensionSchemePageQuery, VerticalPensionSchemePageQueryVariables>(VerticalPensionSchemePageDocument, options);
      }
export function useVerticalPensionSchemePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerticalPensionSchemePageQuery, VerticalPensionSchemePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerticalPensionSchemePageQuery, VerticalPensionSchemePageQueryVariables>(VerticalPensionSchemePageDocument, options);
        }
export function useVerticalPensionSchemePageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VerticalPensionSchemePageQuery, VerticalPensionSchemePageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VerticalPensionSchemePageQuery, VerticalPensionSchemePageQueryVariables>(VerticalPensionSchemePageDocument, options);
        }
export type VerticalPensionSchemePageQueryHookResult = ReturnType<typeof useVerticalPensionSchemePageQuery>;
export type VerticalPensionSchemePageLazyQueryHookResult = ReturnType<typeof useVerticalPensionSchemePageLazyQuery>;
export type VerticalPensionSchemePageSuspenseQueryHookResult = ReturnType<typeof useVerticalPensionSchemePageSuspenseQuery>;
export type VerticalPensionSchemePageQueryResult = Apollo.QueryResult<VerticalPensionSchemePageQuery, VerticalPensionSchemePageQueryVariables>;
export const VerticalPolicyAndInsightPageDocument = gql`
    query verticalPolicyAndInsightPage($verticalSlug: String!) {
  verticalPage(verticalSlug: $verticalSlug) {
    ... on VerticalPage {
      __typename
      meta {
        title
        desc
        fbAppId
        dataLayer
        pageType
        canonical
        taxonomyHierarchy {
          vertical
        }
      }
      header {
        title
        description
        standfirst
      }
      policyAndInsightCategories {
        categories {
          name
          slug
        }
      }
      policyAndInsightCardsCollections {
        collections {
          taxonomy {
            name
            slug
          }
          cards {
            estimatedReadingTime
            heading
            summary
            publishedAt
            url
            image {
              src
              alt
              sources {
                srcset
                sizes
              }
            }
            title
            standfirst
            topicHeading {
              text
              icon
              category
            }
          }
        }
        hero {
          taxonomy {
            name
            slug
          }
          cards {
            image {
              src
              alt
            }
            title
            linkUrl
            standfirst
            ariaLabel
            buttonText
          }
        }
      }
    }
  }
}
    `;

/**
 * __useVerticalPolicyAndInsightPageQuery__
 *
 * To run a query within a React component, call `useVerticalPolicyAndInsightPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerticalPolicyAndInsightPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerticalPolicyAndInsightPageQuery({
 *   variables: {
 *      verticalSlug: // value for 'verticalSlug'
 *   },
 * });
 */
export function useVerticalPolicyAndInsightPageQuery(baseOptions: Apollo.QueryHookOptions<VerticalPolicyAndInsightPageQuery, VerticalPolicyAndInsightPageQueryVariables> & ({ variables: VerticalPolicyAndInsightPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerticalPolicyAndInsightPageQuery, VerticalPolicyAndInsightPageQueryVariables>(VerticalPolicyAndInsightPageDocument, options);
      }
export function useVerticalPolicyAndInsightPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerticalPolicyAndInsightPageQuery, VerticalPolicyAndInsightPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerticalPolicyAndInsightPageQuery, VerticalPolicyAndInsightPageQueryVariables>(VerticalPolicyAndInsightPageDocument, options);
        }
export function useVerticalPolicyAndInsightPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VerticalPolicyAndInsightPageQuery, VerticalPolicyAndInsightPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VerticalPolicyAndInsightPageQuery, VerticalPolicyAndInsightPageQueryVariables>(VerticalPolicyAndInsightPageDocument, options);
        }
export type VerticalPolicyAndInsightPageQueryHookResult = ReturnType<typeof useVerticalPolicyAndInsightPageQuery>;
export type VerticalPolicyAndInsightPageLazyQueryHookResult = ReturnType<typeof useVerticalPolicyAndInsightPageLazyQuery>;
export type VerticalPolicyAndInsightPageSuspenseQueryHookResult = ReturnType<typeof useVerticalPolicyAndInsightPageSuspenseQuery>;
export type VerticalPolicyAndInsightPageQueryResult = Apollo.QueryResult<VerticalPolicyAndInsightPageQuery, VerticalPolicyAndInsightPageQueryVariables>;
export const VerticalReviewsPageDocument = gql`
    query verticalReviewsPage($verticalSlug: String!) {
  verticalPage(verticalSlug: $verticalSlug) {
    ... on VerticalPage {
      __typename
      ...BaseVerticalFragment
      articleCards {
        cards {
          heading
          image {
            alt
            sources {
              srcset
              sizes
            }
            src
          }
          links {
            href
            text
          }
          viewAll {
            text
            href
          }
        }
        heading
      }
      latestNews {
        name
        articles {
          title
          href
          imageWithSources {
            src
            alt
            sources {
              srcset
              sizes
            }
          }
          dateInfo {
            rendered
          }
        }
      }
      optionalData {
        components {
          newsletterSignUpWithImage {
            source
            image {
              alt
              caption
              id
              src
              sources {
                srcset
                sizes
              }
            }
          }
          podcastComponentData {
            header
            title
            info
            iframeContent
            link {
              href
              text
            }
          }
          bannerSignUpComponentData {
            image {
              src
              sources {
                srcset
                media
                type
                sizes
              }
            }
            title
            text
            linkText
            linkUrl
            backgroundColour
            facebookUrl
            twitterUrl
            buttonType
          }
        }
      }
    }
  }
}
    ${BaseVerticalFragmentFragmentDoc}`;

/**
 * __useVerticalReviewsPageQuery__
 *
 * To run a query within a React component, call `useVerticalReviewsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerticalReviewsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerticalReviewsPageQuery({
 *   variables: {
 *      verticalSlug: // value for 'verticalSlug'
 *   },
 * });
 */
export function useVerticalReviewsPageQuery(baseOptions: Apollo.QueryHookOptions<VerticalReviewsPageQuery, VerticalReviewsPageQueryVariables> & ({ variables: VerticalReviewsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerticalReviewsPageQuery, VerticalReviewsPageQueryVariables>(VerticalReviewsPageDocument, options);
      }
export function useVerticalReviewsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerticalReviewsPageQuery, VerticalReviewsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerticalReviewsPageQuery, VerticalReviewsPageQueryVariables>(VerticalReviewsPageDocument, options);
        }
export function useVerticalReviewsPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VerticalReviewsPageQuery, VerticalReviewsPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VerticalReviewsPageQuery, VerticalReviewsPageQueryVariables>(VerticalReviewsPageDocument, options);
        }
export type VerticalReviewsPageQueryHookResult = ReturnType<typeof useVerticalReviewsPageQuery>;
export type VerticalReviewsPageLazyQueryHookResult = ReturnType<typeof useVerticalReviewsPageLazyQuery>;
export type VerticalReviewsPageSuspenseQueryHookResult = ReturnType<typeof useVerticalReviewsPageSuspenseQuery>;
export type VerticalReviewsPageQueryResult = Apollo.QueryResult<VerticalReviewsPageQuery, VerticalReviewsPageQueryVariables>;
export const VerticalSitemapPageDocument = gql`
    query verticalSitemapPage($verticalSlug: String!) {
  verticalPage(verticalSlug: $verticalSlug) {
    ... on VerticalPage {
      __typename
      ...BaseVerticalFragment
      sitemapMenu {
        name
        items {
          label
          url
          children {
            label
            url
            children {
              label
              url
            }
          }
        }
      }
    }
  }
}
    ${BaseVerticalFragmentFragmentDoc}`;

/**
 * __useVerticalSitemapPageQuery__
 *
 * To run a query within a React component, call `useVerticalSitemapPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerticalSitemapPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerticalSitemapPageQuery({
 *   variables: {
 *      verticalSlug: // value for 'verticalSlug'
 *   },
 * });
 */
export function useVerticalSitemapPageQuery(baseOptions: Apollo.QueryHookOptions<VerticalSitemapPageQuery, VerticalSitemapPageQueryVariables> & ({ variables: VerticalSitemapPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerticalSitemapPageQuery, VerticalSitemapPageQueryVariables>(VerticalSitemapPageDocument, options);
      }
export function useVerticalSitemapPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerticalSitemapPageQuery, VerticalSitemapPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerticalSitemapPageQuery, VerticalSitemapPageQueryVariables>(VerticalSitemapPageDocument, options);
        }
export function useVerticalSitemapPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VerticalSitemapPageQuery, VerticalSitemapPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VerticalSitemapPageQuery, VerticalSitemapPageQueryVariables>(VerticalSitemapPageDocument, options);
        }
export type VerticalSitemapPageQueryHookResult = ReturnType<typeof useVerticalSitemapPageQuery>;
export type VerticalSitemapPageLazyQueryHookResult = ReturnType<typeof useVerticalSitemapPageLazyQuery>;
export type VerticalSitemapPageSuspenseQueryHookResult = ReturnType<typeof useVerticalSitemapPageSuspenseQuery>;
export type VerticalSitemapPageQueryResult = Apollo.QueryResult<VerticalSitemapPageQuery, VerticalSitemapPageQueryVariables>;
export const SavedItemsDocument = gql`
    query savedItems {
  savedItems {
    categorySlug
    products {
      id
      saveId
    }
  }
}
    `;

/**
 * __useSavedItemsQuery__
 *
 * To run a query within a React component, call `useSavedItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavedItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSavedItemsQuery(baseOptions?: Apollo.QueryHookOptions<SavedItemsQuery, SavedItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SavedItemsQuery, SavedItemsQueryVariables>(SavedItemsDocument, options);
      }
export function useSavedItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SavedItemsQuery, SavedItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SavedItemsQuery, SavedItemsQueryVariables>(SavedItemsDocument, options);
        }
export function useSavedItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SavedItemsQuery, SavedItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SavedItemsQuery, SavedItemsQueryVariables>(SavedItemsDocument, options);
        }
export type SavedItemsQueryHookResult = ReturnType<typeof useSavedItemsQuery>;
export type SavedItemsLazyQueryHookResult = ReturnType<typeof useSavedItemsLazyQuery>;
export type SavedItemsSuspenseQueryHookResult = ReturnType<typeof useSavedItemsSuspenseQuery>;
export type SavedItemsQueryResult = Apollo.QueryResult<SavedItemsQuery, SavedItemsQueryVariables>;
export const CreateCaseInSfDocument = gql`
    mutation createCaseInSF($formRequest: FormRequest!) {
  createCaseInSF(formRequest: $formRequest) {
    status
  }
}
    `;
export type CreateCaseInSfMutationFn = Apollo.MutationFunction<CreateCaseInSfMutation, CreateCaseInSfMutationVariables>;

/**
 * __useCreateCaseInSfMutation__
 *
 * To run a mutation, you first call `useCreateCaseInSfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaseInSfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaseInSfMutation, { data, loading, error }] = useCreateCaseInSfMutation({
 *   variables: {
 *      formRequest: // value for 'formRequest'
 *   },
 * });
 */
export function useCreateCaseInSfMutation(baseOptions?: Apollo.MutationHookOptions<CreateCaseInSfMutation, CreateCaseInSfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCaseInSfMutation, CreateCaseInSfMutationVariables>(CreateCaseInSfDocument, options);
      }
export type CreateCaseInSfMutationHookResult = ReturnType<typeof useCreateCaseInSfMutation>;
export type CreateCaseInSfMutationResult = Apollo.MutationResult<CreateCaseInSfMutation>;
export type CreateCaseInSfMutationOptions = Apollo.BaseMutationOptions<CreateCaseInSfMutation, CreateCaseInSfMutationVariables>;
export const IsMigratedMemberDocument = gql`
    query isMigratedMember($email: String!) {
  isMigratedMember(email: $email) {
    status
    response
  }
}
    `;

/**
 * __useIsMigratedMemberQuery__
 *
 * To run a query within a React component, call `useIsMigratedMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsMigratedMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsMigratedMemberQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useIsMigratedMemberQuery(baseOptions: Apollo.QueryHookOptions<IsMigratedMemberQuery, IsMigratedMemberQueryVariables> & ({ variables: IsMigratedMemberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsMigratedMemberQuery, IsMigratedMemberQueryVariables>(IsMigratedMemberDocument, options);
      }
export function useIsMigratedMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsMigratedMemberQuery, IsMigratedMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsMigratedMemberQuery, IsMigratedMemberQueryVariables>(IsMigratedMemberDocument, options);
        }
export function useIsMigratedMemberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsMigratedMemberQuery, IsMigratedMemberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsMigratedMemberQuery, IsMigratedMemberQueryVariables>(IsMigratedMemberDocument, options);
        }
export type IsMigratedMemberQueryHookResult = ReturnType<typeof useIsMigratedMemberQuery>;
export type IsMigratedMemberLazyQueryHookResult = ReturnType<typeof useIsMigratedMemberLazyQuery>;
export type IsMigratedMemberSuspenseQueryHookResult = ReturnType<typeof useIsMigratedMemberSuspenseQuery>;
export type IsMigratedMemberQueryResult = Apollo.QueryResult<IsMigratedMemberQuery, IsMigratedMemberQueryVariables>;
export const GamPersonalisationInfoDocument = gql`
    query GamPersonalisationInfo {
  personalisationInfo {
    newsletterSignups
    newsletterRecommendation
  }
}
    `;

/**
 * __useGamPersonalisationInfoQuery__
 *
 * To run a query within a React component, call `useGamPersonalisationInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGamPersonalisationInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGamPersonalisationInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGamPersonalisationInfoQuery(baseOptions?: Apollo.QueryHookOptions<GamPersonalisationInfoQuery, GamPersonalisationInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GamPersonalisationInfoQuery, GamPersonalisationInfoQueryVariables>(GamPersonalisationInfoDocument, options);
      }
export function useGamPersonalisationInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GamPersonalisationInfoQuery, GamPersonalisationInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GamPersonalisationInfoQuery, GamPersonalisationInfoQueryVariables>(GamPersonalisationInfoDocument, options);
        }
export function useGamPersonalisationInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GamPersonalisationInfoQuery, GamPersonalisationInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GamPersonalisationInfoQuery, GamPersonalisationInfoQueryVariables>(GamPersonalisationInfoDocument, options);
        }
export type GamPersonalisationInfoQueryHookResult = ReturnType<typeof useGamPersonalisationInfoQuery>;
export type GamPersonalisationInfoLazyQueryHookResult = ReturnType<typeof useGamPersonalisationInfoLazyQuery>;
export type GamPersonalisationInfoSuspenseQueryHookResult = ReturnType<typeof useGamPersonalisationInfoSuspenseQuery>;
export type GamPersonalisationInfoQueryResult = Apollo.QueryResult<GamPersonalisationInfoQuery, GamPersonalisationInfoQueryVariables>;
export const CreateGardeningCaseInSfDocument = gql`
    mutation createGardeningCaseInSF($formRequest: GardeningFormRequest!) {
  createGardeningCaseInSF(formRequest: $formRequest) {
    status
    caseId
  }
}
    `;
export type CreateGardeningCaseInSfMutationFn = Apollo.MutationFunction<CreateGardeningCaseInSfMutation, CreateGardeningCaseInSfMutationVariables>;

/**
 * __useCreateGardeningCaseInSfMutation__
 *
 * To run a mutation, you first call `useCreateGardeningCaseInSfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGardeningCaseInSfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGardeningCaseInSfMutation, { data, loading, error }] = useCreateGardeningCaseInSfMutation({
 *   variables: {
 *      formRequest: // value for 'formRequest'
 *   },
 * });
 */
export function useCreateGardeningCaseInSfMutation(baseOptions?: Apollo.MutationHookOptions<CreateGardeningCaseInSfMutation, CreateGardeningCaseInSfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGardeningCaseInSfMutation, CreateGardeningCaseInSfMutationVariables>(CreateGardeningCaseInSfDocument, options);
      }
export type CreateGardeningCaseInSfMutationHookResult = ReturnType<typeof useCreateGardeningCaseInSfMutation>;
export type CreateGardeningCaseInSfMutationResult = Apollo.MutationResult<CreateGardeningCaseInSfMutation>;
export type CreateGardeningCaseInSfMutationOptions = Apollo.BaseMutationOptions<CreateGardeningCaseInSfMutation, CreateGardeningCaseInSfMutationVariables>;
export const RecentlyViewedDocument = gql`
    query recentlyViewed {
  signupCompletePage {
    recentlyViewed {
      content {
        ... on Article {
          __typename
          id
          glide_id
          url
          path
          headline
          short_headline
          standfirst
          short_standfirst
          published_at
          updated_at
          article_type {
            name
            id
          }
          type
          promo_image_url
        }
        ... on Product {
          __typename
          imageUrl
          productUrl
          hasRetailers
          badges
          businessKey
          model
          manufacturer {
            name
          }
          category {
            slug
          }
          slug
          price {
            formatted
          }
          pros
          cons
          testScore {
            overallScore
            textVariation
          }
        }
      }
    }
  }
}
    `;

/**
 * __useRecentlyViewedQuery__
 *
 * To run a query within a React component, call `useRecentlyViewedQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentlyViewedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentlyViewedQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecentlyViewedQuery(baseOptions?: Apollo.QueryHookOptions<RecentlyViewedQuery, RecentlyViewedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentlyViewedQuery, RecentlyViewedQueryVariables>(RecentlyViewedDocument, options);
      }
export function useRecentlyViewedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentlyViewedQuery, RecentlyViewedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentlyViewedQuery, RecentlyViewedQueryVariables>(RecentlyViewedDocument, options);
        }
export function useRecentlyViewedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecentlyViewedQuery, RecentlyViewedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecentlyViewedQuery, RecentlyViewedQueryVariables>(RecentlyViewedDocument, options);
        }
export type RecentlyViewedQueryHookResult = ReturnType<typeof useRecentlyViewedQuery>;
export type RecentlyViewedLazyQueryHookResult = ReturnType<typeof useRecentlyViewedLazyQuery>;
export type RecentlyViewedSuspenseQueryHookResult = ReturnType<typeof useRecentlyViewedSuspenseQuery>;
export type RecentlyViewedQueryResult = Apollo.QueryResult<RecentlyViewedQuery, RecentlyViewedQueryVariables>;
export const RecommendedForYouDocument = gql`
    query recommendedForYou {
  homePage {
    recommendations {
      models {
        model
        content {
          __typename
          ... on RecommendedArticle {
            type
            id
            href
            title
            subheading
            image
          }
        }
      }
    }
  }
}
    `;

/**
 * __useRecommendedForYouQuery__
 *
 * To run a query within a React component, call `useRecommendedForYouQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendedForYouQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendedForYouQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecommendedForYouQuery(baseOptions?: Apollo.QueryHookOptions<RecommendedForYouQuery, RecommendedForYouQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecommendedForYouQuery, RecommendedForYouQueryVariables>(RecommendedForYouDocument, options);
      }
export function useRecommendedForYouLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecommendedForYouQuery, RecommendedForYouQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecommendedForYouQuery, RecommendedForYouQueryVariables>(RecommendedForYouDocument, options);
        }
export function useRecommendedForYouSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecommendedForYouQuery, RecommendedForYouQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecommendedForYouQuery, RecommendedForYouQueryVariables>(RecommendedForYouDocument, options);
        }
export type RecommendedForYouQueryHookResult = ReturnType<typeof useRecommendedForYouQuery>;
export type RecommendedForYouLazyQueryHookResult = ReturnType<typeof useRecommendedForYouLazyQuery>;
export type RecommendedForYouSuspenseQueryHookResult = ReturnType<typeof useRecommendedForYouSuspenseQuery>;
export type RecommendedForYouQueryResult = Apollo.QueryResult<RecommendedForYouQuery, RecommendedForYouQueryVariables>;
export const ResubscribeBannerPersonalisationInfoDocument = gql`
    query ResubscribeBannerPersonalisationInfo {
  personalisationInfo {
    enableWinbackOffer
  }
}
    `;

/**
 * __useResubscribeBannerPersonalisationInfoQuery__
 *
 * To run a query within a React component, call `useResubscribeBannerPersonalisationInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useResubscribeBannerPersonalisationInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResubscribeBannerPersonalisationInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useResubscribeBannerPersonalisationInfoQuery(baseOptions?: Apollo.QueryHookOptions<ResubscribeBannerPersonalisationInfoQuery, ResubscribeBannerPersonalisationInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResubscribeBannerPersonalisationInfoQuery, ResubscribeBannerPersonalisationInfoQueryVariables>(ResubscribeBannerPersonalisationInfoDocument, options);
      }
export function useResubscribeBannerPersonalisationInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResubscribeBannerPersonalisationInfoQuery, ResubscribeBannerPersonalisationInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResubscribeBannerPersonalisationInfoQuery, ResubscribeBannerPersonalisationInfoQueryVariables>(ResubscribeBannerPersonalisationInfoDocument, options);
        }
export function useResubscribeBannerPersonalisationInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResubscribeBannerPersonalisationInfoQuery, ResubscribeBannerPersonalisationInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ResubscribeBannerPersonalisationInfoQuery, ResubscribeBannerPersonalisationInfoQueryVariables>(ResubscribeBannerPersonalisationInfoDocument, options);
        }
export type ResubscribeBannerPersonalisationInfoQueryHookResult = ReturnType<typeof useResubscribeBannerPersonalisationInfoQuery>;
export type ResubscribeBannerPersonalisationInfoLazyQueryHookResult = ReturnType<typeof useResubscribeBannerPersonalisationInfoLazyQuery>;
export type ResubscribeBannerPersonalisationInfoSuspenseQueryHookResult = ReturnType<typeof useResubscribeBannerPersonalisationInfoSuspenseQuery>;
export type ResubscribeBannerPersonalisationInfoQueryResult = Apollo.QueryResult<ResubscribeBannerPersonalisationInfoQuery, ResubscribeBannerPersonalisationInfoQueryVariables>;
export const CreateTechSupportCaseInSfDocument = gql`
    mutation createTechSupportCaseInSF($formRequest: TechSupportFormRequest!) {
  createTechSupportCaseInSF(formRequest: $formRequest) {
    status
    caseId
  }
}
    `;
export type CreateTechSupportCaseInSfMutationFn = Apollo.MutationFunction<CreateTechSupportCaseInSfMutation, CreateTechSupportCaseInSfMutationVariables>;

/**
 * __useCreateTechSupportCaseInSfMutation__
 *
 * To run a mutation, you first call `useCreateTechSupportCaseInSfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTechSupportCaseInSfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTechSupportCaseInSfMutation, { data, loading, error }] = useCreateTechSupportCaseInSfMutation({
 *   variables: {
 *      formRequest: // value for 'formRequest'
 *   },
 * });
 */
export function useCreateTechSupportCaseInSfMutation(baseOptions?: Apollo.MutationHookOptions<CreateTechSupportCaseInSfMutation, CreateTechSupportCaseInSfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTechSupportCaseInSfMutation, CreateTechSupportCaseInSfMutationVariables>(CreateTechSupportCaseInSfDocument, options);
      }
export type CreateTechSupportCaseInSfMutationHookResult = ReturnType<typeof useCreateTechSupportCaseInSfMutation>;
export type CreateTechSupportCaseInSfMutationResult = Apollo.MutationResult<CreateTechSupportCaseInSfMutation>;
export type CreateTechSupportCaseInSfMutationOptions = Apollo.BaseMutationOptions<CreateTechSupportCaseInSfMutation, CreateTechSupportCaseInSfMutationVariables>;
export const AddSavedItemDocument = gql`
    mutation addSavedItem($item: SavedItemDetails!) {
  addSavedItem(item: $item) {
    ... on SavedItemSuccess {
      success
    }
    ... on SavedItemError {
      success
      errorResponse
    }
  }
}
    `;
export type AddSavedItemMutationFn = Apollo.MutationFunction<AddSavedItemMutation, AddSavedItemMutationVariables>;

/**
 * __useAddSavedItemMutation__
 *
 * To run a mutation, you first call `useAddSavedItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSavedItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSavedItemMutation, { data, loading, error }] = useAddSavedItemMutation({
 *   variables: {
 *      item: // value for 'item'
 *   },
 * });
 */
export function useAddSavedItemMutation(baseOptions?: Apollo.MutationHookOptions<AddSavedItemMutation, AddSavedItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSavedItemMutation, AddSavedItemMutationVariables>(AddSavedItemDocument, options);
      }
export type AddSavedItemMutationHookResult = ReturnType<typeof useAddSavedItemMutation>;
export type AddSavedItemMutationResult = Apollo.MutationResult<AddSavedItemMutation>;
export type AddSavedItemMutationOptions = Apollo.BaseMutationOptions<AddSavedItemMutation, AddSavedItemMutationVariables>;
export const RemoveSavedItemDocument = gql`
    mutation removeSavedItem($itemId: String!) {
  removeSavedItem(itemId: $itemId) {
    ... on SavedItemSuccess {
      success
    }
    ... on SavedItemError {
      success
      errorResponse
    }
  }
}
    `;
export type RemoveSavedItemMutationFn = Apollo.MutationFunction<RemoveSavedItemMutation, RemoveSavedItemMutationVariables>;

/**
 * __useRemoveSavedItemMutation__
 *
 * To run a mutation, you first call `useRemoveSavedItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSavedItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSavedItemMutation, { data, loading, error }] = useRemoveSavedItemMutation({
 *   variables: {
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useRemoveSavedItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSavedItemMutation, RemoveSavedItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSavedItemMutation, RemoveSavedItemMutationVariables>(RemoveSavedItemDocument, options);
      }
export type RemoveSavedItemMutationHookResult = ReturnType<typeof useRemoveSavedItemMutation>;
export type RemoveSavedItemMutationResult = Apollo.MutationResult<RemoveSavedItemMutation>;
export type RemoveSavedItemMutationOptions = Apollo.BaseMutationOptions<RemoveSavedItemMutation, RemoveSavedItemMutationVariables>;